import { UnknownError, NetworkError, ConnectionAbortedError, TimeoutError, InvalidSdkConfigurationError, InvalidRegionOrHostError, InvalidRegionError, InvalidHostError } from "@smash-sdk/core";
import { GenericError as ListTransferFilesInternalGenericError } from "./types/ListTransferFilesInternal/ListTransferFilesInternalError";
import { InvalidParameterError as ListTransferFilesInternalInvalidParameterError } from "./types/ListTransferFilesInternal/ListTransferFilesInternalError";
import { UnauthorizedError as ListTransferFilesInternalUnauthorizedError } from "./types/ListTransferFilesInternal/ListTransferFilesInternalError";
import { ForbiddenError as ListTransferFilesInternalForbiddenError } from "./types/ListTransferFilesInternal/ListTransferFilesInternalError";
import { NotFoundError as ListTransferFilesInternalNotFoundError } from "./types/ListTransferFilesInternal/ListTransferFilesInternalError";
import { InternalServerError as ListTransferFilesInternalInternalServerError } from "./types/ListTransferFilesInternal/ListTransferFilesInternalError";
import { BadGatewayError as ListTransferFilesInternalBadGatewayError } from "./types/ListTransferFilesInternal/ListTransferFilesInternalError";
import { GatewayTimeoutError as ListTransferFilesInternalGatewayTimeoutError } from "./types/ListTransferFilesInternal/ListTransferFilesInternalError";
import { GenericError as ListTransferFilesPreviewGenericError } from "./types/ListTransferFilesPreview/ListTransferFilesPreviewError";
import { InvalidParameterError as ListTransferFilesPreviewInvalidParameterError } from "./types/ListTransferFilesPreview/ListTransferFilesPreviewError";
import { UnauthorizedError as ListTransferFilesPreviewUnauthorizedError } from "./types/ListTransferFilesPreview/ListTransferFilesPreviewError";
import { PasswordDoesNotMatchError as ListTransferFilesPreviewPasswordDoesNotMatchError } from "./types/ListTransferFilesPreview/ListTransferFilesPreviewError";
import { OwnerUsageExceededError as ListTransferFilesPreviewOwnerUsageExceededError } from "./types/ListTransferFilesPreview/ListTransferFilesPreviewError";
import { AccessorUsageExceededError as ListTransferFilesPreviewAccessorUsageExceededError } from "./types/ListTransferFilesPreview/ListTransferFilesPreviewError";
import { ForbiddenError as ListTransferFilesPreviewForbiddenError } from "./types/ListTransferFilesPreview/ListTransferFilesPreviewError";
import { NotFoundError as ListTransferFilesPreviewNotFoundError } from "./types/ListTransferFilesPreview/ListTransferFilesPreviewError";
import { InternalServerError as ListTransferFilesPreviewInternalServerError } from "./types/ListTransferFilesPreview/ListTransferFilesPreviewError";
import { BadGatewayError as ListTransferFilesPreviewBadGatewayError } from "./types/ListTransferFilesPreview/ListTransferFilesPreviewError";
import { GatewayTimeoutError as ListTransferFilesPreviewGatewayTimeoutError } from "./types/ListTransferFilesPreview/ListTransferFilesPreviewError";
import { GenericError as ListTransfersGenericError } from "./types/ListTransfers/ListTransfersError";
import { InvalidParameterError as ListTransfersInvalidParameterError } from "./types/ListTransfers/ListTransfersError";
import { UnauthorizedError as ListTransfersUnauthorizedError } from "./types/ListTransfers/ListTransfersError";
import { ForbiddenError as ListTransfersForbiddenError } from "./types/ListTransfers/ListTransfersError";
import { NotFoundError as ListTransfersNotFoundError } from "./types/ListTransfers/ListTransfersError";
import { InternalServerError as ListTransfersInternalServerError } from "./types/ListTransfers/ListTransfersError";
import { BadGatewayError as ListTransfersBadGatewayError } from "./types/ListTransfers/ListTransfersError";
import { GatewayTimeoutError as ListTransfersGatewayTimeoutError } from "./types/ListTransfers/ListTransfersError";
import { GenericError as ListUserDropboxesGenericError } from "./types/ListUserDropboxes/ListUserDropboxesError";
import { InvalidParameterError as ListUserDropboxesInvalidParameterError } from "./types/ListUserDropboxes/ListUserDropboxesError";
import { UnauthorizedError as ListUserDropboxesUnauthorizedError } from "./types/ListUserDropboxes/ListUserDropboxesError";
import { ForbiddenError as ListUserDropboxesForbiddenError } from "./types/ListUserDropboxes/ListUserDropboxesError";
import { InternalServerError as ListUserDropboxesInternalServerError } from "./types/ListUserDropboxes/ListUserDropboxesError";
import { BadGatewayError as ListUserDropboxesBadGatewayError } from "./types/ListUserDropboxes/ListUserDropboxesError";
import { GatewayTimeoutError as ListUserDropboxesGatewayTimeoutError } from "./types/ListUserDropboxes/ListUserDropboxesError";
import { GenericError as ListUserReceiptFilesGenericError } from "./types/ListUserReceiptFiles/ListUserReceiptFilesError";
import { InvalidParameterError as ListUserReceiptFilesInvalidParameterError } from "./types/ListUserReceiptFiles/ListUserReceiptFilesError";
import { UnauthorizedError as ListUserReceiptFilesUnauthorizedError } from "./types/ListUserReceiptFiles/ListUserReceiptFilesError";
import { ForbiddenError as ListUserReceiptFilesForbiddenError } from "./types/ListUserReceiptFiles/ListUserReceiptFilesError";
import { NotFoundError as ListUserReceiptFilesNotFoundError } from "./types/ListUserReceiptFiles/ListUserReceiptFilesError";
import { InternalServerError as ListUserReceiptFilesInternalServerError } from "./types/ListUserReceiptFiles/ListUserReceiptFilesError";
import { BadGatewayError as ListUserReceiptFilesBadGatewayError } from "./types/ListUserReceiptFiles/ListUserReceiptFilesError";
import { GatewayTimeoutError as ListUserReceiptFilesGatewayTimeoutError } from "./types/ListUserReceiptFiles/ListUserReceiptFilesError";
import { GenericError as ListUserReceiptsGenericError } from "./types/ListUserReceipts/ListUserReceiptsError";
import { InvalidParameterError as ListUserReceiptsInvalidParameterError } from "./types/ListUserReceipts/ListUserReceiptsError";
import { UnauthorizedError as ListUserReceiptsUnauthorizedError } from "./types/ListUserReceipts/ListUserReceiptsError";
import { ForbiddenError as ListUserReceiptsForbiddenError } from "./types/ListUserReceipts/ListUserReceiptsError";
import { InternalServerError as ListUserReceiptsInternalServerError } from "./types/ListUserReceipts/ListUserReceiptsError";
import { BadGatewayError as ListUserReceiptsBadGatewayError } from "./types/ListUserReceipts/ListUserReceiptsError";
import { GatewayTimeoutError as ListUserReceiptsGatewayTimeoutError } from "./types/ListUserReceipts/ListUserReceiptsError";
import { GenericError as ListUserTransferEventsGenericError } from "./types/ListUserTransferEvents/ListUserTransferEventsError";
import { InvalidParameterError as ListUserTransferEventsInvalidParameterError } from "./types/ListUserTransferEvents/ListUserTransferEventsError";
import { UnauthorizedError as ListUserTransferEventsUnauthorizedError } from "./types/ListUserTransferEvents/ListUserTransferEventsError";
import { ForbiddenError as ListUserTransferEventsForbiddenError } from "./types/ListUserTransferEvents/ListUserTransferEventsError";
import { NotFoundError as ListUserTransferEventsNotFoundError } from "./types/ListUserTransferEvents/ListUserTransferEventsError";
import { InternalServerError as ListUserTransferEventsInternalServerError } from "./types/ListUserTransferEvents/ListUserTransferEventsError";
import { BadGatewayError as ListUserTransferEventsBadGatewayError } from "./types/ListUserTransferEvents/ListUserTransferEventsError";
import { GatewayTimeoutError as ListUserTransferEventsGatewayTimeoutError } from "./types/ListUserTransferEvents/ListUserTransferEventsError";
import { GenericError as ListUserTransferFilesGenericError } from "./types/ListUserTransferFiles/ListUserTransferFilesError";
import { InvalidParameterError as ListUserTransferFilesInvalidParameterError } from "./types/ListUserTransferFiles/ListUserTransferFilesError";
import { UnauthorizedError as ListUserTransferFilesUnauthorizedError } from "./types/ListUserTransferFiles/ListUserTransferFilesError";
import { ForbiddenError as ListUserTransferFilesForbiddenError } from "./types/ListUserTransferFiles/ListUserTransferFilesError";
import { NotFoundError as ListUserTransferFilesNotFoundError } from "./types/ListUserTransferFiles/ListUserTransferFilesError";
import { InternalServerError as ListUserTransferFilesInternalServerError } from "./types/ListUserTransferFiles/ListUserTransferFilesError";
import { BadGatewayError as ListUserTransferFilesBadGatewayError } from "./types/ListUserTransferFiles/ListUserTransferFilesError";
import { GatewayTimeoutError as ListUserTransferFilesGatewayTimeoutError } from "./types/ListUserTransferFiles/ListUserTransferFilesError";
import { GenericError as ListUserTransfersGenericError } from "./types/ListUserTransfers/ListUserTransfersError";
import { InvalidParameterError as ListUserTransfersInvalidParameterError } from "./types/ListUserTransfers/ListUserTransfersError";
import { UnauthorizedError as ListUserTransfersUnauthorizedError } from "./types/ListUserTransfers/ListUserTransfersError";
import { ForbiddenError as ListUserTransfersForbiddenError } from "./types/ListUserTransfers/ListUserTransfersError";
import { NotFoundError as ListUserTransfersNotFoundError } from "./types/ListUserTransfers/ListUserTransfersError";
import { InternalServerError as ListUserTransfersInternalServerError } from "./types/ListUserTransfers/ListUserTransfersError";
import { BadGatewayError as ListUserTransfersBadGatewayError } from "./types/ListUserTransfers/ListUserTransfersError";
import { GatewayTimeoutError as ListUserTransfersGatewayTimeoutError } from "./types/ListUserTransfers/ListUserTransfersError";
import { GenericError as ListYearEventsGenericError } from "./types/ListYearEvents/ListYearEventsError";
import { InvalidParameterError as ListYearEventsInvalidParameterError } from "./types/ListYearEvents/ListYearEventsError";
import { UnauthorizedError as ListYearEventsUnauthorizedError } from "./types/ListYearEvents/ListYearEventsError";
import { ForbiddenError as ListYearEventsForbiddenError } from "./types/ListYearEvents/ListYearEventsError";
import { InternalServerError as ListYearEventsInternalServerError } from "./types/ListYearEvents/ListYearEventsError";
import { BadGatewayError as ListYearEventsBadGatewayError } from "./types/ListYearEvents/ListYearEventsError";
import { GatewayTimeoutError as ListYearEventsGatewayTimeoutError } from "./types/ListYearEvents/ListYearEventsError";
import { GenericError as ListYearFilesGenericError } from "./types/ListYearFiles/ListYearFilesError";
import { InvalidParameterError as ListYearFilesInvalidParameterError } from "./types/ListYearFiles/ListYearFilesError";
import { UnauthorizedError as ListYearFilesUnauthorizedError } from "./types/ListYearFiles/ListYearFilesError";
import { ForbiddenError as ListYearFilesForbiddenError } from "./types/ListYearFiles/ListYearFilesError";
import { InternalServerError as ListYearFilesInternalServerError } from "./types/ListYearFiles/ListYearFilesError";
import { BadGatewayError as ListYearFilesBadGatewayError } from "./types/ListYearFiles/ListYearFilesError";
import { GatewayTimeoutError as ListYearFilesGatewayTimeoutError } from "./types/ListYearFiles/ListYearFilesError";
import { GenericError as ListYearTransfersGenericError } from "./types/ListYearTransfers/ListYearTransfersError";
import { InvalidParameterError as ListYearTransfersInvalidParameterError } from "./types/ListYearTransfers/ListYearTransfersError";
import { UnauthorizedError as ListYearTransfersUnauthorizedError } from "./types/ListYearTransfers/ListYearTransfersError";
import { ForbiddenError as ListYearTransfersForbiddenError } from "./types/ListYearTransfers/ListYearTransfersError";
import { InternalServerError as ListYearTransfersInternalServerError } from "./types/ListYearTransfers/ListYearTransfersError";
import { BadGatewayError as ListYearTransfersBadGatewayError } from "./types/ListYearTransfers/ListYearTransfersError";
import { GatewayTimeoutError as ListYearTransfersGatewayTimeoutError } from "./types/ListYearTransfers/ListYearTransfersError";
import { GenericError as LockTransferGenericError } from "./types/LockTransfer/LockTransferError";
import { InvalidParameterError as LockTransferInvalidParameterError } from "./types/LockTransfer/LockTransferError";
import { UnauthorizedError as LockTransferUnauthorizedError } from "./types/LockTransfer/LockTransferError";
import { TransferAlreadyLockedError as LockTransferTransferAlreadyLockedError } from "./types/LockTransfer/LockTransferError";
import { TransferIsDirtyError as LockTransferTransferIsDirtyError } from "./types/LockTransfer/LockTransferError";
import { TransferIsInQueueError as LockTransferTransferIsInQueueError } from "./types/LockTransfer/LockTransferError";
import { ForbiddenError as LockTransferForbiddenError } from "./types/LockTransfer/LockTransferError";
import { NotFoundError as LockTransferNotFoundError } from "./types/LockTransfer/LockTransferError";
import { InternalServerError as LockTransferInternalServerError } from "./types/LockTransfer/LockTransferError";
import { BadGatewayError as LockTransferBadGatewayError } from "./types/LockTransfer/LockTransferError";
import { GatewayTimeoutError as LockTransferGatewayTimeoutError } from "./types/LockTransfer/LockTransferError";
import { GenericError as UpdateDropboxGenericError } from "./types/UpdateDropbox/UpdateDropboxError";
import { InvalidParameterError as UpdateDropboxInvalidParameterError } from "./types/UpdateDropbox/UpdateDropboxError";
import { UnauthorizedError as UpdateDropboxUnauthorizedError } from "./types/UpdateDropbox/UpdateDropboxError";
import { ForbiddenError as UpdateDropboxForbiddenError } from "./types/UpdateDropbox/UpdateDropboxError";
import { NotFoundError as UpdateDropboxNotFoundError } from "./types/UpdateDropbox/UpdateDropboxError";
import { InternalServerError as UpdateDropboxInternalServerError } from "./types/UpdateDropbox/UpdateDropboxError";
import { BadGatewayError as UpdateDropboxBadGatewayError } from "./types/UpdateDropbox/UpdateDropboxError";
import { GatewayTimeoutError as UpdateDropboxGatewayTimeoutError } from "./types/UpdateDropbox/UpdateDropboxError";
import { GenericError as UpdateManualReviewGenericError } from "./types/UpdateManualReview/UpdateManualReviewError";
import { InvalidParameterError as UpdateManualReviewInvalidParameterError } from "./types/UpdateManualReview/UpdateManualReviewError";
import { UnauthorizedError as UpdateManualReviewUnauthorizedError } from "./types/UpdateManualReview/UpdateManualReviewError";
import { ForbiddenError as UpdateManualReviewForbiddenError } from "./types/UpdateManualReview/UpdateManualReviewError";
import { NotFoundError as UpdateManualReviewNotFoundError } from "./types/UpdateManualReview/UpdateManualReviewError";
import { InternalServerError as UpdateManualReviewInternalServerError } from "./types/UpdateManualReview/UpdateManualReviewError";
import { BadGatewayError as UpdateManualReviewBadGatewayError } from "./types/UpdateManualReview/UpdateManualReviewError";
import { GatewayTimeoutError as UpdateManualReviewGatewayTimeoutError } from "./types/UpdateManualReview/UpdateManualReviewError";
import { GenericError as UpdateTeamDropboxGenericError } from "./types/UpdateTeamDropbox/UpdateTeamDropboxError";
import { InvalidParameterError as UpdateTeamDropboxInvalidParameterError } from "./types/UpdateTeamDropbox/UpdateTeamDropboxError";
import { UnauthorizedError as UpdateTeamDropboxUnauthorizedError } from "./types/UpdateTeamDropbox/UpdateTeamDropboxError";
import { ForbiddenError as UpdateTeamDropboxForbiddenError } from "./types/UpdateTeamDropbox/UpdateTeamDropboxError";
import { NotFoundError as UpdateTeamDropboxNotFoundError } from "./types/UpdateTeamDropbox/UpdateTeamDropboxError";
import { InternalServerError as UpdateTeamDropboxInternalServerError } from "./types/UpdateTeamDropbox/UpdateTeamDropboxError";
import { BadGatewayError as UpdateTeamDropboxBadGatewayError } from "./types/UpdateTeamDropbox/UpdateTeamDropboxError";
import { GatewayTimeoutError as UpdateTeamDropboxGatewayTimeoutError } from "./types/UpdateTeamDropbox/UpdateTeamDropboxError";
import { GenericError as UpdateTeamUserDropboxGenericError } from "./types/UpdateTeamUserDropbox/UpdateTeamUserDropboxError";
import { InvalidParameterError as UpdateTeamUserDropboxInvalidParameterError } from "./types/UpdateTeamUserDropbox/UpdateTeamUserDropboxError";
import { UnauthorizedError as UpdateTeamUserDropboxUnauthorizedError } from "./types/UpdateTeamUserDropbox/UpdateTeamUserDropboxError";
import { ForbiddenError as UpdateTeamUserDropboxForbiddenError } from "./types/UpdateTeamUserDropbox/UpdateTeamUserDropboxError";
import { NotFoundError as UpdateTeamUserDropboxNotFoundError } from "./types/UpdateTeamUserDropbox/UpdateTeamUserDropboxError";
import { InternalServerError as UpdateTeamUserDropboxInternalServerError } from "./types/UpdateTeamUserDropbox/UpdateTeamUserDropboxError";
import { BadGatewayError as UpdateTeamUserDropboxBadGatewayError } from "./types/UpdateTeamUserDropbox/UpdateTeamUserDropboxError";
import { GatewayTimeoutError as UpdateTeamUserDropboxGatewayTimeoutError } from "./types/UpdateTeamUserDropbox/UpdateTeamUserDropboxError";
import { GenericError as UpdateTransferGenericError } from "./types/UpdateTransfer/UpdateTransferError";
import { InvalidParameterError as UpdateTransferInvalidParameterError } from "./types/UpdateTransfer/UpdateTransferError";
import { UnauthorizedError as UpdateTransferUnauthorizedError } from "./types/UpdateTransfer/UpdateTransferError";
import { TransferAlreadyLockedError as UpdateTransferTransferAlreadyLockedError } from "./types/UpdateTransfer/UpdateTransferError";
import { ForbiddenError as UpdateTransferForbiddenError } from "./types/UpdateTransfer/UpdateTransferError";
import { NotFoundError as UpdateTransferNotFoundError } from "./types/UpdateTransfer/UpdateTransferError";
import { InternalServerError as UpdateTransferInternalServerError } from "./types/UpdateTransfer/UpdateTransferError";
import { BadGatewayError as UpdateTransferBadGatewayError } from "./types/UpdateTransfer/UpdateTransferError";
import { GatewayTimeoutError as UpdateTransferGatewayTimeoutError } from "./types/UpdateTransfer/UpdateTransferError";
import { GenericError as UpdateTransferCustomizationGenericError } from "./types/UpdateTransferCustomization/UpdateTransferCustomizationError";
import { InvalidParameterError as UpdateTransferCustomizationInvalidParameterError } from "./types/UpdateTransferCustomization/UpdateTransferCustomizationError";
import { UnauthorizedError as UpdateTransferCustomizationUnauthorizedError } from "./types/UpdateTransferCustomization/UpdateTransferCustomizationError";
import { ForbiddenError as UpdateTransferCustomizationForbiddenError } from "./types/UpdateTransferCustomization/UpdateTransferCustomizationError";
import { NotFoundError as UpdateTransferCustomizationNotFoundError } from "./types/UpdateTransferCustomization/UpdateTransferCustomizationError";
import { InternalServerError as UpdateTransferCustomizationInternalServerError } from "./types/UpdateTransferCustomization/UpdateTransferCustomizationError";
import { BadGatewayError as UpdateTransferCustomizationBadGatewayError } from "./types/UpdateTransferCustomization/UpdateTransferCustomizationError";
import { GatewayTimeoutError as UpdateTransferCustomizationGatewayTimeoutError } from "./types/UpdateTransferCustomization/UpdateTransferCustomizationError";
import { GenericError as UpdateTransferFileGenericError } from "./types/UpdateTransferFile/UpdateTransferFileError";
import { InvalidParameterError as UpdateTransferFileInvalidParameterError } from "./types/UpdateTransferFile/UpdateTransferFileError";
import { UnauthorizedError as UpdateTransferFileUnauthorizedError } from "./types/UpdateTransferFile/UpdateTransferFileError";
import { TransferAlreadyLockedError as UpdateTransferFileTransferAlreadyLockedError } from "./types/UpdateTransferFile/UpdateTransferFileError";
import { FileAlreadyLockedError as UpdateTransferFileFileAlreadyLockedError } from "./types/UpdateTransferFile/UpdateTransferFileError";
import { ForbiddenError as UpdateTransferFileForbiddenError } from "./types/UpdateTransferFile/UpdateTransferFileError";
import { NotFoundError as UpdateTransferFileNotFoundError } from "./types/UpdateTransferFile/UpdateTransferFileError";
import { InternalServerError as UpdateTransferFileInternalServerError } from "./types/UpdateTransferFile/UpdateTransferFileError";
import { BadGatewayError as UpdateTransferFileBadGatewayError } from "./types/UpdateTransferFile/UpdateTransferFileError";
import { GatewayTimeoutError as UpdateTransferFileGatewayTimeoutError } from "./types/UpdateTransferFile/UpdateTransferFileError";
import { GenericError as UpdateTransferFilePartGenericError } from "./types/UpdateTransferFilePart/UpdateTransferFilePartError";
import { InvalidParameterError as UpdateTransferFilePartInvalidParameterError } from "./types/UpdateTransferFilePart/UpdateTransferFilePartError";
import { UnauthorizedError as UpdateTransferFilePartUnauthorizedError } from "./types/UpdateTransferFilePart/UpdateTransferFilePartError";
import { TransferAlreadyLockedError as UpdateTransferFilePartTransferAlreadyLockedError } from "./types/UpdateTransferFilePart/UpdateTransferFilePartError";
import { FileAlreadyLockedError as UpdateTransferFilePartFileAlreadyLockedError } from "./types/UpdateTransferFilePart/UpdateTransferFilePartError";
import { ForbiddenError as UpdateTransferFilePartForbiddenError } from "./types/UpdateTransferFilePart/UpdateTransferFilePartError";
import { NotFoundError as UpdateTransferFilePartNotFoundError } from "./types/UpdateTransferFilePart/UpdateTransferFilePartError";
import { InternalServerError as UpdateTransferFilePartInternalServerError } from "./types/UpdateTransferFilePart/UpdateTransferFilePartError";
import { BadGatewayError as UpdateTransferFilePartBadGatewayError } from "./types/UpdateTransferFilePart/UpdateTransferFilePartError";
import { GatewayTimeoutError as UpdateTransferFilePartGatewayTimeoutError } from "./types/UpdateTransferFilePart/UpdateTransferFilePartError";
import { GenericError as UpdateTransferFilePartsGenericError } from "./types/UpdateTransferFileParts/UpdateTransferFilePartsError";
import { InvalidParameterError as UpdateTransferFilePartsInvalidParameterError } from "./types/UpdateTransferFileParts/UpdateTransferFilePartsError";
import { UnauthorizedError as UpdateTransferFilePartsUnauthorizedError } from "./types/UpdateTransferFileParts/UpdateTransferFilePartsError";
import { TransferAlreadyLockedError as UpdateTransferFilePartsTransferAlreadyLockedError } from "./types/UpdateTransferFileParts/UpdateTransferFilePartsError";
import { FileAlreadyLockedError as UpdateTransferFilePartsFileAlreadyLockedError } from "./types/UpdateTransferFileParts/UpdateTransferFilePartsError";
import { ForbiddenError as UpdateTransferFilePartsForbiddenError } from "./types/UpdateTransferFileParts/UpdateTransferFilePartsError";
import { NotFoundError as UpdateTransferFilePartsNotFoundError } from "./types/UpdateTransferFileParts/UpdateTransferFilePartsError";
import { InternalServerError as UpdateTransferFilePartsInternalServerError } from "./types/UpdateTransferFileParts/UpdateTransferFilePartsError";
import { BadGatewayError as UpdateTransferFilePartsBadGatewayError } from "./types/UpdateTransferFileParts/UpdateTransferFilePartsError";
import { GatewayTimeoutError as UpdateTransferFilePartsGatewayTimeoutError } from "./types/UpdateTransferFileParts/UpdateTransferFilePartsError";
import { GenericError as UpdateUserDropboxGenericError } from "./types/UpdateUserDropbox/UpdateUserDropboxError";
import { InvalidParameterError as UpdateUserDropboxInvalidParameterError } from "./types/UpdateUserDropbox/UpdateUserDropboxError";
import { UnauthorizedError as UpdateUserDropboxUnauthorizedError } from "./types/UpdateUserDropbox/UpdateUserDropboxError";
import { ForbiddenError as UpdateUserDropboxForbiddenError } from "./types/UpdateUserDropbox/UpdateUserDropboxError";
import { NotFoundError as UpdateUserDropboxNotFoundError } from "./types/UpdateUserDropbox/UpdateUserDropboxError";
import { InternalServerError as UpdateUserDropboxInternalServerError } from "./types/UpdateUserDropbox/UpdateUserDropboxError";
import { BadGatewayError as UpdateUserDropboxBadGatewayError } from "./types/UpdateUserDropbox/UpdateUserDropboxError";
import { GatewayTimeoutError as UpdateUserDropboxGatewayTimeoutError } from "./types/UpdateUserDropbox/UpdateUserDropboxError";
import { GenericError as CreateDropboxGenericError } from "./types/CreateDropbox/CreateDropboxError";
import { InvalidParameterError as CreateDropboxInvalidParameterError } from "./types/CreateDropbox/CreateDropboxError";
import { UnauthorizedError as CreateDropboxUnauthorizedError } from "./types/CreateDropbox/CreateDropboxError";
import { InvalidSubscriptionError as CreateDropboxInvalidSubscriptionError } from "./types/CreateDropbox/CreateDropboxError";
import { ForbiddenError as CreateDropboxForbiddenError } from "./types/CreateDropbox/CreateDropboxError";
import { InternalServerError as CreateDropboxInternalServerError } from "./types/CreateDropbox/CreateDropboxError";
import { BadGatewayError as CreateDropboxBadGatewayError } from "./types/CreateDropbox/CreateDropboxError";
import { GatewayTimeoutError as CreateDropboxGatewayTimeoutError } from "./types/CreateDropbox/CreateDropboxError";
import { GenericError as CreateDropboxTransferGenericError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { MissingSenderError as CreateDropboxTransferMissingSenderError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { MissingReceiversError as CreateDropboxTransferMissingReceiversError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { InvalidDeliveryError as CreateDropboxTransferInvalidDeliveryError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { InvalidAvailabilityDurationError as CreateDropboxTransferInvalidAvailabilityDurationError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { InvalidParameterError as CreateDropboxTransferInvalidParameterError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { UnauthorizedError as CreateDropboxTransferUnauthorizedError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { PasswordDoesNotMatchError as CreateDropboxTransferPasswordDoesNotMatchError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { InvalidSubscriptionError as CreateDropboxTransferInvalidSubscriptionError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { EmailNotAllowedError as CreateDropboxTransferEmailNotAllowedError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { OwnerUsageExceededError as CreateDropboxTransferOwnerUsageExceededError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { PasswordRequiredError as CreateDropboxTransferPasswordRequiredError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { TeamConfigurationError as CreateDropboxTransferTeamConfigurationError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { DropboxDisabledError as CreateDropboxTransferDropboxDisabledError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { DropboxDeletedError as CreateDropboxTransferDropboxDeletedError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { DropboxMaxTransferCountError as CreateDropboxTransferDropboxMaxTransferCountError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { DropboxMaxBytesUploadedError as CreateDropboxTransferDropboxMaxBytesUploadedError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { ForbiddenError as CreateDropboxTransferForbiddenError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { NotFoundError as CreateDropboxTransferNotFoundError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { CustomUrlAlreadyInUseError as CreateDropboxTransferCustomUrlAlreadyInUseError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { InternalServerError as CreateDropboxTransferInternalServerError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { BadGatewayError as CreateDropboxTransferBadGatewayError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { GatewayTimeoutError as CreateDropboxTransferGatewayTimeoutError } from "./types/CreateDropboxTransfer/CreateDropboxTransferError";
import { GenericError as CreateTeamDropboxGenericError } from "./types/CreateTeamDropbox/CreateTeamDropboxError";
import { InvalidParameterError as CreateTeamDropboxInvalidParameterError } from "./types/CreateTeamDropbox/CreateTeamDropboxError";
import { UnauthorizedError as CreateTeamDropboxUnauthorizedError } from "./types/CreateTeamDropbox/CreateTeamDropboxError";
import { InvalidSubscriptionError as CreateTeamDropboxInvalidSubscriptionError } from "./types/CreateTeamDropbox/CreateTeamDropboxError";
import { ForbiddenError as CreateTeamDropboxForbiddenError } from "./types/CreateTeamDropbox/CreateTeamDropboxError";
import { NotFoundError as CreateTeamDropboxNotFoundError } from "./types/CreateTeamDropbox/CreateTeamDropboxError";
import { InternalServerError as CreateTeamDropboxInternalServerError } from "./types/CreateTeamDropbox/CreateTeamDropboxError";
import { BadGatewayError as CreateTeamDropboxBadGatewayError } from "./types/CreateTeamDropbox/CreateTeamDropboxError";
import { GatewayTimeoutError as CreateTeamDropboxGatewayTimeoutError } from "./types/CreateTeamDropbox/CreateTeamDropboxError";
import { GenericError as CreateTeamTransferGenericError } from "./types/CreateTeamTransfer/CreateTeamTransferError";
import { InvalidAvailabilityDurationError as CreateTeamTransferInvalidAvailabilityDurationError } from "./types/CreateTeamTransfer/CreateTeamTransferError";
import { InvalidParameterError as CreateTeamTransferInvalidParameterError } from "./types/CreateTeamTransfer/CreateTeamTransferError";
import { UnauthorizedError as CreateTeamTransferUnauthorizedError } from "./types/CreateTeamTransfer/CreateTeamTransferError";
import { InvalidSubscriptionError as CreateTeamTransferInvalidSubscriptionError } from "./types/CreateTeamTransfer/CreateTeamTransferError";
import { EmailNotAllowedError as CreateTeamTransferEmailNotAllowedError } from "./types/CreateTeamTransfer/CreateTeamTransferError";
import { UsageExceededError as CreateTeamTransferUsageExceededError } from "./types/CreateTeamTransfer/CreateTeamTransferError";
import { PasswordRequiredError as CreateTeamTransferPasswordRequiredError } from "./types/CreateTeamTransfer/CreateTeamTransferError";
import { ForbiddenError as CreateTeamTransferForbiddenError } from "./types/CreateTeamTransfer/CreateTeamTransferError";
import { NotFoundError as CreateTeamTransferNotFoundError } from "./types/CreateTeamTransfer/CreateTeamTransferError";
import { CustomUrlAlreadyInUseError as CreateTeamTransferCustomUrlAlreadyInUseError } from "./types/CreateTeamTransfer/CreateTeamTransferError";
import { InternalServerError as CreateTeamTransferInternalServerError } from "./types/CreateTeamTransfer/CreateTeamTransferError";
import { BadGatewayError as CreateTeamTransferBadGatewayError } from "./types/CreateTeamTransfer/CreateTeamTransferError";
import { GatewayTimeoutError as CreateTeamTransferGatewayTimeoutError } from "./types/CreateTeamTransfer/CreateTeamTransferError";
import { GenericError as CreateTeamUserDropboxGenericError } from "./types/CreateTeamUserDropbox/CreateTeamUserDropboxError";
import { InvalidParameterError as CreateTeamUserDropboxInvalidParameterError } from "./types/CreateTeamUserDropbox/CreateTeamUserDropboxError";
import { UnauthorizedError as CreateTeamUserDropboxUnauthorizedError } from "./types/CreateTeamUserDropbox/CreateTeamUserDropboxError";
import { InvalidSubscriptionError as CreateTeamUserDropboxInvalidSubscriptionError } from "./types/CreateTeamUserDropbox/CreateTeamUserDropboxError";
import { ForbiddenError as CreateTeamUserDropboxForbiddenError } from "./types/CreateTeamUserDropbox/CreateTeamUserDropboxError";
import { NotFoundError as CreateTeamUserDropboxNotFoundError } from "./types/CreateTeamUserDropbox/CreateTeamUserDropboxError";
import { InternalServerError as CreateTeamUserDropboxInternalServerError } from "./types/CreateTeamUserDropbox/CreateTeamUserDropboxError";
import { BadGatewayError as CreateTeamUserDropboxBadGatewayError } from "./types/CreateTeamUserDropbox/CreateTeamUserDropboxError";
import { GatewayTimeoutError as CreateTeamUserDropboxGatewayTimeoutError } from "./types/CreateTeamUserDropbox/CreateTeamUserDropboxError";
import { GenericError as CreateTransferGenericError } from "./types/CreateTransfer/CreateTransferError";
import { InvalidAvailabilityDurationError as CreateTransferInvalidAvailabilityDurationError } from "./types/CreateTransfer/CreateTransferError";
import { InvalidParameterError as CreateTransferInvalidParameterError } from "./types/CreateTransfer/CreateTransferError";
import { UnauthorizedError as CreateTransferUnauthorizedError } from "./types/CreateTransfer/CreateTransferError";
import { InvalidSubscriptionError as CreateTransferInvalidSubscriptionError } from "./types/CreateTransfer/CreateTransferError";
import { EmailNotAllowedError as CreateTransferEmailNotAllowedError } from "./types/CreateTransfer/CreateTransferError";
import { UsageExceededError as CreateTransferUsageExceededError } from "./types/CreateTransfer/CreateTransferError";
import { PasswordRequiredError as CreateTransferPasswordRequiredError } from "./types/CreateTransfer/CreateTransferError";
import { EmailNotVerifiedError as CreateTransferEmailNotVerifiedError } from "./types/CreateTransfer/CreateTransferError";
import { ForbiddenError as CreateTransferForbiddenError } from "./types/CreateTransfer/CreateTransferError";
import { CustomUrlAlreadyInUseError as CreateTransferCustomUrlAlreadyInUseError } from "./types/CreateTransfer/CreateTransferError";
import { InternalServerError as CreateTransferInternalServerError } from "./types/CreateTransfer/CreateTransferError";
import { BadGatewayError as CreateTransferBadGatewayError } from "./types/CreateTransfer/CreateTransferError";
import { GatewayTimeoutError as CreateTransferGatewayTimeoutError } from "./types/CreateTransfer/CreateTransferError";
import { GenericError as CreateTransferFileGenericError } from "./types/CreateTransferFile/CreateTransferFileError";
import { InvalidParameterError as CreateTransferFileInvalidParameterError } from "./types/CreateTransferFile/CreateTransferFileError";
import { UnauthorizedError as CreateTransferFileUnauthorizedError } from "./types/CreateTransferFile/CreateTransferFileError";
import { TransferAlreadyLockedError as CreateTransferFileTransferAlreadyLockedError } from "./types/CreateTransferFile/CreateTransferFileError";
import { TransferIsInQueueError as CreateTransferFileTransferIsInQueueError } from "./types/CreateTransferFile/CreateTransferFileError";
import { ForbiddenError as CreateTransferFileForbiddenError } from "./types/CreateTransferFile/CreateTransferFileError";
import { NotFoundError as CreateTransferFileNotFoundError } from "./types/CreateTransferFile/CreateTransferFileError";
import { ConflictError as CreateTransferFileConflictError } from "./types/CreateTransferFile/CreateTransferFileError";
import { InternalServerError as CreateTransferFileInternalServerError } from "./types/CreateTransferFile/CreateTransferFileError";
import { BadGatewayError as CreateTransferFileBadGatewayError } from "./types/CreateTransferFile/CreateTransferFileError";
import { GatewayTimeoutError as CreateTransferFileGatewayTimeoutError } from "./types/CreateTransferFile/CreateTransferFileError";
import { GenericError as CreateTransferFilePartGenericError } from "./types/CreateTransferFilePart/CreateTransferFilePartError";
import { InvalidParameterError as CreateTransferFilePartInvalidParameterError } from "./types/CreateTransferFilePart/CreateTransferFilePartError";
import { UnauthorizedError as CreateTransferFilePartUnauthorizedError } from "./types/CreateTransferFilePart/CreateTransferFilePartError";
import { TransferAlreadyLockedError as CreateTransferFilePartTransferAlreadyLockedError } from "./types/CreateTransferFilePart/CreateTransferFilePartError";
import { FileAlreadyLockedError as CreateTransferFilePartFileAlreadyLockedError } from "./types/CreateTransferFilePart/CreateTransferFilePartError";
import { ForbiddenError as CreateTransferFilePartForbiddenError } from "./types/CreateTransferFilePart/CreateTransferFilePartError";
import { NotFoundError as CreateTransferFilePartNotFoundError } from "./types/CreateTransferFilePart/CreateTransferFilePartError";
import { InternalServerError as CreateTransferFilePartInternalServerError } from "./types/CreateTransferFilePart/CreateTransferFilePartError";
import { BadGatewayError as CreateTransferFilePartBadGatewayError } from "./types/CreateTransferFilePart/CreateTransferFilePartError";
import { GatewayTimeoutError as CreateTransferFilePartGatewayTimeoutError } from "./types/CreateTransferFilePart/CreateTransferFilePartError";
import { GenericError as CreateTransferFilePartsGenericError } from "./types/CreateTransferFileParts/CreateTransferFilePartsError";
import { InvalidParameterError as CreateTransferFilePartsInvalidParameterError } from "./types/CreateTransferFileParts/CreateTransferFilePartsError";
import { UnauthorizedError as CreateTransferFilePartsUnauthorizedError } from "./types/CreateTransferFileParts/CreateTransferFilePartsError";
import { TransferAlreadyLockedError as CreateTransferFilePartsTransferAlreadyLockedError } from "./types/CreateTransferFileParts/CreateTransferFilePartsError";
import { FileAlreadyLockedError as CreateTransferFilePartsFileAlreadyLockedError } from "./types/CreateTransferFileParts/CreateTransferFilePartsError";
import { ForbiddenError as CreateTransferFilePartsForbiddenError } from "./types/CreateTransferFileParts/CreateTransferFilePartsError";
import { NotFoundError as CreateTransferFilePartsNotFoundError } from "./types/CreateTransferFileParts/CreateTransferFilePartsError";
import { InternalServerError as CreateTransferFilePartsInternalServerError } from "./types/CreateTransferFileParts/CreateTransferFilePartsError";
import { BadGatewayError as CreateTransferFilePartsBadGatewayError } from "./types/CreateTransferFileParts/CreateTransferFilePartsError";
import { GatewayTimeoutError as CreateTransferFilePartsGatewayTimeoutError } from "./types/CreateTransferFileParts/CreateTransferFilePartsError";
import { GenericError as CreateTransferSignedUrlsGenericError } from "./types/CreateTransferSignedUrls/CreateTransferSignedUrlsError";
import { InvalidParameterError as CreateTransferSignedUrlsInvalidParameterError } from "./types/CreateTransferSignedUrls/CreateTransferSignedUrlsError";
import { UnauthorizedError as CreateTransferSignedUrlsUnauthorizedError } from "./types/CreateTransferSignedUrls/CreateTransferSignedUrlsError";
import { PasswordDoesNotMatchError as CreateTransferSignedUrlsPasswordDoesNotMatchError } from "./types/CreateTransferSignedUrls/CreateTransferSignedUrlsError";
import { ForbiddenError as CreateTransferSignedUrlsForbiddenError } from "./types/CreateTransferSignedUrls/CreateTransferSignedUrlsError";
import { NotFoundError as CreateTransferSignedUrlsNotFoundError } from "./types/CreateTransferSignedUrls/CreateTransferSignedUrlsError";
import { InternalServerError as CreateTransferSignedUrlsInternalServerError } from "./types/CreateTransferSignedUrls/CreateTransferSignedUrlsError";
import { BadGatewayError as CreateTransferSignedUrlsBadGatewayError } from "./types/CreateTransferSignedUrls/CreateTransferSignedUrlsError";
import { GatewayTimeoutError as CreateTransferSignedUrlsGatewayTimeoutError } from "./types/CreateTransferSignedUrls/CreateTransferSignedUrlsError";
import { GenericError as CreateUserDropboxGenericError } from "./types/CreateUserDropbox/CreateUserDropboxError";
import { InvalidParameterError as CreateUserDropboxInvalidParameterError } from "./types/CreateUserDropbox/CreateUserDropboxError";
import { UnauthorizedError as CreateUserDropboxUnauthorizedError } from "./types/CreateUserDropbox/CreateUserDropboxError";
import { InvalidSubscriptionError as CreateUserDropboxInvalidSubscriptionError } from "./types/CreateUserDropbox/CreateUserDropboxError";
import { ForbiddenError as CreateUserDropboxForbiddenError } from "./types/CreateUserDropbox/CreateUserDropboxError";
import { NotFoundError as CreateUserDropboxNotFoundError } from "./types/CreateUserDropbox/CreateUserDropboxError";
import { InternalServerError as CreateUserDropboxInternalServerError } from "./types/CreateUserDropbox/CreateUserDropboxError";
import { BadGatewayError as CreateUserDropboxBadGatewayError } from "./types/CreateUserDropbox/CreateUserDropboxError";
import { GatewayTimeoutError as CreateUserDropboxGatewayTimeoutError } from "./types/CreateUserDropbox/CreateUserDropboxError";
import { GenericError as DeleteDropboxGenericError } from "./types/DeleteDropbox/DeleteDropboxError";
import { InvalidParameterError as DeleteDropboxInvalidParameterError } from "./types/DeleteDropbox/DeleteDropboxError";
import { UnauthorizedError as DeleteDropboxUnauthorizedError } from "./types/DeleteDropbox/DeleteDropboxError";
import { ForbiddenError as DeleteDropboxForbiddenError } from "./types/DeleteDropbox/DeleteDropboxError";
import { NotFoundError as DeleteDropboxNotFoundError } from "./types/DeleteDropbox/DeleteDropboxError";
import { InternalServerError as DeleteDropboxInternalServerError } from "./types/DeleteDropbox/DeleteDropboxError";
import { BadGatewayError as DeleteDropboxBadGatewayError } from "./types/DeleteDropbox/DeleteDropboxError";
import { GatewayTimeoutError as DeleteDropboxGatewayTimeoutError } from "./types/DeleteDropbox/DeleteDropboxError";
import { GenericError as DeleteReceiptGenericError } from "./types/DeleteReceipt/DeleteReceiptError";
import { InvalidParameterError as DeleteReceiptInvalidParameterError } from "./types/DeleteReceipt/DeleteReceiptError";
import { UnauthorizedError as DeleteReceiptUnauthorizedError } from "./types/DeleteReceipt/DeleteReceiptError";
import { ForbiddenError as DeleteReceiptForbiddenError } from "./types/DeleteReceipt/DeleteReceiptError";
import { NotFoundError as DeleteReceiptNotFoundError } from "./types/DeleteReceipt/DeleteReceiptError";
import { InternalServerError as DeleteReceiptInternalServerError } from "./types/DeleteReceipt/DeleteReceiptError";
import { BadGatewayError as DeleteReceiptBadGatewayError } from "./types/DeleteReceipt/DeleteReceiptError";
import { GatewayTimeoutError as DeleteReceiptGatewayTimeoutError } from "./types/DeleteReceipt/DeleteReceiptError";
import { GenericError as DeleteReportGenericError } from "./types/DeleteReport/DeleteReportError";
import { InvalidParameterError as DeleteReportInvalidParameterError } from "./types/DeleteReport/DeleteReportError";
import { UnauthorizedError as DeleteReportUnauthorizedError } from "./types/DeleteReport/DeleteReportError";
import { TransferNotUploadedError as DeleteReportTransferNotUploadedError } from "./types/DeleteReport/DeleteReportError";
import { ForbiddenError as DeleteReportForbiddenError } from "./types/DeleteReport/DeleteReportError";
import { NotFoundError as DeleteReportNotFoundError } from "./types/DeleteReport/DeleteReportError";
import { InternalServerError as DeleteReportInternalServerError } from "./types/DeleteReport/DeleteReportError";
import { BadGatewayError as DeleteReportBadGatewayError } from "./types/DeleteReport/DeleteReportError";
import { GatewayTimeoutError as DeleteReportGatewayTimeoutError } from "./types/DeleteReport/DeleteReportError";
import { GenericError as DeleteTeamDropboxGenericError } from "./types/DeleteTeamDropbox/DeleteTeamDropboxError";
import { InvalidParameterError as DeleteTeamDropboxInvalidParameterError } from "./types/DeleteTeamDropbox/DeleteTeamDropboxError";
import { UnauthorizedError as DeleteTeamDropboxUnauthorizedError } from "./types/DeleteTeamDropbox/DeleteTeamDropboxError";
import { ForbiddenError as DeleteTeamDropboxForbiddenError } from "./types/DeleteTeamDropbox/DeleteTeamDropboxError";
import { NotFoundError as DeleteTeamDropboxNotFoundError } from "./types/DeleteTeamDropbox/DeleteTeamDropboxError";
import { InternalServerError as DeleteTeamDropboxInternalServerError } from "./types/DeleteTeamDropbox/DeleteTeamDropboxError";
import { BadGatewayError as DeleteTeamDropboxBadGatewayError } from "./types/DeleteTeamDropbox/DeleteTeamDropboxError";
import { GatewayTimeoutError as DeleteTeamDropboxGatewayTimeoutError } from "./types/DeleteTeamDropbox/DeleteTeamDropboxError";
import { GenericError as DeleteTeamReceiptGenericError } from "./types/DeleteTeamReceipt/DeleteTeamReceiptError";
import { InvalidParameterError as DeleteTeamReceiptInvalidParameterError } from "./types/DeleteTeamReceipt/DeleteTeamReceiptError";
import { UnauthorizedError as DeleteTeamReceiptUnauthorizedError } from "./types/DeleteTeamReceipt/DeleteTeamReceiptError";
import { ForbiddenError as DeleteTeamReceiptForbiddenError } from "./types/DeleteTeamReceipt/DeleteTeamReceiptError";
import { NotFoundError as DeleteTeamReceiptNotFoundError } from "./types/DeleteTeamReceipt/DeleteTeamReceiptError";
import { InternalServerError as DeleteTeamReceiptInternalServerError } from "./types/DeleteTeamReceipt/DeleteTeamReceiptError";
import { BadGatewayError as DeleteTeamReceiptBadGatewayError } from "./types/DeleteTeamReceipt/DeleteTeamReceiptError";
import { GatewayTimeoutError as DeleteTeamReceiptGatewayTimeoutError } from "./types/DeleteTeamReceipt/DeleteTeamReceiptError";
import { GenericError as DeleteTeamTransferGenericError } from "./types/DeleteTeamTransfer/DeleteTeamTransferError";
import { InvalidParameterError as DeleteTeamTransferInvalidParameterError } from "./types/DeleteTeamTransfer/DeleteTeamTransferError";
import { UnauthorizedError as DeleteTeamTransferUnauthorizedError } from "./types/DeleteTeamTransfer/DeleteTeamTransferError";
import { TransferNotUploadedError as DeleteTeamTransferTransferNotUploadedError } from "./types/DeleteTeamTransfer/DeleteTeamTransferError";
import { ForbiddenError as DeleteTeamTransferForbiddenError } from "./types/DeleteTeamTransfer/DeleteTeamTransferError";
import { NotFoundError as DeleteTeamTransferNotFoundError } from "./types/DeleteTeamTransfer/DeleteTeamTransferError";
import { InternalServerError as DeleteTeamTransferInternalServerError } from "./types/DeleteTeamTransfer/DeleteTeamTransferError";
import { BadGatewayError as DeleteTeamTransferBadGatewayError } from "./types/DeleteTeamTransfer/DeleteTeamTransferError";
import { GatewayTimeoutError as DeleteTeamTransferGatewayTimeoutError } from "./types/DeleteTeamTransfer/DeleteTeamTransferError";
import { GenericError as DeleteTeamUserDropboxGenericError } from "./types/DeleteTeamUserDropbox/DeleteTeamUserDropboxError";
import { InvalidParameterError as DeleteTeamUserDropboxInvalidParameterError } from "./types/DeleteTeamUserDropbox/DeleteTeamUserDropboxError";
import { UnauthorizedError as DeleteTeamUserDropboxUnauthorizedError } from "./types/DeleteTeamUserDropbox/DeleteTeamUserDropboxError";
import { ForbiddenError as DeleteTeamUserDropboxForbiddenError } from "./types/DeleteTeamUserDropbox/DeleteTeamUserDropboxError";
import { NotFoundError as DeleteTeamUserDropboxNotFoundError } from "./types/DeleteTeamUserDropbox/DeleteTeamUserDropboxError";
import { InternalServerError as DeleteTeamUserDropboxInternalServerError } from "./types/DeleteTeamUserDropbox/DeleteTeamUserDropboxError";
import { BadGatewayError as DeleteTeamUserDropboxBadGatewayError } from "./types/DeleteTeamUserDropbox/DeleteTeamUserDropboxError";
import { GatewayTimeoutError as DeleteTeamUserDropboxGatewayTimeoutError } from "./types/DeleteTeamUserDropbox/DeleteTeamUserDropboxError";
import { GenericError as DeleteTeamUserReceiptGenericError } from "./types/DeleteTeamUserReceipt/DeleteTeamUserReceiptError";
import { InvalidParameterError as DeleteTeamUserReceiptInvalidParameterError } from "./types/DeleteTeamUserReceipt/DeleteTeamUserReceiptError";
import { UnauthorizedError as DeleteTeamUserReceiptUnauthorizedError } from "./types/DeleteTeamUserReceipt/DeleteTeamUserReceiptError";
import { ForbiddenError as DeleteTeamUserReceiptForbiddenError } from "./types/DeleteTeamUserReceipt/DeleteTeamUserReceiptError";
import { NotFoundError as DeleteTeamUserReceiptNotFoundError } from "./types/DeleteTeamUserReceipt/DeleteTeamUserReceiptError";
import { InternalServerError as DeleteTeamUserReceiptInternalServerError } from "./types/DeleteTeamUserReceipt/DeleteTeamUserReceiptError";
import { BadGatewayError as DeleteTeamUserReceiptBadGatewayError } from "./types/DeleteTeamUserReceipt/DeleteTeamUserReceiptError";
import { GatewayTimeoutError as DeleteTeamUserReceiptGatewayTimeoutError } from "./types/DeleteTeamUserReceipt/DeleteTeamUserReceiptError";
import { GenericError as DeleteTransferGenericError } from "./types/DeleteTransfer/DeleteTransferError";
import { InvalidParameterError as DeleteTransferInvalidParameterError } from "./types/DeleteTransfer/DeleteTransferError";
import { UnauthorizedError as DeleteTransferUnauthorizedError } from "./types/DeleteTransfer/DeleteTransferError";
import { TransferNotUploadedError as DeleteTransferTransferNotUploadedError } from "./types/DeleteTransfer/DeleteTransferError";
import { ForbiddenError as DeleteTransferForbiddenError } from "./types/DeleteTransfer/DeleteTransferError";
import { NotFoundError as DeleteTransferNotFoundError } from "./types/DeleteTransfer/DeleteTransferError";
import { InternalServerError as DeleteTransferInternalServerError } from "./types/DeleteTransfer/DeleteTransferError";
import { BadGatewayError as DeleteTransferBadGatewayError } from "./types/DeleteTransfer/DeleteTransferError";
import { GatewayTimeoutError as DeleteTransferGatewayTimeoutError } from "./types/DeleteTransfer/DeleteTransferError";
import { GenericError as DeleteTransferFileGenericError } from "./types/DeleteTransferFile/DeleteTransferFileError";
import { InvalidParameterError as DeleteTransferFileInvalidParameterError } from "./types/DeleteTransferFile/DeleteTransferFileError";
import { UnauthorizedError as DeleteTransferFileUnauthorizedError } from "./types/DeleteTransferFile/DeleteTransferFileError";
import { ForbiddenError as DeleteTransferFileForbiddenError } from "./types/DeleteTransferFile/DeleteTransferFileError";
import { NotFoundError as DeleteTransferFileNotFoundError } from "./types/DeleteTransferFile/DeleteTransferFileError";
import { InternalServerError as DeleteTransferFileInternalServerError } from "./types/DeleteTransferFile/DeleteTransferFileError";
import { BadGatewayError as DeleteTransferFileBadGatewayError } from "./types/DeleteTransferFile/DeleteTransferFileError";
import { GatewayTimeoutError as DeleteTransferFileGatewayTimeoutError } from "./types/DeleteTransferFile/DeleteTransferFileError";
import { GenericError as DeleteUserDropboxGenericError } from "./types/DeleteUserDropbox/DeleteUserDropboxError";
import { InvalidParameterError as DeleteUserDropboxInvalidParameterError } from "./types/DeleteUserDropbox/DeleteUserDropboxError";
import { UnauthorizedError as DeleteUserDropboxUnauthorizedError } from "./types/DeleteUserDropbox/DeleteUserDropboxError";
import { ForbiddenError as DeleteUserDropboxForbiddenError } from "./types/DeleteUserDropbox/DeleteUserDropboxError";
import { NotFoundError as DeleteUserDropboxNotFoundError } from "./types/DeleteUserDropbox/DeleteUserDropboxError";
import { InternalServerError as DeleteUserDropboxInternalServerError } from "./types/DeleteUserDropbox/DeleteUserDropboxError";
import { BadGatewayError as DeleteUserDropboxBadGatewayError } from "./types/DeleteUserDropbox/DeleteUserDropboxError";
import { GatewayTimeoutError as DeleteUserDropboxGatewayTimeoutError } from "./types/DeleteUserDropbox/DeleteUserDropboxError";
import { GenericError as DeleteUserReceiptGenericError } from "./types/DeleteUserReceipt/DeleteUserReceiptError";
import { InvalidParameterError as DeleteUserReceiptInvalidParameterError } from "./types/DeleteUserReceipt/DeleteUserReceiptError";
import { UnauthorizedError as DeleteUserReceiptUnauthorizedError } from "./types/DeleteUserReceipt/DeleteUserReceiptError";
import { ForbiddenError as DeleteUserReceiptForbiddenError } from "./types/DeleteUserReceipt/DeleteUserReceiptError";
import { NotFoundError as DeleteUserReceiptNotFoundError } from "./types/DeleteUserReceipt/DeleteUserReceiptError";
import { InternalServerError as DeleteUserReceiptInternalServerError } from "./types/DeleteUserReceipt/DeleteUserReceiptError";
import { BadGatewayError as DeleteUserReceiptBadGatewayError } from "./types/DeleteUserReceipt/DeleteUserReceiptError";
import { GatewayTimeoutError as DeleteUserReceiptGatewayTimeoutError } from "./types/DeleteUserReceipt/DeleteUserReceiptError";
import { GenericError as DeleteUserTransferGenericError } from "./types/DeleteUserTransfer/DeleteUserTransferError";
import { InvalidParameterError as DeleteUserTransferInvalidParameterError } from "./types/DeleteUserTransfer/DeleteUserTransferError";
import { UnauthorizedError as DeleteUserTransferUnauthorizedError } from "./types/DeleteUserTransfer/DeleteUserTransferError";
import { TransferNotUploadedError as DeleteUserTransferTransferNotUploadedError } from "./types/DeleteUserTransfer/DeleteUserTransferError";
import { ForbiddenError as DeleteUserTransferForbiddenError } from "./types/DeleteUserTransfer/DeleteUserTransferError";
import { NotFoundError as DeleteUserTransferNotFoundError } from "./types/DeleteUserTransfer/DeleteUserTransferError";
import { InternalServerError as DeleteUserTransferInternalServerError } from "./types/DeleteUserTransfer/DeleteUserTransferError";
import { BadGatewayError as DeleteUserTransferBadGatewayError } from "./types/DeleteUserTransfer/DeleteUserTransferError";
import { GatewayTimeoutError as DeleteUserTransferGatewayTimeoutError } from "./types/DeleteUserTransfer/DeleteUserTransferError";
import { GenericError as GetAccountMetricStatisticGenericError } from "./types/GetAccountMetricStatistic/GetAccountMetricStatisticError";
import { InvalidParameterError as GetAccountMetricStatisticInvalidParameterError } from "./types/GetAccountMetricStatistic/GetAccountMetricStatisticError";
import { UnauthorizedError as GetAccountMetricStatisticUnauthorizedError } from "./types/GetAccountMetricStatistic/GetAccountMetricStatisticError";
import { ForbiddenError as GetAccountMetricStatisticForbiddenError } from "./types/GetAccountMetricStatistic/GetAccountMetricStatisticError";
import { NotFoundError as GetAccountMetricStatisticNotFoundError } from "./types/GetAccountMetricStatistic/GetAccountMetricStatisticError";
import { InternalServerError as GetAccountMetricStatisticInternalServerError } from "./types/GetAccountMetricStatistic/GetAccountMetricStatisticError";
import { BadGatewayError as GetAccountMetricStatisticBadGatewayError } from "./types/GetAccountMetricStatistic/GetAccountMetricStatisticError";
import { GatewayTimeoutError as GetAccountMetricStatisticGatewayTimeoutError } from "./types/GetAccountMetricStatistic/GetAccountMetricStatisticError";
import { GenericError as GetAccountTeamMetricStatisticGenericError } from "./types/GetAccountTeamMetricStatistic/GetAccountTeamMetricStatisticError";
import { InvalidParameterError as GetAccountTeamMetricStatisticInvalidParameterError } from "./types/GetAccountTeamMetricStatistic/GetAccountTeamMetricStatisticError";
import { UnauthorizedError as GetAccountTeamMetricStatisticUnauthorizedError } from "./types/GetAccountTeamMetricStatistic/GetAccountTeamMetricStatisticError";
import { ForbiddenError as GetAccountTeamMetricStatisticForbiddenError } from "./types/GetAccountTeamMetricStatistic/GetAccountTeamMetricStatisticError";
import { NotFoundError as GetAccountTeamMetricStatisticNotFoundError } from "./types/GetAccountTeamMetricStatistic/GetAccountTeamMetricStatisticError";
import { InternalServerError as GetAccountTeamMetricStatisticInternalServerError } from "./types/GetAccountTeamMetricStatistic/GetAccountTeamMetricStatisticError";
import { BadGatewayError as GetAccountTeamMetricStatisticBadGatewayError } from "./types/GetAccountTeamMetricStatistic/GetAccountTeamMetricStatisticError";
import { GatewayTimeoutError as GetAccountTeamMetricStatisticGatewayTimeoutError } from "./types/GetAccountTeamMetricStatistic/GetAccountTeamMetricStatisticError";
import { GenericError as GetAccountTeamUsageGenericError } from "./types/GetAccountTeamUsage/GetAccountTeamUsageError";
import { InvalidParameterError as GetAccountTeamUsageInvalidParameterError } from "./types/GetAccountTeamUsage/GetAccountTeamUsageError";
import { UnauthorizedError as GetAccountTeamUsageUnauthorizedError } from "./types/GetAccountTeamUsage/GetAccountTeamUsageError";
import { ForbiddenError as GetAccountTeamUsageForbiddenError } from "./types/GetAccountTeamUsage/GetAccountTeamUsageError";
import { InternalServerError as GetAccountTeamUsageInternalServerError } from "./types/GetAccountTeamUsage/GetAccountTeamUsageError";
import { BadGatewayError as GetAccountTeamUsageBadGatewayError } from "./types/GetAccountTeamUsage/GetAccountTeamUsageError";
import { GatewayTimeoutError as GetAccountTeamUsageGatewayTimeoutError } from "./types/GetAccountTeamUsage/GetAccountTeamUsageError";
import { GenericError as GetAccountTeamUserMetricStatisticGenericError } from "./types/GetAccountTeamUserMetricStatistic/GetAccountTeamUserMetricStatisticError";
import { InvalidParameterError as GetAccountTeamUserMetricStatisticInvalidParameterError } from "./types/GetAccountTeamUserMetricStatistic/GetAccountTeamUserMetricStatisticError";
import { UnauthorizedError as GetAccountTeamUserMetricStatisticUnauthorizedError } from "./types/GetAccountTeamUserMetricStatistic/GetAccountTeamUserMetricStatisticError";
import { ForbiddenError as GetAccountTeamUserMetricStatisticForbiddenError } from "./types/GetAccountTeamUserMetricStatistic/GetAccountTeamUserMetricStatisticError";
import { NotFoundError as GetAccountTeamUserMetricStatisticNotFoundError } from "./types/GetAccountTeamUserMetricStatistic/GetAccountTeamUserMetricStatisticError";
import { InternalServerError as GetAccountTeamUserMetricStatisticInternalServerError } from "./types/GetAccountTeamUserMetricStatistic/GetAccountTeamUserMetricStatisticError";
import { BadGatewayError as GetAccountTeamUserMetricStatisticBadGatewayError } from "./types/GetAccountTeamUserMetricStatistic/GetAccountTeamUserMetricStatisticError";
import { GatewayTimeoutError as GetAccountTeamUserMetricStatisticGatewayTimeoutError } from "./types/GetAccountTeamUserMetricStatistic/GetAccountTeamUserMetricStatisticError";
import { GenericError as GetAccountTeamUserUsageGenericError } from "./types/GetAccountTeamUserUsage/GetAccountTeamUserUsageError";
import { InvalidParameterError as GetAccountTeamUserUsageInvalidParameterError } from "./types/GetAccountTeamUserUsage/GetAccountTeamUserUsageError";
import { UnauthorizedError as GetAccountTeamUserUsageUnauthorizedError } from "./types/GetAccountTeamUserUsage/GetAccountTeamUserUsageError";
import { ForbiddenError as GetAccountTeamUserUsageForbiddenError } from "./types/GetAccountTeamUserUsage/GetAccountTeamUserUsageError";
import { InternalServerError as GetAccountTeamUserUsageInternalServerError } from "./types/GetAccountTeamUserUsage/GetAccountTeamUserUsageError";
import { BadGatewayError as GetAccountTeamUserUsageBadGatewayError } from "./types/GetAccountTeamUserUsage/GetAccountTeamUserUsageError";
import { GatewayTimeoutError as GetAccountTeamUserUsageGatewayTimeoutError } from "./types/GetAccountTeamUserUsage/GetAccountTeamUserUsageError";
import { GenericError as GetAccountTransferGenericError } from "./types/GetAccountTransfer/GetAccountTransferError";
import { InvalidParameterError as GetAccountTransferInvalidParameterError } from "./types/GetAccountTransfer/GetAccountTransferError";
import { UnauthorizedError as GetAccountTransferUnauthorizedError } from "./types/GetAccountTransfer/GetAccountTransferError";
import { ForbiddenError as GetAccountTransferForbiddenError } from "./types/GetAccountTransfer/GetAccountTransferError";
import { NotFoundError as GetAccountTransferNotFoundError } from "./types/GetAccountTransfer/GetAccountTransferError";
import { InternalServerError as GetAccountTransferInternalServerError } from "./types/GetAccountTransfer/GetAccountTransferError";
import { BadGatewayError as GetAccountTransferBadGatewayError } from "./types/GetAccountTransfer/GetAccountTransferError";
import { GatewayTimeoutError as GetAccountTransferGatewayTimeoutError } from "./types/GetAccountTransfer/GetAccountTransferError";
import { GenericError as GetAccountUsageGenericError } from "./types/GetAccountUsage/GetAccountUsageError";
import { InvalidParameterError as GetAccountUsageInvalidParameterError } from "./types/GetAccountUsage/GetAccountUsageError";
import { UnauthorizedError as GetAccountUsageUnauthorizedError } from "./types/GetAccountUsage/GetAccountUsageError";
import { ForbiddenError as GetAccountUsageForbiddenError } from "./types/GetAccountUsage/GetAccountUsageError";
import { InternalServerError as GetAccountUsageInternalServerError } from "./types/GetAccountUsage/GetAccountUsageError";
import { BadGatewayError as GetAccountUsageBadGatewayError } from "./types/GetAccountUsage/GetAccountUsageError";
import { GatewayTimeoutError as GetAccountUsageGatewayTimeoutError } from "./types/GetAccountUsage/GetAccountUsageError";
import { GenericError as GetAccountUserMetricStatisticGenericError } from "./types/GetAccountUserMetricStatistic/GetAccountUserMetricStatisticError";
import { InvalidParameterError as GetAccountUserMetricStatisticInvalidParameterError } from "./types/GetAccountUserMetricStatistic/GetAccountUserMetricStatisticError";
import { UnauthorizedError as GetAccountUserMetricStatisticUnauthorizedError } from "./types/GetAccountUserMetricStatistic/GetAccountUserMetricStatisticError";
import { ForbiddenError as GetAccountUserMetricStatisticForbiddenError } from "./types/GetAccountUserMetricStatistic/GetAccountUserMetricStatisticError";
import { NotFoundError as GetAccountUserMetricStatisticNotFoundError } from "./types/GetAccountUserMetricStatistic/GetAccountUserMetricStatisticError";
import { InternalServerError as GetAccountUserMetricStatisticInternalServerError } from "./types/GetAccountUserMetricStatistic/GetAccountUserMetricStatisticError";
import { BadGatewayError as GetAccountUserMetricStatisticBadGatewayError } from "./types/GetAccountUserMetricStatistic/GetAccountUserMetricStatisticError";
import { GatewayTimeoutError as GetAccountUserMetricStatisticGatewayTimeoutError } from "./types/GetAccountUserMetricStatistic/GetAccountUserMetricStatisticError";
import { GenericError as GetAccountUserUsageGenericError } from "./types/GetAccountUserUsage/GetAccountUserUsageError";
import { InvalidParameterError as GetAccountUserUsageInvalidParameterError } from "./types/GetAccountUserUsage/GetAccountUserUsageError";
import { UnauthorizedError as GetAccountUserUsageUnauthorizedError } from "./types/GetAccountUserUsage/GetAccountUserUsageError";
import { ForbiddenError as GetAccountUserUsageForbiddenError } from "./types/GetAccountUserUsage/GetAccountUserUsageError";
import { InternalServerError as GetAccountUserUsageInternalServerError } from "./types/GetAccountUserUsage/GetAccountUserUsageError";
import { BadGatewayError as GetAccountUserUsageBadGatewayError } from "./types/GetAccountUserUsage/GetAccountUserUsageError";
import { GatewayTimeoutError as GetAccountUserUsageGatewayTimeoutError } from "./types/GetAccountUserUsage/GetAccountUserUsageError";
import { GenericError as GetDropboxGenericError } from "./types/GetDropbox/GetDropboxError";
import { InvalidParameterError as GetDropboxInvalidParameterError } from "./types/GetDropbox/GetDropboxError";
import { UnauthorizedError as GetDropboxUnauthorizedError } from "./types/GetDropbox/GetDropboxError";
import { ForbiddenError as GetDropboxForbiddenError } from "./types/GetDropbox/GetDropboxError";
import { NotFoundError as GetDropboxNotFoundError } from "./types/GetDropbox/GetDropboxError";
import { InternalServerError as GetDropboxInternalServerError } from "./types/GetDropbox/GetDropboxError";
import { BadGatewayError as GetDropboxBadGatewayError } from "./types/GetDropbox/GetDropboxError";
import { GatewayTimeoutError as GetDropboxGatewayTimeoutError } from "./types/GetDropbox/GetDropboxError";
import { GenericError as GetDropboxPreviewGenericError } from "./types/GetDropboxPreview/GetDropboxPreviewError";
import { InvalidParameterError as GetDropboxPreviewInvalidParameterError } from "./types/GetDropboxPreview/GetDropboxPreviewError";
import { UnauthorizedError as GetDropboxPreviewUnauthorizedError } from "./types/GetDropboxPreview/GetDropboxPreviewError";
import { PasswordDoesNotMatchError as GetDropboxPreviewPasswordDoesNotMatchError } from "./types/GetDropboxPreview/GetDropboxPreviewError";
import { InvalidSubscriptionError as GetDropboxPreviewInvalidSubscriptionError } from "./types/GetDropboxPreview/GetDropboxPreviewError";
import { OwnerUsageExceededError as GetDropboxPreviewOwnerUsageExceededError } from "./types/GetDropboxPreview/GetDropboxPreviewError";
import { DropboxDisabledError as GetDropboxPreviewDropboxDisabledError } from "./types/GetDropboxPreview/GetDropboxPreviewError";
import { DropboxDeletedError as GetDropboxPreviewDropboxDeletedError } from "./types/GetDropboxPreview/GetDropboxPreviewError";
import { DropboxMaxTransferCountError as GetDropboxPreviewDropboxMaxTransferCountError } from "./types/GetDropboxPreview/GetDropboxPreviewError";
import { DropboxMaxBytesUploadedError as GetDropboxPreviewDropboxMaxBytesUploadedError } from "./types/GetDropboxPreview/GetDropboxPreviewError";
import { ForbiddenError as GetDropboxPreviewForbiddenError } from "./types/GetDropboxPreview/GetDropboxPreviewError";
import { NotFoundError as GetDropboxPreviewNotFoundError } from "./types/GetDropboxPreview/GetDropboxPreviewError";
import { InternalServerError as GetDropboxPreviewInternalServerError } from "./types/GetDropboxPreview/GetDropboxPreviewError";
import { BadGatewayError as GetDropboxPreviewBadGatewayError } from "./types/GetDropboxPreview/GetDropboxPreviewError";
import { GatewayTimeoutError as GetDropboxPreviewGatewayTimeoutError } from "./types/GetDropboxPreview/GetDropboxPreviewError";
import { GenericError as GetManualReviewGenericError } from "./types/GetManualReview/GetManualReviewError";
import { InvalidParameterError as GetManualReviewInvalidParameterError } from "./types/GetManualReview/GetManualReviewError";
import { UnauthorizedError as GetManualReviewUnauthorizedError } from "./types/GetManualReview/GetManualReviewError";
import { ForbiddenError as GetManualReviewForbiddenError } from "./types/GetManualReview/GetManualReviewError";
import { NotFoundError as GetManualReviewNotFoundError } from "./types/GetManualReview/GetManualReviewError";
import { InternalServerError as GetManualReviewInternalServerError } from "./types/GetManualReview/GetManualReviewError";
import { BadGatewayError as GetManualReviewBadGatewayError } from "./types/GetManualReview/GetManualReviewError";
import { GatewayTimeoutError as GetManualReviewGatewayTimeoutError } from "./types/GetManualReview/GetManualReviewError";
import { GenericError as GetMetricStatisticGenericError } from "./types/GetMetricStatistic/GetMetricStatisticError";
import { InvalidParameterError as GetMetricStatisticInvalidParameterError } from "./types/GetMetricStatistic/GetMetricStatisticError";
import { UnauthorizedError as GetMetricStatisticUnauthorizedError } from "./types/GetMetricStatistic/GetMetricStatisticError";
import { ForbiddenError as GetMetricStatisticForbiddenError } from "./types/GetMetricStatistic/GetMetricStatisticError";
import { InternalServerError as GetMetricStatisticInternalServerError } from "./types/GetMetricStatistic/GetMetricStatisticError";
import { BadGatewayError as GetMetricStatisticBadGatewayError } from "./types/GetMetricStatistic/GetMetricStatisticError";
import { GatewayTimeoutError as GetMetricStatisticGatewayTimeoutError } from "./types/GetMetricStatistic/GetMetricStatisticError";
import { GenericError as GetReceiptGenericError } from "./types/GetReceipt/GetReceiptError";
import { InvalidParameterError as GetReceiptInvalidParameterError } from "./types/GetReceipt/GetReceiptError";
import { UnauthorizedError as GetReceiptUnauthorizedError } from "./types/GetReceipt/GetReceiptError";
import { ForbiddenError as GetReceiptForbiddenError } from "./types/GetReceipt/GetReceiptError";
import { NotFoundError as GetReceiptNotFoundError } from "./types/GetReceipt/GetReceiptError";
import { InternalServerError as GetReceiptInternalServerError } from "./types/GetReceipt/GetReceiptError";
import { BadGatewayError as GetReceiptBadGatewayError } from "./types/GetReceipt/GetReceiptError";
import { GatewayTimeoutError as GetReceiptGatewayTimeoutError } from "./types/GetReceipt/GetReceiptError";
import { GenericError as GetReceiptFileGenericError } from "./types/GetReceiptFile/GetReceiptFileError";
import { InvalidParameterError as GetReceiptFileInvalidParameterError } from "./types/GetReceiptFile/GetReceiptFileError";
import { UnauthorizedError as GetReceiptFileUnauthorizedError } from "./types/GetReceiptFile/GetReceiptFileError";
import { ForbiddenError as GetReceiptFileForbiddenError } from "./types/GetReceiptFile/GetReceiptFileError";
import { NotFoundError as GetReceiptFileNotFoundError } from "./types/GetReceiptFile/GetReceiptFileError";
import { InternalServerError as GetReceiptFileInternalServerError } from "./types/GetReceiptFile/GetReceiptFileError";
import { BadGatewayError as GetReceiptFileBadGatewayError } from "./types/GetReceiptFile/GetReceiptFileError";
import { GatewayTimeoutError as GetReceiptFileGatewayTimeoutError } from "./types/GetReceiptFile/GetReceiptFileError";
import { GenericError as GetReceiverGenericError } from "./types/GetReceiver/GetReceiverError";
import { InvalidParameterError as GetReceiverInvalidParameterError } from "./types/GetReceiver/GetReceiverError";
import { UnauthorizedError as GetReceiverUnauthorizedError } from "./types/GetReceiver/GetReceiverError";
import { ForbiddenError as GetReceiverForbiddenError } from "./types/GetReceiver/GetReceiverError";
import { InternalServerError as GetReceiverInternalServerError } from "./types/GetReceiver/GetReceiverError";
import { BadGatewayError as GetReceiverBadGatewayError } from "./types/GetReceiver/GetReceiverError";
import { GatewayTimeoutError as GetReceiverGatewayTimeoutError } from "./types/GetReceiver/GetReceiverError";
import { GenericError as GetReportGenericError } from "./types/GetReport/GetReportError";
import { InvalidParameterError as GetReportInvalidParameterError } from "./types/GetReport/GetReportError";
import { UnauthorizedError as GetReportUnauthorizedError } from "./types/GetReport/GetReportError";
import { ForbiddenError as GetReportForbiddenError } from "./types/GetReport/GetReportError";
import { NotFoundError as GetReportNotFoundError } from "./types/GetReport/GetReportError";
import { InternalServerError as GetReportInternalServerError } from "./types/GetReport/GetReportError";
import { BadGatewayError as GetReportBadGatewayError } from "./types/GetReport/GetReportError";
import { GatewayTimeoutError as GetReportGatewayTimeoutError } from "./types/GetReport/GetReportError";
import { GenericError as GetSenderGenericError } from "./types/GetSender/GetSenderError";
import { InvalidParameterError as GetSenderInvalidParameterError } from "./types/GetSender/GetSenderError";
import { UnauthorizedError as GetSenderUnauthorizedError } from "./types/GetSender/GetSenderError";
import { ForbiddenError as GetSenderForbiddenError } from "./types/GetSender/GetSenderError";
import { InternalServerError as GetSenderInternalServerError } from "./types/GetSender/GetSenderError";
import { BadGatewayError as GetSenderBadGatewayError } from "./types/GetSender/GetSenderError";
import { GatewayTimeoutError as GetSenderGatewayTimeoutError } from "./types/GetSender/GetSenderError";
import { GenericError as GetTeamDropboxGenericError } from "./types/GetTeamDropbox/GetTeamDropboxError";
import { InvalidParameterError as GetTeamDropboxInvalidParameterError } from "./types/GetTeamDropbox/GetTeamDropboxError";
import { UnauthorizedError as GetTeamDropboxUnauthorizedError } from "./types/GetTeamDropbox/GetTeamDropboxError";
import { ForbiddenError as GetTeamDropboxForbiddenError } from "./types/GetTeamDropbox/GetTeamDropboxError";
import { NotFoundError as GetTeamDropboxNotFoundError } from "./types/GetTeamDropbox/GetTeamDropboxError";
import { InternalServerError as GetTeamDropboxInternalServerError } from "./types/GetTeamDropbox/GetTeamDropboxError";
import { BadGatewayError as GetTeamDropboxBadGatewayError } from "./types/GetTeamDropbox/GetTeamDropboxError";
import { GatewayTimeoutError as GetTeamDropboxGatewayTimeoutError } from "./types/GetTeamDropbox/GetTeamDropboxError";
import { GenericError as GetTeamMetricStatisticGenericError } from "./types/GetTeamMetricStatistic/GetTeamMetricStatisticError";
import { InvalidParameterError as GetTeamMetricStatisticInvalidParameterError } from "./types/GetTeamMetricStatistic/GetTeamMetricStatisticError";
import { UnauthorizedError as GetTeamMetricStatisticUnauthorizedError } from "./types/GetTeamMetricStatistic/GetTeamMetricStatisticError";
import { ForbiddenError as GetTeamMetricStatisticForbiddenError } from "./types/GetTeamMetricStatistic/GetTeamMetricStatisticError";
import { InternalServerError as GetTeamMetricStatisticInternalServerError } from "./types/GetTeamMetricStatistic/GetTeamMetricStatisticError";
import { BadGatewayError as GetTeamMetricStatisticBadGatewayError } from "./types/GetTeamMetricStatistic/GetTeamMetricStatisticError";
import { GatewayTimeoutError as GetTeamMetricStatisticGatewayTimeoutError } from "./types/GetTeamMetricStatistic/GetTeamMetricStatisticError";
import { GenericError as GetTeamReceiptGenericError } from "./types/GetTeamReceipt/GetTeamReceiptError";
import { InvalidParameterError as GetTeamReceiptInvalidParameterError } from "./types/GetTeamReceipt/GetTeamReceiptError";
import { UnauthorizedError as GetTeamReceiptUnauthorizedError } from "./types/GetTeamReceipt/GetTeamReceiptError";
import { ForbiddenError as GetTeamReceiptForbiddenError } from "./types/GetTeamReceipt/GetTeamReceiptError";
import { NotFoundError as GetTeamReceiptNotFoundError } from "./types/GetTeamReceipt/GetTeamReceiptError";
import { InternalServerError as GetTeamReceiptInternalServerError } from "./types/GetTeamReceipt/GetTeamReceiptError";
import { BadGatewayError as GetTeamReceiptBadGatewayError } from "./types/GetTeamReceipt/GetTeamReceiptError";
import { GatewayTimeoutError as GetTeamReceiptGatewayTimeoutError } from "./types/GetTeamReceipt/GetTeamReceiptError";
import { GenericError as GetTeamReceiptFileGenericError } from "./types/GetTeamReceiptFile/GetTeamReceiptFileError";
import { InvalidParameterError as GetTeamReceiptFileInvalidParameterError } from "./types/GetTeamReceiptFile/GetTeamReceiptFileError";
import { UnauthorizedError as GetTeamReceiptFileUnauthorizedError } from "./types/GetTeamReceiptFile/GetTeamReceiptFileError";
import { ForbiddenError as GetTeamReceiptFileForbiddenError } from "./types/GetTeamReceiptFile/GetTeamReceiptFileError";
import { NotFoundError as GetTeamReceiptFileNotFoundError } from "./types/GetTeamReceiptFile/GetTeamReceiptFileError";
import { InternalServerError as GetTeamReceiptFileInternalServerError } from "./types/GetTeamReceiptFile/GetTeamReceiptFileError";
import { BadGatewayError as GetTeamReceiptFileBadGatewayError } from "./types/GetTeamReceiptFile/GetTeamReceiptFileError";
import { GatewayTimeoutError as GetTeamReceiptFileGatewayTimeoutError } from "./types/GetTeamReceiptFile/GetTeamReceiptFileError";
import { GenericError as GetTeamTransferGenericError } from "./types/GetTeamTransfer/GetTeamTransferError";
import { InvalidParameterError as GetTeamTransferInvalidParameterError } from "./types/GetTeamTransfer/GetTeamTransferError";
import { UnauthorizedError as GetTeamTransferUnauthorizedError } from "./types/GetTeamTransfer/GetTeamTransferError";
import { ForbiddenError as GetTeamTransferForbiddenError } from "./types/GetTeamTransfer/GetTeamTransferError";
import { NotFoundError as GetTeamTransferNotFoundError } from "./types/GetTeamTransfer/GetTeamTransferError";
import { InternalServerError as GetTeamTransferInternalServerError } from "./types/GetTeamTransfer/GetTeamTransferError";
import { BadGatewayError as GetTeamTransferBadGatewayError } from "./types/GetTeamTransfer/GetTeamTransferError";
import { GatewayTimeoutError as GetTeamTransferGatewayTimeoutError } from "./types/GetTeamTransfer/GetTeamTransferError";
import { GenericError as GetTeamTransferFileGenericError } from "./types/GetTeamTransferFile/GetTeamTransferFileError";
import { InvalidParameterError as GetTeamTransferFileInvalidParameterError } from "./types/GetTeamTransferFile/GetTeamTransferFileError";
import { UnauthorizedError as GetTeamTransferFileUnauthorizedError } from "./types/GetTeamTransferFile/GetTeamTransferFileError";
import { ForbiddenError as GetTeamTransferFileForbiddenError } from "./types/GetTeamTransferFile/GetTeamTransferFileError";
import { NotFoundError as GetTeamTransferFileNotFoundError } from "./types/GetTeamTransferFile/GetTeamTransferFileError";
import { InternalServerError as GetTeamTransferFileInternalServerError } from "./types/GetTeamTransferFile/GetTeamTransferFileError";
import { BadGatewayError as GetTeamTransferFileBadGatewayError } from "./types/GetTeamTransferFile/GetTeamTransferFileError";
import { GatewayTimeoutError as GetTeamTransferFileGatewayTimeoutError } from "./types/GetTeamTransferFile/GetTeamTransferFileError";
import { GenericError as GetTeamTransferQueueGenericError } from "./types/GetTeamTransferQueue/GetTeamTransferQueueError";
import { InvalidParameterError as GetTeamTransferQueueInvalidParameterError } from "./types/GetTeamTransferQueue/GetTeamTransferQueueError";
import { UnauthorizedError as GetTeamTransferQueueUnauthorizedError } from "./types/GetTeamTransferQueue/GetTeamTransferQueueError";
import { ForbiddenError as GetTeamTransferQueueForbiddenError } from "./types/GetTeamTransferQueue/GetTeamTransferQueueError";
import { NotFoundError as GetTeamTransferQueueNotFoundError } from "./types/GetTeamTransferQueue/GetTeamTransferQueueError";
import { InternalServerError as GetTeamTransferQueueInternalServerError } from "./types/GetTeamTransferQueue/GetTeamTransferQueueError";
import { BadGatewayError as GetTeamTransferQueueBadGatewayError } from "./types/GetTeamTransferQueue/GetTeamTransferQueueError";
import { GatewayTimeoutError as GetTeamTransferQueueGatewayTimeoutError } from "./types/GetTeamTransferQueue/GetTeamTransferQueueError";
import { GenericError as GetTeamUsageGenericError } from "./types/GetTeamUsage/GetTeamUsageError";
import { InvalidParameterError as GetTeamUsageInvalidParameterError } from "./types/GetTeamUsage/GetTeamUsageError";
import { UnauthorizedError as GetTeamUsageUnauthorizedError } from "./types/GetTeamUsage/GetTeamUsageError";
import { ForbiddenError as GetTeamUsageForbiddenError } from "./types/GetTeamUsage/GetTeamUsageError";
import { InternalServerError as GetTeamUsageInternalServerError } from "./types/GetTeamUsage/GetTeamUsageError";
import { BadGatewayError as GetTeamUsageBadGatewayError } from "./types/GetTeamUsage/GetTeamUsageError";
import { GatewayTimeoutError as GetTeamUsageGatewayTimeoutError } from "./types/GetTeamUsage/GetTeamUsageError";
import { GenericError as GetTeamUserDropboxGenericError } from "./types/GetTeamUserDropbox/GetTeamUserDropboxError";
import { InvalidParameterError as GetTeamUserDropboxInvalidParameterError } from "./types/GetTeamUserDropbox/GetTeamUserDropboxError";
import { UnauthorizedError as GetTeamUserDropboxUnauthorizedError } from "./types/GetTeamUserDropbox/GetTeamUserDropboxError";
import { ForbiddenError as GetTeamUserDropboxForbiddenError } from "./types/GetTeamUserDropbox/GetTeamUserDropboxError";
import { NotFoundError as GetTeamUserDropboxNotFoundError } from "./types/GetTeamUserDropbox/GetTeamUserDropboxError";
import { InternalServerError as GetTeamUserDropboxInternalServerError } from "./types/GetTeamUserDropbox/GetTeamUserDropboxError";
import { BadGatewayError as GetTeamUserDropboxBadGatewayError } from "./types/GetTeamUserDropbox/GetTeamUserDropboxError";
import { GatewayTimeoutError as GetTeamUserDropboxGatewayTimeoutError } from "./types/GetTeamUserDropbox/GetTeamUserDropboxError";
import { GenericError as GetTeamUserMetricStatisticGenericError } from "./types/GetTeamUserMetricStatistic/GetTeamUserMetricStatisticError";
import { InvalidParameterError as GetTeamUserMetricStatisticInvalidParameterError } from "./types/GetTeamUserMetricStatistic/GetTeamUserMetricStatisticError";
import { UnauthorizedError as GetTeamUserMetricStatisticUnauthorizedError } from "./types/GetTeamUserMetricStatistic/GetTeamUserMetricStatisticError";
import { ForbiddenError as GetTeamUserMetricStatisticForbiddenError } from "./types/GetTeamUserMetricStatistic/GetTeamUserMetricStatisticError";
import { InternalServerError as GetTeamUserMetricStatisticInternalServerError } from "./types/GetTeamUserMetricStatistic/GetTeamUserMetricStatisticError";
import { BadGatewayError as GetTeamUserMetricStatisticBadGatewayError } from "./types/GetTeamUserMetricStatistic/GetTeamUserMetricStatisticError";
import { GatewayTimeoutError as GetTeamUserMetricStatisticGatewayTimeoutError } from "./types/GetTeamUserMetricStatistic/GetTeamUserMetricStatisticError";
import { GenericError as GetTeamUserReceiptGenericError } from "./types/GetTeamUserReceipt/GetTeamUserReceiptError";
import { InvalidParameterError as GetTeamUserReceiptInvalidParameterError } from "./types/GetTeamUserReceipt/GetTeamUserReceiptError";
import { UnauthorizedError as GetTeamUserReceiptUnauthorizedError } from "./types/GetTeamUserReceipt/GetTeamUserReceiptError";
import { ForbiddenError as GetTeamUserReceiptForbiddenError } from "./types/GetTeamUserReceipt/GetTeamUserReceiptError";
import { NotFoundError as GetTeamUserReceiptNotFoundError } from "./types/GetTeamUserReceipt/GetTeamUserReceiptError";
import { InternalServerError as GetTeamUserReceiptInternalServerError } from "./types/GetTeamUserReceipt/GetTeamUserReceiptError";
import { BadGatewayError as GetTeamUserReceiptBadGatewayError } from "./types/GetTeamUserReceipt/GetTeamUserReceiptError";
import { GatewayTimeoutError as GetTeamUserReceiptGatewayTimeoutError } from "./types/GetTeamUserReceipt/GetTeamUserReceiptError";
import { GenericError as GetTeamUserReceiptFileGenericError } from "./types/GetTeamUserReceiptFile/GetTeamUserReceiptFileError";
import { InvalidParameterError as GetTeamUserReceiptFileInvalidParameterError } from "./types/GetTeamUserReceiptFile/GetTeamUserReceiptFileError";
import { UnauthorizedError as GetTeamUserReceiptFileUnauthorizedError } from "./types/GetTeamUserReceiptFile/GetTeamUserReceiptFileError";
import { ForbiddenError as GetTeamUserReceiptFileForbiddenError } from "./types/GetTeamUserReceiptFile/GetTeamUserReceiptFileError";
import { NotFoundError as GetTeamUserReceiptFileNotFoundError } from "./types/GetTeamUserReceiptFile/GetTeamUserReceiptFileError";
import { InternalServerError as GetTeamUserReceiptFileInternalServerError } from "./types/GetTeamUserReceiptFile/GetTeamUserReceiptFileError";
import { BadGatewayError as GetTeamUserReceiptFileBadGatewayError } from "./types/GetTeamUserReceiptFile/GetTeamUserReceiptFileError";
import { GatewayTimeoutError as GetTeamUserReceiptFileGatewayTimeoutError } from "./types/GetTeamUserReceiptFile/GetTeamUserReceiptFileError";
import { GenericError as GetTeamUserTransferGenericError } from "./types/GetTeamUserTransfer/GetTeamUserTransferError";
import { InvalidParameterError as GetTeamUserTransferInvalidParameterError } from "./types/GetTeamUserTransfer/GetTeamUserTransferError";
import { UnauthorizedError as GetTeamUserTransferUnauthorizedError } from "./types/GetTeamUserTransfer/GetTeamUserTransferError";
import { ForbiddenError as GetTeamUserTransferForbiddenError } from "./types/GetTeamUserTransfer/GetTeamUserTransferError";
import { NotFoundError as GetTeamUserTransferNotFoundError } from "./types/GetTeamUserTransfer/GetTeamUserTransferError";
import { InternalServerError as GetTeamUserTransferInternalServerError } from "./types/GetTeamUserTransfer/GetTeamUserTransferError";
import { BadGatewayError as GetTeamUserTransferBadGatewayError } from "./types/GetTeamUserTransfer/GetTeamUserTransferError";
import { GatewayTimeoutError as GetTeamUserTransferGatewayTimeoutError } from "./types/GetTeamUserTransfer/GetTeamUserTransferError";
import { GenericError as GetTeamUserUsageGenericError } from "./types/GetTeamUserUsage/GetTeamUserUsageError";
import { InvalidParameterError as GetTeamUserUsageInvalidParameterError } from "./types/GetTeamUserUsage/GetTeamUserUsageError";
import { UnauthorizedError as GetTeamUserUsageUnauthorizedError } from "./types/GetTeamUserUsage/GetTeamUserUsageError";
import { ForbiddenError as GetTeamUserUsageForbiddenError } from "./types/GetTeamUserUsage/GetTeamUserUsageError";
import { InternalServerError as GetTeamUserUsageInternalServerError } from "./types/GetTeamUserUsage/GetTeamUserUsageError";
import { BadGatewayError as GetTeamUserUsageBadGatewayError } from "./types/GetTeamUserUsage/GetTeamUserUsageError";
import { GatewayTimeoutError as GetTeamUserUsageGatewayTimeoutError } from "./types/GetTeamUserUsage/GetTeamUserUsageError";
import { GenericError as GetTransferGenericError } from "./types/GetTransfer/GetTransferError";
import { InvalidParameterError as GetTransferInvalidParameterError } from "./types/GetTransfer/GetTransferError";
import { UnauthorizedError as GetTransferUnauthorizedError } from "./types/GetTransfer/GetTransferError";
import { ForbiddenError as GetTransferForbiddenError } from "./types/GetTransfer/GetTransferError";
import { NotFoundError as GetTransferNotFoundError } from "./types/GetTransfer/GetTransferError";
import { InternalServerError as GetTransferInternalServerError } from "./types/GetTransfer/GetTransferError";
import { BadGatewayError as GetTransferBadGatewayError } from "./types/GetTransfer/GetTransferError";
import { GatewayTimeoutError as GetTransferGatewayTimeoutError } from "./types/GetTransfer/GetTransferError";
import { GenericError as GetTransferFileGenericError } from "./types/GetTransferFile/GetTransferFileError";
import { InvalidParameterError as GetTransferFileInvalidParameterError } from "./types/GetTransferFile/GetTransferFileError";
import { UnauthorizedError as GetTransferFileUnauthorizedError } from "./types/GetTransferFile/GetTransferFileError";
import { ForbiddenError as GetTransferFileForbiddenError } from "./types/GetTransferFile/GetTransferFileError";
import { NotFoundError as GetTransferFileNotFoundError } from "./types/GetTransferFile/GetTransferFileError";
import { InternalServerError as GetTransferFileInternalServerError } from "./types/GetTransferFile/GetTransferFileError";
import { BadGatewayError as GetTransferFileBadGatewayError } from "./types/GetTransferFile/GetTransferFileError";
import { GatewayTimeoutError as GetTransferFileGatewayTimeoutError } from "./types/GetTransferFile/GetTransferFileError";
import { GenericError as GetTransferFileInternalGenericError } from "./types/GetTransferFileInternal/GetTransferFileInternalError";
import { InvalidParameterError as GetTransferFileInternalInvalidParameterError } from "./types/GetTransferFileInternal/GetTransferFileInternalError";
import { UnauthorizedError as GetTransferFileInternalUnauthorizedError } from "./types/GetTransferFileInternal/GetTransferFileInternalError";
import { ForbiddenError as GetTransferFileInternalForbiddenError } from "./types/GetTransferFileInternal/GetTransferFileInternalError";
import { NotFoundError as GetTransferFileInternalNotFoundError } from "./types/GetTransferFileInternal/GetTransferFileInternalError";
import { InternalServerError as GetTransferFileInternalInternalServerError } from "./types/GetTransferFileInternal/GetTransferFileInternalError";
import { BadGatewayError as GetTransferFileInternalBadGatewayError } from "./types/GetTransferFileInternal/GetTransferFileInternalError";
import { GatewayTimeoutError as GetTransferFileInternalGatewayTimeoutError } from "./types/GetTransferFileInternal/GetTransferFileInternalError";
import { GenericError as GetTransferFilePreviewGenericError } from "./types/GetTransferFilePreview/GetTransferFilePreviewError";
import { InvalidParameterError as GetTransferFilePreviewInvalidParameterError } from "./types/GetTransferFilePreview/GetTransferFilePreviewError";
import { UnauthorizedError as GetTransferFilePreviewUnauthorizedError } from "./types/GetTransferFilePreview/GetTransferFilePreviewError";
import { PasswordDoesNotMatchError as GetTransferFilePreviewPasswordDoesNotMatchError } from "./types/GetTransferFilePreview/GetTransferFilePreviewError";
import { ForbiddenError as GetTransferFilePreviewForbiddenError } from "./types/GetTransferFilePreview/GetTransferFilePreviewError";
import { NotFoundError as GetTransferFilePreviewNotFoundError } from "./types/GetTransferFilePreview/GetTransferFilePreviewError";
import { InternalServerError as GetTransferFilePreviewInternalServerError } from "./types/GetTransferFilePreview/GetTransferFilePreviewError";
import { BadGatewayError as GetTransferFilePreviewBadGatewayError } from "./types/GetTransferFilePreview/GetTransferFilePreviewError";
import { GatewayTimeoutError as GetTransferFilePreviewGatewayTimeoutError } from "./types/GetTransferFilePreview/GetTransferFilePreviewError";
import { GenericError as GetTransferInternalGenericError } from "./types/GetTransferInternal/GetTransferInternalError";
import { InvalidParameterError as GetTransferInternalInvalidParameterError } from "./types/GetTransferInternal/GetTransferInternalError";
import { UnauthorizedError as GetTransferInternalUnauthorizedError } from "./types/GetTransferInternal/GetTransferInternalError";
import { ForbiddenError as GetTransferInternalForbiddenError } from "./types/GetTransferInternal/GetTransferInternalError";
import { NotFoundError as GetTransferInternalNotFoundError } from "./types/GetTransferInternal/GetTransferInternalError";
import { InternalServerError as GetTransferInternalInternalServerError } from "./types/GetTransferInternal/GetTransferInternalError";
import { BadGatewayError as GetTransferInternalBadGatewayError } from "./types/GetTransferInternal/GetTransferInternalError";
import { GatewayTimeoutError as GetTransferInternalGatewayTimeoutError } from "./types/GetTransferInternal/GetTransferInternalError";
import { GenericError as GetTransferPreviewGenericError } from "./types/GetTransferPreview/GetTransferPreviewError";
import { InvalidParameterError as GetTransferPreviewInvalidParameterError } from "./types/GetTransferPreview/GetTransferPreviewError";
import { UnauthorizedError as GetTransferPreviewUnauthorizedError } from "./types/GetTransferPreview/GetTransferPreviewError";
import { PasswordDoesNotMatchError as GetTransferPreviewPasswordDoesNotMatchError } from "./types/GetTransferPreview/GetTransferPreviewError";
import { InvalidEmailError as GetTransferPreviewInvalidEmailError } from "./types/GetTransferPreview/GetTransferPreviewError";
import { OwnerUsageExceededError as GetTransferPreviewOwnerUsageExceededError } from "./types/GetTransferPreview/GetTransferPreviewError";
import { AccessorUsageExceededError as GetTransferPreviewAccessorUsageExceededError } from "./types/GetTransferPreview/GetTransferPreviewError";
import { ForbiddenError as GetTransferPreviewForbiddenError } from "./types/GetTransferPreview/GetTransferPreviewError";
import { NotFoundError as GetTransferPreviewNotFoundError } from "./types/GetTransferPreview/GetTransferPreviewError";
import { InternalServerError as GetTransferPreviewInternalServerError } from "./types/GetTransferPreview/GetTransferPreviewError";
import { BadGatewayError as GetTransferPreviewBadGatewayError } from "./types/GetTransferPreview/GetTransferPreviewError";
import { GatewayTimeoutError as GetTransferPreviewGatewayTimeoutError } from "./types/GetTransferPreview/GetTransferPreviewError";
import { GenericError as GetTransferQueueGenericError } from "./types/GetTransferQueue/GetTransferQueueError";
import { InvalidParameterError as GetTransferQueueInvalidParameterError } from "./types/GetTransferQueue/GetTransferQueueError";
import { UnauthorizedError as GetTransferQueueUnauthorizedError } from "./types/GetTransferQueue/GetTransferQueueError";
import { ForbiddenError as GetTransferQueueForbiddenError } from "./types/GetTransferQueue/GetTransferQueueError";
import { NotFoundError as GetTransferQueueNotFoundError } from "./types/GetTransferQueue/GetTransferQueueError";
import { InternalServerError as GetTransferQueueInternalServerError } from "./types/GetTransferQueue/GetTransferQueueError";
import { BadGatewayError as GetTransferQueueBadGatewayError } from "./types/GetTransferQueue/GetTransferQueueError";
import { GatewayTimeoutError as GetTransferQueueGatewayTimeoutError } from "./types/GetTransferQueue/GetTransferQueueError";
import { GenericError as GetTransferUserGenericError } from "./types/GetTransferUser/GetTransferUserError";
import { InvalidParameterError as GetTransferUserInvalidParameterError } from "./types/GetTransferUser/GetTransferUserError";
import { UnauthorizedError as GetTransferUserUnauthorizedError } from "./types/GetTransferUser/GetTransferUserError";
import { ForbiddenError as GetTransferUserForbiddenError } from "./types/GetTransferUser/GetTransferUserError";
import { NotFoundError as GetTransferUserNotFoundError } from "./types/GetTransferUser/GetTransferUserError";
import { InternalServerError as GetTransferUserInternalServerError } from "./types/GetTransferUser/GetTransferUserError";
import { BadGatewayError as GetTransferUserBadGatewayError } from "./types/GetTransferUser/GetTransferUserError";
import { GatewayTimeoutError as GetTransferUserGatewayTimeoutError } from "./types/GetTransferUser/GetTransferUserError";
import { GenericError as GetUsageGenericError } from "./types/GetUsage/GetUsageError";
import { UnauthorizedError as GetUsageUnauthorizedError } from "./types/GetUsage/GetUsageError";
import { ForbiddenError as GetUsageForbiddenError } from "./types/GetUsage/GetUsageError";
import { InternalServerError as GetUsageInternalServerError } from "./types/GetUsage/GetUsageError";
import { BadGatewayError as GetUsageBadGatewayError } from "./types/GetUsage/GetUsageError";
import { GatewayTimeoutError as GetUsageGatewayTimeoutError } from "./types/GetUsage/GetUsageError";
import { GenericError as GetUserDropboxGenericError } from "./types/GetUserDropbox/GetUserDropboxError";
import { InvalidParameterError as GetUserDropboxInvalidParameterError } from "./types/GetUserDropbox/GetUserDropboxError";
import { UnauthorizedError as GetUserDropboxUnauthorizedError } from "./types/GetUserDropbox/GetUserDropboxError";
import { ForbiddenError as GetUserDropboxForbiddenError } from "./types/GetUserDropbox/GetUserDropboxError";
import { NotFoundError as GetUserDropboxNotFoundError } from "./types/GetUserDropbox/GetUserDropboxError";
import { InternalServerError as GetUserDropboxInternalServerError } from "./types/GetUserDropbox/GetUserDropboxError";
import { BadGatewayError as GetUserDropboxBadGatewayError } from "./types/GetUserDropbox/GetUserDropboxError";
import { GatewayTimeoutError as GetUserDropboxGatewayTimeoutError } from "./types/GetUserDropbox/GetUserDropboxError";
import { GenericError as GetUserMetricStatisticGenericError } from "./types/GetUserMetricStatistic/GetUserMetricStatisticError";
import { InvalidParameterError as GetUserMetricStatisticInvalidParameterError } from "./types/GetUserMetricStatistic/GetUserMetricStatisticError";
import { UnauthorizedError as GetUserMetricStatisticUnauthorizedError } from "./types/GetUserMetricStatistic/GetUserMetricStatisticError";
import { ForbiddenError as GetUserMetricStatisticForbiddenError } from "./types/GetUserMetricStatistic/GetUserMetricStatisticError";
import { InternalServerError as GetUserMetricStatisticInternalServerError } from "./types/GetUserMetricStatistic/GetUserMetricStatisticError";
import { BadGatewayError as GetUserMetricStatisticBadGatewayError } from "./types/GetUserMetricStatistic/GetUserMetricStatisticError";
import { GatewayTimeoutError as GetUserMetricStatisticGatewayTimeoutError } from "./types/GetUserMetricStatistic/GetUserMetricStatisticError";
import { GenericError as GetUserReceiptGenericError } from "./types/GetUserReceipt/GetUserReceiptError";
import { InvalidParameterError as GetUserReceiptInvalidParameterError } from "./types/GetUserReceipt/GetUserReceiptError";
import { UnauthorizedError as GetUserReceiptUnauthorizedError } from "./types/GetUserReceipt/GetUserReceiptError";
import { ForbiddenError as GetUserReceiptForbiddenError } from "./types/GetUserReceipt/GetUserReceiptError";
import { NotFoundError as GetUserReceiptNotFoundError } from "./types/GetUserReceipt/GetUserReceiptError";
import { InternalServerError as GetUserReceiptInternalServerError } from "./types/GetUserReceipt/GetUserReceiptError";
import { BadGatewayError as GetUserReceiptBadGatewayError } from "./types/GetUserReceipt/GetUserReceiptError";
import { GatewayTimeoutError as GetUserReceiptGatewayTimeoutError } from "./types/GetUserReceipt/GetUserReceiptError";
import { GenericError as GetUserReceiptFileGenericError } from "./types/GetUserReceiptFile/GetUserReceiptFileError";
import { InvalidParameterError as GetUserReceiptFileInvalidParameterError } from "./types/GetUserReceiptFile/GetUserReceiptFileError";
import { UnauthorizedError as GetUserReceiptFileUnauthorizedError } from "./types/GetUserReceiptFile/GetUserReceiptFileError";
import { ForbiddenError as GetUserReceiptFileForbiddenError } from "./types/GetUserReceiptFile/GetUserReceiptFileError";
import { NotFoundError as GetUserReceiptFileNotFoundError } from "./types/GetUserReceiptFile/GetUserReceiptFileError";
import { InternalServerError as GetUserReceiptFileInternalServerError } from "./types/GetUserReceiptFile/GetUserReceiptFileError";
import { BadGatewayError as GetUserReceiptFileBadGatewayError } from "./types/GetUserReceiptFile/GetUserReceiptFileError";
import { GatewayTimeoutError as GetUserReceiptFileGatewayTimeoutError } from "./types/GetUserReceiptFile/GetUserReceiptFileError";
import { GenericError as GetUserTransferGenericError } from "./types/GetUserTransfer/GetUserTransferError";
import { InvalidParameterError as GetUserTransferInvalidParameterError } from "./types/GetUserTransfer/GetUserTransferError";
import { UnauthorizedError as GetUserTransferUnauthorizedError } from "./types/GetUserTransfer/GetUserTransferError";
import { ForbiddenError as GetUserTransferForbiddenError } from "./types/GetUserTransfer/GetUserTransferError";
import { NotFoundError as GetUserTransferNotFoundError } from "./types/GetUserTransfer/GetUserTransferError";
import { InternalServerError as GetUserTransferInternalServerError } from "./types/GetUserTransfer/GetUserTransferError";
import { BadGatewayError as GetUserTransferBadGatewayError } from "./types/GetUserTransfer/GetUserTransferError";
import { GatewayTimeoutError as GetUserTransferGatewayTimeoutError } from "./types/GetUserTransfer/GetUserTransferError";
import { GenericError as GetUserTransferFileGenericError } from "./types/GetUserTransferFile/GetUserTransferFileError";
import { InvalidParameterError as GetUserTransferFileInvalidParameterError } from "./types/GetUserTransferFile/GetUserTransferFileError";
import { UnauthorizedError as GetUserTransferFileUnauthorizedError } from "./types/GetUserTransferFile/GetUserTransferFileError";
import { ForbiddenError as GetUserTransferFileForbiddenError } from "./types/GetUserTransferFile/GetUserTransferFileError";
import { NotFoundError as GetUserTransferFileNotFoundError } from "./types/GetUserTransferFile/GetUserTransferFileError";
import { InternalServerError as GetUserTransferFileInternalServerError } from "./types/GetUserTransferFile/GetUserTransferFileError";
import { BadGatewayError as GetUserTransferFileBadGatewayError } from "./types/GetUserTransferFile/GetUserTransferFileError";
import { GatewayTimeoutError as GetUserTransferFileGatewayTimeoutError } from "./types/GetUserTransferFile/GetUserTransferFileError";
import { GenericError as GetUserUsageGenericError } from "./types/GetUserUsage/GetUserUsageError";
import { InvalidParameterError as GetUserUsageInvalidParameterError } from "./types/GetUserUsage/GetUserUsageError";
import { UnauthorizedError as GetUserUsageUnauthorizedError } from "./types/GetUserUsage/GetUserUsageError";
import { ForbiddenError as GetUserUsageForbiddenError } from "./types/GetUserUsage/GetUserUsageError";
import { InternalServerError as GetUserUsageInternalServerError } from "./types/GetUserUsage/GetUserUsageError";
import { BadGatewayError as GetUserUsageBadGatewayError } from "./types/GetUserUsage/GetUserUsageError";
import { GatewayTimeoutError as GetUserUsageGatewayTimeoutError } from "./types/GetUserUsage/GetUserUsageError";
import { GenericError as ListAccountTransfersGenericError } from "./types/ListAccountTransfers/ListAccountTransfersError";
import { InvalidParameterError as ListAccountTransfersInvalidParameterError } from "./types/ListAccountTransfers/ListAccountTransfersError";
import { UnauthorizedError as ListAccountTransfersUnauthorizedError } from "./types/ListAccountTransfers/ListAccountTransfersError";
import { ForbiddenError as ListAccountTransfersForbiddenError } from "./types/ListAccountTransfers/ListAccountTransfersError";
import { InternalServerError as ListAccountTransfersInternalServerError } from "./types/ListAccountTransfers/ListAccountTransfersError";
import { BadGatewayError as ListAccountTransfersBadGatewayError } from "./types/ListAccountTransfers/ListAccountTransfersError";
import { GatewayTimeoutError as ListAccountTransfersGatewayTimeoutError } from "./types/ListAccountTransfers/ListAccountTransfersError";
import { GenericError as ListDayEventsGenericError } from "./types/ListDayEvents/ListDayEventsError";
import { InvalidParameterError as ListDayEventsInvalidParameterError } from "./types/ListDayEvents/ListDayEventsError";
import { UnauthorizedError as ListDayEventsUnauthorizedError } from "./types/ListDayEvents/ListDayEventsError";
import { ForbiddenError as ListDayEventsForbiddenError } from "./types/ListDayEvents/ListDayEventsError";
import { InternalServerError as ListDayEventsInternalServerError } from "./types/ListDayEvents/ListDayEventsError";
import { BadGatewayError as ListDayEventsBadGatewayError } from "./types/ListDayEvents/ListDayEventsError";
import { GatewayTimeoutError as ListDayEventsGatewayTimeoutError } from "./types/ListDayEvents/ListDayEventsError";
import { GenericError as ListDayFilesGenericError } from "./types/ListDayFiles/ListDayFilesError";
import { InvalidParameterError as ListDayFilesInvalidParameterError } from "./types/ListDayFiles/ListDayFilesError";
import { UnauthorizedError as ListDayFilesUnauthorizedError } from "./types/ListDayFiles/ListDayFilesError";
import { ForbiddenError as ListDayFilesForbiddenError } from "./types/ListDayFiles/ListDayFilesError";
import { InternalServerError as ListDayFilesInternalServerError } from "./types/ListDayFiles/ListDayFilesError";
import { BadGatewayError as ListDayFilesBadGatewayError } from "./types/ListDayFiles/ListDayFilesError";
import { GatewayTimeoutError as ListDayFilesGatewayTimeoutError } from "./types/ListDayFiles/ListDayFilesError";
import { GenericError as ListDayTransfersGenericError } from "./types/ListDayTransfers/ListDayTransfersError";
import { InvalidParameterError as ListDayTransfersInvalidParameterError } from "./types/ListDayTransfers/ListDayTransfersError";
import { UnauthorizedError as ListDayTransfersUnauthorizedError } from "./types/ListDayTransfers/ListDayTransfersError";
import { ForbiddenError as ListDayTransfersForbiddenError } from "./types/ListDayTransfers/ListDayTransfersError";
import { InternalServerError as ListDayTransfersInternalServerError } from "./types/ListDayTransfers/ListDayTransfersError";
import { BadGatewayError as ListDayTransfersBadGatewayError } from "./types/ListDayTransfers/ListDayTransfersError";
import { GatewayTimeoutError as ListDayTransfersGatewayTimeoutError } from "./types/ListDayTransfers/ListDayTransfersError";
import { GenericError as ListDropboxesGenericError } from "./types/ListDropboxes/ListDropboxesError";
import { InvalidParameterError as ListDropboxesInvalidParameterError } from "./types/ListDropboxes/ListDropboxesError";
import { UnauthorizedError as ListDropboxesUnauthorizedError } from "./types/ListDropboxes/ListDropboxesError";
import { ForbiddenError as ListDropboxesForbiddenError } from "./types/ListDropboxes/ListDropboxesError";
import { InternalServerError as ListDropboxesInternalServerError } from "./types/ListDropboxes/ListDropboxesError";
import { BadGatewayError as ListDropboxesBadGatewayError } from "./types/ListDropboxes/ListDropboxesError";
import { GatewayTimeoutError as ListDropboxesGatewayTimeoutError } from "./types/ListDropboxes/ListDropboxesError";
import { GenericError as ListHourEventsGenericError } from "./types/ListHourEvents/ListHourEventsError";
import { InvalidParameterError as ListHourEventsInvalidParameterError } from "./types/ListHourEvents/ListHourEventsError";
import { UnauthorizedError as ListHourEventsUnauthorizedError } from "./types/ListHourEvents/ListHourEventsError";
import { ForbiddenError as ListHourEventsForbiddenError } from "./types/ListHourEvents/ListHourEventsError";
import { InternalServerError as ListHourEventsInternalServerError } from "./types/ListHourEvents/ListHourEventsError";
import { BadGatewayError as ListHourEventsBadGatewayError } from "./types/ListHourEvents/ListHourEventsError";
import { GatewayTimeoutError as ListHourEventsGatewayTimeoutError } from "./types/ListHourEvents/ListHourEventsError";
import { GenericError as ListHourFilesGenericError } from "./types/ListHourFiles/ListHourFilesError";
import { InvalidParameterError as ListHourFilesInvalidParameterError } from "./types/ListHourFiles/ListHourFilesError";
import { UnauthorizedError as ListHourFilesUnauthorizedError } from "./types/ListHourFiles/ListHourFilesError";
import { ForbiddenError as ListHourFilesForbiddenError } from "./types/ListHourFiles/ListHourFilesError";
import { InternalServerError as ListHourFilesInternalServerError } from "./types/ListHourFiles/ListHourFilesError";
import { BadGatewayError as ListHourFilesBadGatewayError } from "./types/ListHourFiles/ListHourFilesError";
import { GatewayTimeoutError as ListHourFilesGatewayTimeoutError } from "./types/ListHourFiles/ListHourFilesError";
import { GenericError as ListHourTransfersGenericError } from "./types/ListHourTransfers/ListHourTransfersError";
import { InvalidParameterError as ListHourTransfersInvalidParameterError } from "./types/ListHourTransfers/ListHourTransfersError";
import { UnauthorizedError as ListHourTransfersUnauthorizedError } from "./types/ListHourTransfers/ListHourTransfersError";
import { ForbiddenError as ListHourTransfersForbiddenError } from "./types/ListHourTransfers/ListHourTransfersError";
import { InternalServerError as ListHourTransfersInternalServerError } from "./types/ListHourTransfers/ListHourTransfersError";
import { BadGatewayError as ListHourTransfersBadGatewayError } from "./types/ListHourTransfers/ListHourTransfersError";
import { GatewayTimeoutError as ListHourTransfersGatewayTimeoutError } from "./types/ListHourTransfers/ListHourTransfersError";
import { GenericError as ListManualReviewsGenericError } from "./types/ListManualReviews/ListManualReviewsError";
import { UnauthorizedError as ListManualReviewsUnauthorizedError } from "./types/ListManualReviews/ListManualReviewsError";
import { ForbiddenError as ListManualReviewsForbiddenError } from "./types/ListManualReviews/ListManualReviewsError";
import { InternalServerError as ListManualReviewsInternalServerError } from "./types/ListManualReviews/ListManualReviewsError";
import { BadGatewayError as ListManualReviewsBadGatewayError } from "./types/ListManualReviews/ListManualReviewsError";
import { GatewayTimeoutError as ListManualReviewsGatewayTimeoutError } from "./types/ListManualReviews/ListManualReviewsError";
import { GenericError as ListMonthEventsGenericError } from "./types/ListMonthEvents/ListMonthEventsError";
import { InvalidParameterError as ListMonthEventsInvalidParameterError } from "./types/ListMonthEvents/ListMonthEventsError";
import { UnauthorizedError as ListMonthEventsUnauthorizedError } from "./types/ListMonthEvents/ListMonthEventsError";
import { ForbiddenError as ListMonthEventsForbiddenError } from "./types/ListMonthEvents/ListMonthEventsError";
import { InternalServerError as ListMonthEventsInternalServerError } from "./types/ListMonthEvents/ListMonthEventsError";
import { BadGatewayError as ListMonthEventsBadGatewayError } from "./types/ListMonthEvents/ListMonthEventsError";
import { GatewayTimeoutError as ListMonthEventsGatewayTimeoutError } from "./types/ListMonthEvents/ListMonthEventsError";
import { GenericError as ListMonthFilesGenericError } from "./types/ListMonthFiles/ListMonthFilesError";
import { InvalidParameterError as ListMonthFilesInvalidParameterError } from "./types/ListMonthFiles/ListMonthFilesError";
import { UnauthorizedError as ListMonthFilesUnauthorizedError } from "./types/ListMonthFiles/ListMonthFilesError";
import { ForbiddenError as ListMonthFilesForbiddenError } from "./types/ListMonthFiles/ListMonthFilesError";
import { InternalServerError as ListMonthFilesInternalServerError } from "./types/ListMonthFiles/ListMonthFilesError";
import { BadGatewayError as ListMonthFilesBadGatewayError } from "./types/ListMonthFiles/ListMonthFilesError";
import { GatewayTimeoutError as ListMonthFilesGatewayTimeoutError } from "./types/ListMonthFiles/ListMonthFilesError";
import { GenericError as ListMonthTransfersGenericError } from "./types/ListMonthTransfers/ListMonthTransfersError";
import { InvalidParameterError as ListMonthTransfersInvalidParameterError } from "./types/ListMonthTransfers/ListMonthTransfersError";
import { UnauthorizedError as ListMonthTransfersUnauthorizedError } from "./types/ListMonthTransfers/ListMonthTransfersError";
import { ForbiddenError as ListMonthTransfersForbiddenError } from "./types/ListMonthTransfers/ListMonthTransfersError";
import { InternalServerError as ListMonthTransfersInternalServerError } from "./types/ListMonthTransfers/ListMonthTransfersError";
import { BadGatewayError as ListMonthTransfersBadGatewayError } from "./types/ListMonthTransfers/ListMonthTransfersError";
import { GatewayTimeoutError as ListMonthTransfersGatewayTimeoutError } from "./types/ListMonthTransfers/ListMonthTransfersError";
import { GenericError as ListReceiptFilesGenericError } from "./types/ListReceiptFiles/ListReceiptFilesError";
import { InvalidParameterError as ListReceiptFilesInvalidParameterError } from "./types/ListReceiptFiles/ListReceiptFilesError";
import { UnauthorizedError as ListReceiptFilesUnauthorizedError } from "./types/ListReceiptFiles/ListReceiptFilesError";
import { ForbiddenError as ListReceiptFilesForbiddenError } from "./types/ListReceiptFiles/ListReceiptFilesError";
import { NotFoundError as ListReceiptFilesNotFoundError } from "./types/ListReceiptFiles/ListReceiptFilesError";
import { InternalServerError as ListReceiptFilesInternalServerError } from "./types/ListReceiptFiles/ListReceiptFilesError";
import { BadGatewayError as ListReceiptFilesBadGatewayError } from "./types/ListReceiptFiles/ListReceiptFilesError";
import { GatewayTimeoutError as ListReceiptFilesGatewayTimeoutError } from "./types/ListReceiptFiles/ListReceiptFilesError";
import { GenericError as ListReceiptsGenericError } from "./types/ListReceipts/ListReceiptsError";
import { InvalidParameterError as ListReceiptsInvalidParameterError } from "./types/ListReceipts/ListReceiptsError";
import { UnauthorizedError as ListReceiptsUnauthorizedError } from "./types/ListReceipts/ListReceiptsError";
import { ForbiddenError as ListReceiptsForbiddenError } from "./types/ListReceipts/ListReceiptsError";
import { InternalServerError as ListReceiptsInternalServerError } from "./types/ListReceipts/ListReceiptsError";
import { BadGatewayError as ListReceiptsBadGatewayError } from "./types/ListReceipts/ListReceiptsError";
import { GatewayTimeoutError as ListReceiptsGatewayTimeoutError } from "./types/ListReceipts/ListReceiptsError";
import { GenericError as ListReceiverTransfersGenericError } from "./types/ListReceiverTransfers/ListReceiverTransfersError";
import { InvalidParameterError as ListReceiverTransfersInvalidParameterError } from "./types/ListReceiverTransfers/ListReceiverTransfersError";
import { UnauthorizedError as ListReceiverTransfersUnauthorizedError } from "./types/ListReceiverTransfers/ListReceiverTransfersError";
import { ForbiddenError as ListReceiverTransfersForbiddenError } from "./types/ListReceiverTransfers/ListReceiverTransfersError";
import { NotFoundError as ListReceiverTransfersNotFoundError } from "./types/ListReceiverTransfers/ListReceiverTransfersError";
import { InternalServerError as ListReceiverTransfersInternalServerError } from "./types/ListReceiverTransfers/ListReceiverTransfersError";
import { BadGatewayError as ListReceiverTransfersBadGatewayError } from "./types/ListReceiverTransfers/ListReceiverTransfersError";
import { GatewayTimeoutError as ListReceiverTransfersGatewayTimeoutError } from "./types/ListReceiverTransfers/ListReceiverTransfersError";
import { GenericError as ListSenderTransfersGenericError } from "./types/ListSenderTransfers/ListSenderTransfersError";
import { InvalidParameterError as ListSenderTransfersInvalidParameterError } from "./types/ListSenderTransfers/ListSenderTransfersError";
import { UnauthorizedError as ListSenderTransfersUnauthorizedError } from "./types/ListSenderTransfers/ListSenderTransfersError";
import { ForbiddenError as ListSenderTransfersForbiddenError } from "./types/ListSenderTransfers/ListSenderTransfersError";
import { InternalServerError as ListSenderTransfersInternalServerError } from "./types/ListSenderTransfers/ListSenderTransfersError";
import { BadGatewayError as ListSenderTransfersBadGatewayError } from "./types/ListSenderTransfers/ListSenderTransfersError";
import { GatewayTimeoutError as ListSenderTransfersGatewayTimeoutError } from "./types/ListSenderTransfers/ListSenderTransfersError";
import { GenericError as ListTeamDropboxesGenericError } from "./types/ListTeamDropboxes/ListTeamDropboxesError";
import { InvalidParameterError as ListTeamDropboxesInvalidParameterError } from "./types/ListTeamDropboxes/ListTeamDropboxesError";
import { UnauthorizedError as ListTeamDropboxesUnauthorizedError } from "./types/ListTeamDropboxes/ListTeamDropboxesError";
import { ForbiddenError as ListTeamDropboxesForbiddenError } from "./types/ListTeamDropboxes/ListTeamDropboxesError";
import { InternalServerError as ListTeamDropboxesInternalServerError } from "./types/ListTeamDropboxes/ListTeamDropboxesError";
import { BadGatewayError as ListTeamDropboxesBadGatewayError } from "./types/ListTeamDropboxes/ListTeamDropboxesError";
import { GatewayTimeoutError as ListTeamDropboxesGatewayTimeoutError } from "./types/ListTeamDropboxes/ListTeamDropboxesError";
import { GenericError as ListTeamReceiptFilesGenericError } from "./types/ListTeamReceiptFiles/ListTeamReceiptFilesError";
import { InvalidParameterError as ListTeamReceiptFilesInvalidParameterError } from "./types/ListTeamReceiptFiles/ListTeamReceiptFilesError";
import { UnauthorizedError as ListTeamReceiptFilesUnauthorizedError } from "./types/ListTeamReceiptFiles/ListTeamReceiptFilesError";
import { ForbiddenError as ListTeamReceiptFilesForbiddenError } from "./types/ListTeamReceiptFiles/ListTeamReceiptFilesError";
import { NotFoundError as ListTeamReceiptFilesNotFoundError } from "./types/ListTeamReceiptFiles/ListTeamReceiptFilesError";
import { InternalServerError as ListTeamReceiptFilesInternalServerError } from "./types/ListTeamReceiptFiles/ListTeamReceiptFilesError";
import { BadGatewayError as ListTeamReceiptFilesBadGatewayError } from "./types/ListTeamReceiptFiles/ListTeamReceiptFilesError";
import { GatewayTimeoutError as ListTeamReceiptFilesGatewayTimeoutError } from "./types/ListTeamReceiptFiles/ListTeamReceiptFilesError";
import { GenericError as ListTeamReceiptsGenericError } from "./types/ListTeamReceipts/ListTeamReceiptsError";
import { InvalidParameterError as ListTeamReceiptsInvalidParameterError } from "./types/ListTeamReceipts/ListTeamReceiptsError";
import { UnauthorizedError as ListTeamReceiptsUnauthorizedError } from "./types/ListTeamReceipts/ListTeamReceiptsError";
import { ForbiddenError as ListTeamReceiptsForbiddenError } from "./types/ListTeamReceipts/ListTeamReceiptsError";
import { InternalServerError as ListTeamReceiptsInternalServerError } from "./types/ListTeamReceipts/ListTeamReceiptsError";
import { BadGatewayError as ListTeamReceiptsBadGatewayError } from "./types/ListTeamReceipts/ListTeamReceiptsError";
import { GatewayTimeoutError as ListTeamReceiptsGatewayTimeoutError } from "./types/ListTeamReceipts/ListTeamReceiptsError";
import { GenericError as ListTeamTransferEventsGenericError } from "./types/ListTeamTransferEvents/ListTeamTransferEventsError";
import { InvalidParameterError as ListTeamTransferEventsInvalidParameterError } from "./types/ListTeamTransferEvents/ListTeamTransferEventsError";
import { UnauthorizedError as ListTeamTransferEventsUnauthorizedError } from "./types/ListTeamTransferEvents/ListTeamTransferEventsError";
import { ForbiddenError as ListTeamTransferEventsForbiddenError } from "./types/ListTeamTransferEvents/ListTeamTransferEventsError";
import { NotFoundError as ListTeamTransferEventsNotFoundError } from "./types/ListTeamTransferEvents/ListTeamTransferEventsError";
import { InternalServerError as ListTeamTransferEventsInternalServerError } from "./types/ListTeamTransferEvents/ListTeamTransferEventsError";
import { BadGatewayError as ListTeamTransferEventsBadGatewayError } from "./types/ListTeamTransferEvents/ListTeamTransferEventsError";
import { GatewayTimeoutError as ListTeamTransferEventsGatewayTimeoutError } from "./types/ListTeamTransferEvents/ListTeamTransferEventsError";
import { GenericError as ListTeamTransferFilesGenericError } from "./types/ListTeamTransferFiles/ListTeamTransferFilesError";
import { InvalidParameterError as ListTeamTransferFilesInvalidParameterError } from "./types/ListTeamTransferFiles/ListTeamTransferFilesError";
import { UnauthorizedError as ListTeamTransferFilesUnauthorizedError } from "./types/ListTeamTransferFiles/ListTeamTransferFilesError";
import { ForbiddenError as ListTeamTransferFilesForbiddenError } from "./types/ListTeamTransferFiles/ListTeamTransferFilesError";
import { NotFoundError as ListTeamTransferFilesNotFoundError } from "./types/ListTeamTransferFiles/ListTeamTransferFilesError";
import { InternalServerError as ListTeamTransferFilesInternalServerError } from "./types/ListTeamTransferFiles/ListTeamTransferFilesError";
import { BadGatewayError as ListTeamTransferFilesBadGatewayError } from "./types/ListTeamTransferFiles/ListTeamTransferFilesError";
import { GatewayTimeoutError as ListTeamTransferFilesGatewayTimeoutError } from "./types/ListTeamTransferFiles/ListTeamTransferFilesError";
import { GenericError as ListTeamTransfersGenericError } from "./types/ListTeamTransfers/ListTeamTransfersError";
import { InvalidParameterError as ListTeamTransfersInvalidParameterError } from "./types/ListTeamTransfers/ListTeamTransfersError";
import { UnauthorizedError as ListTeamTransfersUnauthorizedError } from "./types/ListTeamTransfers/ListTeamTransfersError";
import { ForbiddenError as ListTeamTransfersForbiddenError } from "./types/ListTeamTransfers/ListTeamTransfersError";
import { NotFoundError as ListTeamTransfersNotFoundError } from "./types/ListTeamTransfers/ListTeamTransfersError";
import { InternalServerError as ListTeamTransfersInternalServerError } from "./types/ListTeamTransfers/ListTeamTransfersError";
import { BadGatewayError as ListTeamTransfersBadGatewayError } from "./types/ListTeamTransfers/ListTeamTransfersError";
import { GatewayTimeoutError as ListTeamTransfersGatewayTimeoutError } from "./types/ListTeamTransfers/ListTeamTransfersError";
import { GenericError as ListTeamUserDropboxesGenericError } from "./types/ListTeamUserDropboxes/ListTeamUserDropboxesError";
import { InvalidParameterError as ListTeamUserDropboxesInvalidParameterError } from "./types/ListTeamUserDropboxes/ListTeamUserDropboxesError";
import { UnauthorizedError as ListTeamUserDropboxesUnauthorizedError } from "./types/ListTeamUserDropboxes/ListTeamUserDropboxesError";
import { ForbiddenError as ListTeamUserDropboxesForbiddenError } from "./types/ListTeamUserDropboxes/ListTeamUserDropboxesError";
import { InternalServerError as ListTeamUserDropboxesInternalServerError } from "./types/ListTeamUserDropboxes/ListTeamUserDropboxesError";
import { BadGatewayError as ListTeamUserDropboxesBadGatewayError } from "./types/ListTeamUserDropboxes/ListTeamUserDropboxesError";
import { GatewayTimeoutError as ListTeamUserDropboxesGatewayTimeoutError } from "./types/ListTeamUserDropboxes/ListTeamUserDropboxesError";
import { GenericError as ListTeamUserReceiptFilesGenericError } from "./types/ListTeamUserReceiptFiles/ListTeamUserReceiptFilesError";
import { InvalidParameterError as ListTeamUserReceiptFilesInvalidParameterError } from "./types/ListTeamUserReceiptFiles/ListTeamUserReceiptFilesError";
import { UnauthorizedError as ListTeamUserReceiptFilesUnauthorizedError } from "./types/ListTeamUserReceiptFiles/ListTeamUserReceiptFilesError";
import { ForbiddenError as ListTeamUserReceiptFilesForbiddenError } from "./types/ListTeamUserReceiptFiles/ListTeamUserReceiptFilesError";
import { NotFoundError as ListTeamUserReceiptFilesNotFoundError } from "./types/ListTeamUserReceiptFiles/ListTeamUserReceiptFilesError";
import { InternalServerError as ListTeamUserReceiptFilesInternalServerError } from "./types/ListTeamUserReceiptFiles/ListTeamUserReceiptFilesError";
import { BadGatewayError as ListTeamUserReceiptFilesBadGatewayError } from "./types/ListTeamUserReceiptFiles/ListTeamUserReceiptFilesError";
import { GatewayTimeoutError as ListTeamUserReceiptFilesGatewayTimeoutError } from "./types/ListTeamUserReceiptFiles/ListTeamUserReceiptFilesError";
import { GenericError as ListTeamUserReceiptsGenericError } from "./types/ListTeamUserReceipts/ListTeamUserReceiptsError";
import { InvalidParameterError as ListTeamUserReceiptsInvalidParameterError } from "./types/ListTeamUserReceipts/ListTeamUserReceiptsError";
import { UnauthorizedError as ListTeamUserReceiptsUnauthorizedError } from "./types/ListTeamUserReceipts/ListTeamUserReceiptsError";
import { ForbiddenError as ListTeamUserReceiptsForbiddenError } from "./types/ListTeamUserReceipts/ListTeamUserReceiptsError";
import { InternalServerError as ListTeamUserReceiptsInternalServerError } from "./types/ListTeamUserReceipts/ListTeamUserReceiptsError";
import { BadGatewayError as ListTeamUserReceiptsBadGatewayError } from "./types/ListTeamUserReceipts/ListTeamUserReceiptsError";
import { GatewayTimeoutError as ListTeamUserReceiptsGatewayTimeoutError } from "./types/ListTeamUserReceipts/ListTeamUserReceiptsError";
import { GenericError as ListTeamUserTransfersGenericError } from "./types/ListTeamUserTransfers/ListTeamUserTransfersError";
import { InvalidParameterError as ListTeamUserTransfersInvalidParameterError } from "./types/ListTeamUserTransfers/ListTeamUserTransfersError";
import { UnauthorizedError as ListTeamUserTransfersUnauthorizedError } from "./types/ListTeamUserTransfers/ListTeamUserTransfersError";
import { ForbiddenError as ListTeamUserTransfersForbiddenError } from "./types/ListTeamUserTransfers/ListTeamUserTransfersError";
import { InternalServerError as ListTeamUserTransfersInternalServerError } from "./types/ListTeamUserTransfers/ListTeamUserTransfersError";
import { BadGatewayError as ListTeamUserTransfersBadGatewayError } from "./types/ListTeamUserTransfers/ListTeamUserTransfersError";
import { GatewayTimeoutError as ListTeamUserTransfersGatewayTimeoutError } from "./types/ListTeamUserTransfers/ListTeamUserTransfersError";
import { GenericError as ListTransferEventsGenericError } from "./types/ListTransferEvents/ListTransferEventsError";
import { InvalidParameterError as ListTransferEventsInvalidParameterError } from "./types/ListTransferEvents/ListTransferEventsError";
import { UnauthorizedError as ListTransferEventsUnauthorizedError } from "./types/ListTransferEvents/ListTransferEventsError";
import { ForbiddenError as ListTransferEventsForbiddenError } from "./types/ListTransferEvents/ListTransferEventsError";
import { NotFoundError as ListTransferEventsNotFoundError } from "./types/ListTransferEvents/ListTransferEventsError";
import { InternalServerError as ListTransferEventsInternalServerError } from "./types/ListTransferEvents/ListTransferEventsError";
import { BadGatewayError as ListTransferEventsBadGatewayError } from "./types/ListTransferEvents/ListTransferEventsError";
import { GatewayTimeoutError as ListTransferEventsGatewayTimeoutError } from "./types/ListTransferEvents/ListTransferEventsError";
import { GenericError as ListTransferFilesGenericError } from "./types/ListTransferFiles/ListTransferFilesError";
import { InvalidParameterError as ListTransferFilesInvalidParameterError } from "./types/ListTransferFiles/ListTransferFilesError";
import { UnauthorizedError as ListTransferFilesUnauthorizedError } from "./types/ListTransferFiles/ListTransferFilesError";
import { ForbiddenError as ListTransferFilesForbiddenError } from "./types/ListTransferFiles/ListTransferFilesError";
import { NotFoundError as ListTransferFilesNotFoundError } from "./types/ListTransferFiles/ListTransferFilesError";
import { InternalServerError as ListTransferFilesInternalServerError } from "./types/ListTransferFiles/ListTransferFilesError";
import { BadGatewayError as ListTransferFilesBadGatewayError } from "./types/ListTransferFiles/ListTransferFilesError";
import { GatewayTimeoutError as ListTransferFilesGatewayTimeoutError } from "./types/ListTransferFiles/ListTransferFilesError";
import { GenericError as DownloadGenericError } from "./types/Download/DownloadError";
import { BadRequestError as DownloadBadRequestError } from "./types/Download/DownloadError";
import { UnauthorizedError as DownloadUnauthorizedError } from "./types/Download/DownloadError";
import { FobiddenError as DownloadFobiddenError } from "./types/Download/DownloadError";
import { NotFoundError as DownloadNotFoundError } from "./types/Download/DownloadError";
import { InternalServerError as DownloadInternalServerError } from "./types/Download/DownloadError";
import { BadGatewayError as DownloadBadGatewayError } from "./types/Download/DownloadError";
import { GatewayTimeoutError as DownloadGatewayTimeoutError } from "./types/Download/DownloadError";
import { GenericError as UploadTransferFilePartGenericError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { BadRequestError as UploadTransferFilePartBadRequestError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InternalServerError as UploadTransferFilePartInternalServerError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { NotFoundError as UploadTransferFilePartNotFoundError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { NoSuchUploadError as UploadTransferFilePartNoSuchUploadError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { AccessControlListNotSupportedError as UploadTransferFilePartAccessControlListNotSupportedError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { AccessDeniedError as UploadTransferFilePartAccessDeniedError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { AccessPointAlreadyOwnedByYouError as UploadTransferFilePartAccessPointAlreadyOwnedByYouError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { AccountProblemError as UploadTransferFilePartAccountProblemError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { AllAccessDisabledError as UploadTransferFilePartAllAccessDisabledError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { AmbiguousGrantByEmailAddressError as UploadTransferFilePartAmbiguousGrantByEmailAddressError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { AuthorizationHeaderMalformedError as UploadTransferFilePartAuthorizationHeaderMalformedError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { BadDigestError as UploadTransferFilePartBadDigestError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { EntityTooSmallError as UploadTransferFilePartEntityTooSmallError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { EntityTooLargeError as UploadTransferFilePartEntityTooLargeError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { ExpiredTokenError as UploadTransferFilePartExpiredTokenError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { IllegalLocationConstraintExceptionError as UploadTransferFilePartIllegalLocationConstraintExceptionError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { IllegalVersioningConfigurationExceptionError as UploadTransferFilePartIllegalVersioningConfigurationExceptionError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { IncompleteBodyError as UploadTransferFilePartIncompleteBodyError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InlineDataTooLargeError as UploadTransferFilePartInlineDataTooLargeError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InternalError as UploadTransferFilePartInternalError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidAccessKeyIdError as UploadTransferFilePartInvalidAccessKeyIdError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidArgumentError as UploadTransferFilePartInvalidArgumentError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidBucketNameError as UploadTransferFilePartInvalidBucketNameError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidBucketStateError as UploadTransferFilePartInvalidBucketStateError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidDigestError as UploadTransferFilePartInvalidDigestError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidLocationConstraintError as UploadTransferFilePartInvalidLocationConstraintError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidObjectStateError as UploadTransferFilePartInvalidObjectStateError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidPartError as UploadTransferFilePartInvalidPartError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidPartOrderError as UploadTransferFilePartInvalidPartOrderError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidPayerError as UploadTransferFilePartInvalidPayerError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidPolicyDocumentError as UploadTransferFilePartInvalidPolicyDocumentError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidRangeError as UploadTransferFilePartInvalidRangeError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidRequestError as UploadTransferFilePartInvalidRequestError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidSecurityError as UploadTransferFilePartInvalidSecurityError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidTokenError as UploadTransferFilePartInvalidTokenError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidURIError as UploadTransferFilePartInvalidURIError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { KeyTooLongError as UploadTransferFilePartKeyTooLongError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { MaxMessageLengthExceededError as UploadTransferFilePartMaxMessageLengthExceededError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { MetadataTooLargeError as UploadTransferFilePartMetadataTooLargeError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { MissingContentLengthError as UploadTransferFilePartMissingContentLengthError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { MissingRequestBodyError as UploadTransferFilePartMissingRequestBodyError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { MissingSecurityHeaderError as UploadTransferFilePartMissingSecurityHeaderError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { NoSuchBucketError as UploadTransferFilePartNoSuchBucketError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { NoSuchBucketPolicyError as UploadTransferFilePartNoSuchBucketPolicyError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { NoSuchCORSConfigurationError as UploadTransferFilePartNoSuchCORSConfigurationError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { NoSuchKeyError as UploadTransferFilePartNoSuchKeyError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { NotImplementedError as UploadTransferFilePartNotImplementedError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { RequestHeaderSectionTooLargeError as UploadTransferFilePartRequestHeaderSectionTooLargeError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { RequestTimeoutError as UploadTransferFilePartRequestTimeoutError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { RequestTimeTooSkewedError as UploadTransferFilePartRequestTimeTooSkewedError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { ServerSideEncryptionConfigurationNotFoundError as UploadTransferFilePartServerSideEncryptionConfigurationNotFoundError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { ServiceUnavailableError as UploadTransferFilePartServiceUnavailableError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { SignatureDoesNotMatchError as UploadTransferFilePartSignatureDoesNotMatchError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { SlowDownError as UploadTransferFilePartSlowDownError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { TokenRefreshRequiredError as UploadTransferFilePartTokenRefreshRequiredError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { UnexpectedContentError as UploadTransferFilePartUnexpectedContentError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { UserKeyMustBeSpecifiedError as UploadTransferFilePartUserKeyMustBeSpecifiedError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { EtagIsMissingError as UploadTransferFilePartEtagIsMissingError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { AuthorizationQueryParametersError as UploadTransferFilePartAuthorizationQueryParametersError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { ConditionalRequestConflictError as UploadTransferFilePartConditionalRequestConflictError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { EndpointNotFoundError as UploadTransferFilePartEndpointNotFoundError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { IncorrectEndpointError as UploadTransferFilePartIncorrectEndpointError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidAccessPointError as UploadTransferFilePartInvalidAccessPointError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidAccessPointAliasError as UploadTransferFilePartInvalidAccessPointAliasError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidAddressingHeaderError as UploadTransferFilePartInvalidAddressingHeaderError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidEncryptionAlgorithmError as UploadTransferFilePartInvalidEncryptionAlgorithmError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidHostHeaderError as UploadTransferFilePartInvalidHostHeaderError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidSessionExceptionError as UploadTransferFilePartInvalidSessionExceptionError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidSignatureError as UploadTransferFilePartInvalidSignatureError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { InvalidStorageClassError as UploadTransferFilePartInvalidStorageClassError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { MissingAuthenticationTokenError as UploadTransferFilePartMissingAuthenticationTokenError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { TokenCodeInvalidError as UploadTransferFilePartTokenCodeInvalidError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { UnauthorizedAccessError as UploadTransferFilePartUnauthorizedAccessError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { UnexpectedIPError as UploadTransferFilePartUnexpectedIPError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { UnsupportedArgumentError as UploadTransferFilePartUnsupportedArgumentError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { UnsupportedSignatureError as UploadTransferFilePartUnsupportedSignatureError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
import { NoSuchAccessPointError as UploadTransferFilePartNoSuchAccessPointError } from "./types/UploadTransferFilePart/UploadTransferFilePartError";
export const errors = {
    ListTransferFilesInternal: {
        InvalidParameterError: ListTransferFilesInternalInvalidParameterError,
        UnauthorizedError: ListTransferFilesInternalUnauthorizedError,
        ForbiddenError: ListTransferFilesInternalForbiddenError,
        NotFoundError: ListTransferFilesInternalNotFoundError,
        InternalServerError: ListTransferFilesInternalInternalServerError,
        BadGatewayError: ListTransferFilesInternalBadGatewayError,
        GatewayTimeoutError: ListTransferFilesInternalGatewayTimeoutError,
        GenericError: ListTransferFilesInternalGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTransferFilesPreview: {
        InvalidParameterError: ListTransferFilesPreviewInvalidParameterError,
        UnauthorizedError: ListTransferFilesPreviewUnauthorizedError,
        PasswordDoesNotMatchError: ListTransferFilesPreviewPasswordDoesNotMatchError,
        OwnerUsageExceededError: ListTransferFilesPreviewOwnerUsageExceededError,
        AccessorUsageExceededError: ListTransferFilesPreviewAccessorUsageExceededError,
        ForbiddenError: ListTransferFilesPreviewForbiddenError,
        NotFoundError: ListTransferFilesPreviewNotFoundError,
        InternalServerError: ListTransferFilesPreviewInternalServerError,
        BadGatewayError: ListTransferFilesPreviewBadGatewayError,
        GatewayTimeoutError: ListTransferFilesPreviewGatewayTimeoutError,
        GenericError: ListTransferFilesPreviewGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTransfers: {
        InvalidParameterError: ListTransfersInvalidParameterError,
        UnauthorizedError: ListTransfersUnauthorizedError,
        ForbiddenError: ListTransfersForbiddenError,
        NotFoundError: ListTransfersNotFoundError,
        InternalServerError: ListTransfersInternalServerError,
        BadGatewayError: ListTransfersBadGatewayError,
        GatewayTimeoutError: ListTransfersGatewayTimeoutError,
        GenericError: ListTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserDropboxes: {
        InvalidParameterError: ListUserDropboxesInvalidParameterError,
        UnauthorizedError: ListUserDropboxesUnauthorizedError,
        ForbiddenError: ListUserDropboxesForbiddenError,
        InternalServerError: ListUserDropboxesInternalServerError,
        BadGatewayError: ListUserDropboxesBadGatewayError,
        GatewayTimeoutError: ListUserDropboxesGatewayTimeoutError,
        GenericError: ListUserDropboxesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserReceiptFiles: {
        InvalidParameterError: ListUserReceiptFilesInvalidParameterError,
        UnauthorizedError: ListUserReceiptFilesUnauthorizedError,
        ForbiddenError: ListUserReceiptFilesForbiddenError,
        NotFoundError: ListUserReceiptFilesNotFoundError,
        InternalServerError: ListUserReceiptFilesInternalServerError,
        BadGatewayError: ListUserReceiptFilesBadGatewayError,
        GatewayTimeoutError: ListUserReceiptFilesGatewayTimeoutError,
        GenericError: ListUserReceiptFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserReceipts: {
        InvalidParameterError: ListUserReceiptsInvalidParameterError,
        UnauthorizedError: ListUserReceiptsUnauthorizedError,
        ForbiddenError: ListUserReceiptsForbiddenError,
        InternalServerError: ListUserReceiptsInternalServerError,
        BadGatewayError: ListUserReceiptsBadGatewayError,
        GatewayTimeoutError: ListUserReceiptsGatewayTimeoutError,
        GenericError: ListUserReceiptsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserTransferEvents: {
        InvalidParameterError: ListUserTransferEventsInvalidParameterError,
        UnauthorizedError: ListUserTransferEventsUnauthorizedError,
        ForbiddenError: ListUserTransferEventsForbiddenError,
        NotFoundError: ListUserTransferEventsNotFoundError,
        InternalServerError: ListUserTransferEventsInternalServerError,
        BadGatewayError: ListUserTransferEventsBadGatewayError,
        GatewayTimeoutError: ListUserTransferEventsGatewayTimeoutError,
        GenericError: ListUserTransferEventsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserTransferFiles: {
        InvalidParameterError: ListUserTransferFilesInvalidParameterError,
        UnauthorizedError: ListUserTransferFilesUnauthorizedError,
        ForbiddenError: ListUserTransferFilesForbiddenError,
        NotFoundError: ListUserTransferFilesNotFoundError,
        InternalServerError: ListUserTransferFilesInternalServerError,
        BadGatewayError: ListUserTransferFilesBadGatewayError,
        GatewayTimeoutError: ListUserTransferFilesGatewayTimeoutError,
        GenericError: ListUserTransferFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserTransfers: {
        InvalidParameterError: ListUserTransfersInvalidParameterError,
        UnauthorizedError: ListUserTransfersUnauthorizedError,
        ForbiddenError: ListUserTransfersForbiddenError,
        NotFoundError: ListUserTransfersNotFoundError,
        InternalServerError: ListUserTransfersInternalServerError,
        BadGatewayError: ListUserTransfersBadGatewayError,
        GatewayTimeoutError: ListUserTransfersGatewayTimeoutError,
        GenericError: ListUserTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListYearEvents: {
        InvalidParameterError: ListYearEventsInvalidParameterError,
        UnauthorizedError: ListYearEventsUnauthorizedError,
        ForbiddenError: ListYearEventsForbiddenError,
        InternalServerError: ListYearEventsInternalServerError,
        BadGatewayError: ListYearEventsBadGatewayError,
        GatewayTimeoutError: ListYearEventsGatewayTimeoutError,
        GenericError: ListYearEventsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListYearFiles: {
        InvalidParameterError: ListYearFilesInvalidParameterError,
        UnauthorizedError: ListYearFilesUnauthorizedError,
        ForbiddenError: ListYearFilesForbiddenError,
        InternalServerError: ListYearFilesInternalServerError,
        BadGatewayError: ListYearFilesBadGatewayError,
        GatewayTimeoutError: ListYearFilesGatewayTimeoutError,
        GenericError: ListYearFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListYearTransfers: {
        InvalidParameterError: ListYearTransfersInvalidParameterError,
        UnauthorizedError: ListYearTransfersUnauthorizedError,
        ForbiddenError: ListYearTransfersForbiddenError,
        InternalServerError: ListYearTransfersInternalServerError,
        BadGatewayError: ListYearTransfersBadGatewayError,
        GatewayTimeoutError: ListYearTransfersGatewayTimeoutError,
        GenericError: ListYearTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    LockTransfer: {
        InvalidParameterError: LockTransferInvalidParameterError,
        UnauthorizedError: LockTransferUnauthorizedError,
        TransferAlreadyLockedError: LockTransferTransferAlreadyLockedError,
        TransferIsDirtyError: LockTransferTransferIsDirtyError,
        TransferIsInQueueError: LockTransferTransferIsInQueueError,
        ForbiddenError: LockTransferForbiddenError,
        NotFoundError: LockTransferNotFoundError,
        InternalServerError: LockTransferInternalServerError,
        BadGatewayError: LockTransferBadGatewayError,
        GatewayTimeoutError: LockTransferGatewayTimeoutError,
        GenericError: LockTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateDropbox: {
        InvalidParameterError: UpdateDropboxInvalidParameterError,
        UnauthorizedError: UpdateDropboxUnauthorizedError,
        ForbiddenError: UpdateDropboxForbiddenError,
        NotFoundError: UpdateDropboxNotFoundError,
        InternalServerError: UpdateDropboxInternalServerError,
        BadGatewayError: UpdateDropboxBadGatewayError,
        GatewayTimeoutError: UpdateDropboxGatewayTimeoutError,
        GenericError: UpdateDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateManualReview: {
        InvalidParameterError: UpdateManualReviewInvalidParameterError,
        UnauthorizedError: UpdateManualReviewUnauthorizedError,
        ForbiddenError: UpdateManualReviewForbiddenError,
        NotFoundError: UpdateManualReviewNotFoundError,
        InternalServerError: UpdateManualReviewInternalServerError,
        BadGatewayError: UpdateManualReviewBadGatewayError,
        GatewayTimeoutError: UpdateManualReviewGatewayTimeoutError,
        GenericError: UpdateManualReviewGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTeamDropbox: {
        InvalidParameterError: UpdateTeamDropboxInvalidParameterError,
        UnauthorizedError: UpdateTeamDropboxUnauthorizedError,
        ForbiddenError: UpdateTeamDropboxForbiddenError,
        NotFoundError: UpdateTeamDropboxNotFoundError,
        InternalServerError: UpdateTeamDropboxInternalServerError,
        BadGatewayError: UpdateTeamDropboxBadGatewayError,
        GatewayTimeoutError: UpdateTeamDropboxGatewayTimeoutError,
        GenericError: UpdateTeamDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTeamUserDropbox: {
        InvalidParameterError: UpdateTeamUserDropboxInvalidParameterError,
        UnauthorizedError: UpdateTeamUserDropboxUnauthorizedError,
        ForbiddenError: UpdateTeamUserDropboxForbiddenError,
        NotFoundError: UpdateTeamUserDropboxNotFoundError,
        InternalServerError: UpdateTeamUserDropboxInternalServerError,
        BadGatewayError: UpdateTeamUserDropboxBadGatewayError,
        GatewayTimeoutError: UpdateTeamUserDropboxGatewayTimeoutError,
        GenericError: UpdateTeamUserDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTransfer: {
        InvalidParameterError: UpdateTransferInvalidParameterError,
        UnauthorizedError: UpdateTransferUnauthorizedError,
        TransferAlreadyLockedError: UpdateTransferTransferAlreadyLockedError,
        ForbiddenError: UpdateTransferForbiddenError,
        NotFoundError: UpdateTransferNotFoundError,
        InternalServerError: UpdateTransferInternalServerError,
        BadGatewayError: UpdateTransferBadGatewayError,
        GatewayTimeoutError: UpdateTransferGatewayTimeoutError,
        GenericError: UpdateTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTransferCustomization: {
        InvalidParameterError: UpdateTransferCustomizationInvalidParameterError,
        UnauthorizedError: UpdateTransferCustomizationUnauthorizedError,
        ForbiddenError: UpdateTransferCustomizationForbiddenError,
        NotFoundError: UpdateTransferCustomizationNotFoundError,
        InternalServerError: UpdateTransferCustomizationInternalServerError,
        BadGatewayError: UpdateTransferCustomizationBadGatewayError,
        GatewayTimeoutError: UpdateTransferCustomizationGatewayTimeoutError,
        GenericError: UpdateTransferCustomizationGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTransferFile: {
        InvalidParameterError: UpdateTransferFileInvalidParameterError,
        UnauthorizedError: UpdateTransferFileUnauthorizedError,
        TransferAlreadyLockedError: UpdateTransferFileTransferAlreadyLockedError,
        FileAlreadyLockedError: UpdateTransferFileFileAlreadyLockedError,
        ForbiddenError: UpdateTransferFileForbiddenError,
        NotFoundError: UpdateTransferFileNotFoundError,
        InternalServerError: UpdateTransferFileInternalServerError,
        BadGatewayError: UpdateTransferFileBadGatewayError,
        GatewayTimeoutError: UpdateTransferFileGatewayTimeoutError,
        GenericError: UpdateTransferFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTransferFilePart: {
        InvalidParameterError: UpdateTransferFilePartInvalidParameterError,
        UnauthorizedError: UpdateTransferFilePartUnauthorizedError,
        TransferAlreadyLockedError: UpdateTransferFilePartTransferAlreadyLockedError,
        FileAlreadyLockedError: UpdateTransferFilePartFileAlreadyLockedError,
        ForbiddenError: UpdateTransferFilePartForbiddenError,
        NotFoundError: UpdateTransferFilePartNotFoundError,
        InternalServerError: UpdateTransferFilePartInternalServerError,
        BadGatewayError: UpdateTransferFilePartBadGatewayError,
        GatewayTimeoutError: UpdateTransferFilePartGatewayTimeoutError,
        GenericError: UpdateTransferFilePartGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTransferFileParts: {
        InvalidParameterError: UpdateTransferFilePartsInvalidParameterError,
        UnauthorizedError: UpdateTransferFilePartsUnauthorizedError,
        TransferAlreadyLockedError: UpdateTransferFilePartsTransferAlreadyLockedError,
        FileAlreadyLockedError: UpdateTransferFilePartsFileAlreadyLockedError,
        ForbiddenError: UpdateTransferFilePartsForbiddenError,
        NotFoundError: UpdateTransferFilePartsNotFoundError,
        InternalServerError: UpdateTransferFilePartsInternalServerError,
        BadGatewayError: UpdateTransferFilePartsBadGatewayError,
        GatewayTimeoutError: UpdateTransferFilePartsGatewayTimeoutError,
        GenericError: UpdateTransferFilePartsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateUserDropbox: {
        InvalidParameterError: UpdateUserDropboxInvalidParameterError,
        UnauthorizedError: UpdateUserDropboxUnauthorizedError,
        ForbiddenError: UpdateUserDropboxForbiddenError,
        NotFoundError: UpdateUserDropboxNotFoundError,
        InternalServerError: UpdateUserDropboxInternalServerError,
        BadGatewayError: UpdateUserDropboxBadGatewayError,
        GatewayTimeoutError: UpdateUserDropboxGatewayTimeoutError,
        GenericError: UpdateUserDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateDropbox: {
        InvalidParameterError: CreateDropboxInvalidParameterError,
        UnauthorizedError: CreateDropboxUnauthorizedError,
        InvalidSubscriptionError: CreateDropboxInvalidSubscriptionError,
        ForbiddenError: CreateDropboxForbiddenError,
        InternalServerError: CreateDropboxInternalServerError,
        BadGatewayError: CreateDropboxBadGatewayError,
        GatewayTimeoutError: CreateDropboxGatewayTimeoutError,
        GenericError: CreateDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateDropboxTransfer: {
        MissingSenderError: CreateDropboxTransferMissingSenderError,
        MissingReceiversError: CreateDropboxTransferMissingReceiversError,
        InvalidDeliveryError: CreateDropboxTransferInvalidDeliveryError,
        InvalidAvailabilityDurationError: CreateDropboxTransferInvalidAvailabilityDurationError,
        InvalidParameterError: CreateDropboxTransferInvalidParameterError,
        UnauthorizedError: CreateDropboxTransferUnauthorizedError,
        PasswordDoesNotMatchError: CreateDropboxTransferPasswordDoesNotMatchError,
        InvalidSubscriptionError: CreateDropboxTransferInvalidSubscriptionError,
        EmailNotAllowedError: CreateDropboxTransferEmailNotAllowedError,
        OwnerUsageExceededError: CreateDropboxTransferOwnerUsageExceededError,
        PasswordRequiredError: CreateDropboxTransferPasswordRequiredError,
        TeamConfigurationError: CreateDropboxTransferTeamConfigurationError,
        DropboxDisabledError: CreateDropboxTransferDropboxDisabledError,
        DropboxDeletedError: CreateDropboxTransferDropboxDeletedError,
        DropboxMaxTransferCountError: CreateDropboxTransferDropboxMaxTransferCountError,
        DropboxMaxBytesUploadedError: CreateDropboxTransferDropboxMaxBytesUploadedError,
        ForbiddenError: CreateDropboxTransferForbiddenError,
        NotFoundError: CreateDropboxTransferNotFoundError,
        CustomUrlAlreadyInUseError: CreateDropboxTransferCustomUrlAlreadyInUseError,
        InternalServerError: CreateDropboxTransferInternalServerError,
        BadGatewayError: CreateDropboxTransferBadGatewayError,
        GatewayTimeoutError: CreateDropboxTransferGatewayTimeoutError,
        GenericError: CreateDropboxTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTeamDropbox: {
        InvalidParameterError: CreateTeamDropboxInvalidParameterError,
        UnauthorizedError: CreateTeamDropboxUnauthorizedError,
        InvalidSubscriptionError: CreateTeamDropboxInvalidSubscriptionError,
        ForbiddenError: CreateTeamDropboxForbiddenError,
        NotFoundError: CreateTeamDropboxNotFoundError,
        InternalServerError: CreateTeamDropboxInternalServerError,
        BadGatewayError: CreateTeamDropboxBadGatewayError,
        GatewayTimeoutError: CreateTeamDropboxGatewayTimeoutError,
        GenericError: CreateTeamDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTeamTransfer: {
        InvalidAvailabilityDurationError: CreateTeamTransferInvalidAvailabilityDurationError,
        InvalidParameterError: CreateTeamTransferInvalidParameterError,
        UnauthorizedError: CreateTeamTransferUnauthorizedError,
        InvalidSubscriptionError: CreateTeamTransferInvalidSubscriptionError,
        EmailNotAllowedError: CreateTeamTransferEmailNotAllowedError,
        UsageExceededError: CreateTeamTransferUsageExceededError,
        PasswordRequiredError: CreateTeamTransferPasswordRequiredError,
        ForbiddenError: CreateTeamTransferForbiddenError,
        NotFoundError: CreateTeamTransferNotFoundError,
        CustomUrlAlreadyInUseError: CreateTeamTransferCustomUrlAlreadyInUseError,
        InternalServerError: CreateTeamTransferInternalServerError,
        BadGatewayError: CreateTeamTransferBadGatewayError,
        GatewayTimeoutError: CreateTeamTransferGatewayTimeoutError,
        GenericError: CreateTeamTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTeamUserDropbox: {
        InvalidParameterError: CreateTeamUserDropboxInvalidParameterError,
        UnauthorizedError: CreateTeamUserDropboxUnauthorizedError,
        InvalidSubscriptionError: CreateTeamUserDropboxInvalidSubscriptionError,
        ForbiddenError: CreateTeamUserDropboxForbiddenError,
        NotFoundError: CreateTeamUserDropboxNotFoundError,
        InternalServerError: CreateTeamUserDropboxInternalServerError,
        BadGatewayError: CreateTeamUserDropboxBadGatewayError,
        GatewayTimeoutError: CreateTeamUserDropboxGatewayTimeoutError,
        GenericError: CreateTeamUserDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTransfer: {
        InvalidAvailabilityDurationError: CreateTransferInvalidAvailabilityDurationError,
        InvalidParameterError: CreateTransferInvalidParameterError,
        UnauthorizedError: CreateTransferUnauthorizedError,
        InvalidSubscriptionError: CreateTransferInvalidSubscriptionError,
        EmailNotAllowedError: CreateTransferEmailNotAllowedError,
        UsageExceededError: CreateTransferUsageExceededError,
        PasswordRequiredError: CreateTransferPasswordRequiredError,
        EmailNotVerifiedError: CreateTransferEmailNotVerifiedError,
        ForbiddenError: CreateTransferForbiddenError,
        CustomUrlAlreadyInUseError: CreateTransferCustomUrlAlreadyInUseError,
        InternalServerError: CreateTransferInternalServerError,
        BadGatewayError: CreateTransferBadGatewayError,
        GatewayTimeoutError: CreateTransferGatewayTimeoutError,
        GenericError: CreateTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTransferFile: {
        InvalidParameterError: CreateTransferFileInvalidParameterError,
        UnauthorizedError: CreateTransferFileUnauthorizedError,
        TransferAlreadyLockedError: CreateTransferFileTransferAlreadyLockedError,
        TransferIsInQueueError: CreateTransferFileTransferIsInQueueError,
        ForbiddenError: CreateTransferFileForbiddenError,
        NotFoundError: CreateTransferFileNotFoundError,
        ConflictError: CreateTransferFileConflictError,
        InternalServerError: CreateTransferFileInternalServerError,
        BadGatewayError: CreateTransferFileBadGatewayError,
        GatewayTimeoutError: CreateTransferFileGatewayTimeoutError,
        GenericError: CreateTransferFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTransferFilePart: {
        InvalidParameterError: CreateTransferFilePartInvalidParameterError,
        UnauthorizedError: CreateTransferFilePartUnauthorizedError,
        TransferAlreadyLockedError: CreateTransferFilePartTransferAlreadyLockedError,
        FileAlreadyLockedError: CreateTransferFilePartFileAlreadyLockedError,
        ForbiddenError: CreateTransferFilePartForbiddenError,
        NotFoundError: CreateTransferFilePartNotFoundError,
        InternalServerError: CreateTransferFilePartInternalServerError,
        BadGatewayError: CreateTransferFilePartBadGatewayError,
        GatewayTimeoutError: CreateTransferFilePartGatewayTimeoutError,
        GenericError: CreateTransferFilePartGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTransferFileParts: {
        InvalidParameterError: CreateTransferFilePartsInvalidParameterError,
        UnauthorizedError: CreateTransferFilePartsUnauthorizedError,
        TransferAlreadyLockedError: CreateTransferFilePartsTransferAlreadyLockedError,
        FileAlreadyLockedError: CreateTransferFilePartsFileAlreadyLockedError,
        ForbiddenError: CreateTransferFilePartsForbiddenError,
        NotFoundError: CreateTransferFilePartsNotFoundError,
        InternalServerError: CreateTransferFilePartsInternalServerError,
        BadGatewayError: CreateTransferFilePartsBadGatewayError,
        GatewayTimeoutError: CreateTransferFilePartsGatewayTimeoutError,
        GenericError: CreateTransferFilePartsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTransferSignedUrls: {
        InvalidParameterError: CreateTransferSignedUrlsInvalidParameterError,
        UnauthorizedError: CreateTransferSignedUrlsUnauthorizedError,
        PasswordDoesNotMatchError: CreateTransferSignedUrlsPasswordDoesNotMatchError,
        ForbiddenError: CreateTransferSignedUrlsForbiddenError,
        NotFoundError: CreateTransferSignedUrlsNotFoundError,
        InternalServerError: CreateTransferSignedUrlsInternalServerError,
        BadGatewayError: CreateTransferSignedUrlsBadGatewayError,
        GatewayTimeoutError: CreateTransferSignedUrlsGatewayTimeoutError,
        GenericError: CreateTransferSignedUrlsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateUserDropbox: {
        InvalidParameterError: CreateUserDropboxInvalidParameterError,
        UnauthorizedError: CreateUserDropboxUnauthorizedError,
        InvalidSubscriptionError: CreateUserDropboxInvalidSubscriptionError,
        ForbiddenError: CreateUserDropboxForbiddenError,
        NotFoundError: CreateUserDropboxNotFoundError,
        InternalServerError: CreateUserDropboxInternalServerError,
        BadGatewayError: CreateUserDropboxBadGatewayError,
        GatewayTimeoutError: CreateUserDropboxGatewayTimeoutError,
        GenericError: CreateUserDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteDropbox: {
        InvalidParameterError: DeleteDropboxInvalidParameterError,
        UnauthorizedError: DeleteDropboxUnauthorizedError,
        ForbiddenError: DeleteDropboxForbiddenError,
        NotFoundError: DeleteDropboxNotFoundError,
        InternalServerError: DeleteDropboxInternalServerError,
        BadGatewayError: DeleteDropboxBadGatewayError,
        GatewayTimeoutError: DeleteDropboxGatewayTimeoutError,
        GenericError: DeleteDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteReceipt: {
        InvalidParameterError: DeleteReceiptInvalidParameterError,
        UnauthorizedError: DeleteReceiptUnauthorizedError,
        ForbiddenError: DeleteReceiptForbiddenError,
        NotFoundError: DeleteReceiptNotFoundError,
        InternalServerError: DeleteReceiptInternalServerError,
        BadGatewayError: DeleteReceiptBadGatewayError,
        GatewayTimeoutError: DeleteReceiptGatewayTimeoutError,
        GenericError: DeleteReceiptGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteReport: {
        InvalidParameterError: DeleteReportInvalidParameterError,
        UnauthorizedError: DeleteReportUnauthorizedError,
        TransferNotUploadedError: DeleteReportTransferNotUploadedError,
        ForbiddenError: DeleteReportForbiddenError,
        NotFoundError: DeleteReportNotFoundError,
        InternalServerError: DeleteReportInternalServerError,
        BadGatewayError: DeleteReportBadGatewayError,
        GatewayTimeoutError: DeleteReportGatewayTimeoutError,
        GenericError: DeleteReportGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteTeamDropbox: {
        InvalidParameterError: DeleteTeamDropboxInvalidParameterError,
        UnauthorizedError: DeleteTeamDropboxUnauthorizedError,
        ForbiddenError: DeleteTeamDropboxForbiddenError,
        NotFoundError: DeleteTeamDropboxNotFoundError,
        InternalServerError: DeleteTeamDropboxInternalServerError,
        BadGatewayError: DeleteTeamDropboxBadGatewayError,
        GatewayTimeoutError: DeleteTeamDropboxGatewayTimeoutError,
        GenericError: DeleteTeamDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteTeamReceipt: {
        InvalidParameterError: DeleteTeamReceiptInvalidParameterError,
        UnauthorizedError: DeleteTeamReceiptUnauthorizedError,
        ForbiddenError: DeleteTeamReceiptForbiddenError,
        NotFoundError: DeleteTeamReceiptNotFoundError,
        InternalServerError: DeleteTeamReceiptInternalServerError,
        BadGatewayError: DeleteTeamReceiptBadGatewayError,
        GatewayTimeoutError: DeleteTeamReceiptGatewayTimeoutError,
        GenericError: DeleteTeamReceiptGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteTeamTransfer: {
        InvalidParameterError: DeleteTeamTransferInvalidParameterError,
        UnauthorizedError: DeleteTeamTransferUnauthorizedError,
        TransferNotUploadedError: DeleteTeamTransferTransferNotUploadedError,
        ForbiddenError: DeleteTeamTransferForbiddenError,
        NotFoundError: DeleteTeamTransferNotFoundError,
        InternalServerError: DeleteTeamTransferInternalServerError,
        BadGatewayError: DeleteTeamTransferBadGatewayError,
        GatewayTimeoutError: DeleteTeamTransferGatewayTimeoutError,
        GenericError: DeleteTeamTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteTeamUserDropbox: {
        InvalidParameterError: DeleteTeamUserDropboxInvalidParameterError,
        UnauthorizedError: DeleteTeamUserDropboxUnauthorizedError,
        ForbiddenError: DeleteTeamUserDropboxForbiddenError,
        NotFoundError: DeleteTeamUserDropboxNotFoundError,
        InternalServerError: DeleteTeamUserDropboxInternalServerError,
        BadGatewayError: DeleteTeamUserDropboxBadGatewayError,
        GatewayTimeoutError: DeleteTeamUserDropboxGatewayTimeoutError,
        GenericError: DeleteTeamUserDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteTeamUserReceipt: {
        InvalidParameterError: DeleteTeamUserReceiptInvalidParameterError,
        UnauthorizedError: DeleteTeamUserReceiptUnauthorizedError,
        ForbiddenError: DeleteTeamUserReceiptForbiddenError,
        NotFoundError: DeleteTeamUserReceiptNotFoundError,
        InternalServerError: DeleteTeamUserReceiptInternalServerError,
        BadGatewayError: DeleteTeamUserReceiptBadGatewayError,
        GatewayTimeoutError: DeleteTeamUserReceiptGatewayTimeoutError,
        GenericError: DeleteTeamUserReceiptGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteTransfer: {
        InvalidParameterError: DeleteTransferInvalidParameterError,
        UnauthorizedError: DeleteTransferUnauthorizedError,
        TransferNotUploadedError: DeleteTransferTransferNotUploadedError,
        ForbiddenError: DeleteTransferForbiddenError,
        NotFoundError: DeleteTransferNotFoundError,
        InternalServerError: DeleteTransferInternalServerError,
        BadGatewayError: DeleteTransferBadGatewayError,
        GatewayTimeoutError: DeleteTransferGatewayTimeoutError,
        GenericError: DeleteTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteTransferFile: {
        InvalidParameterError: DeleteTransferFileInvalidParameterError,
        UnauthorizedError: DeleteTransferFileUnauthorizedError,
        ForbiddenError: DeleteTransferFileForbiddenError,
        NotFoundError: DeleteTransferFileNotFoundError,
        InternalServerError: DeleteTransferFileInternalServerError,
        BadGatewayError: DeleteTransferFileBadGatewayError,
        GatewayTimeoutError: DeleteTransferFileGatewayTimeoutError,
        GenericError: DeleteTransferFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteUserDropbox: {
        InvalidParameterError: DeleteUserDropboxInvalidParameterError,
        UnauthorizedError: DeleteUserDropboxUnauthorizedError,
        ForbiddenError: DeleteUserDropboxForbiddenError,
        NotFoundError: DeleteUserDropboxNotFoundError,
        InternalServerError: DeleteUserDropboxInternalServerError,
        BadGatewayError: DeleteUserDropboxBadGatewayError,
        GatewayTimeoutError: DeleteUserDropboxGatewayTimeoutError,
        GenericError: DeleteUserDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteUserReceipt: {
        InvalidParameterError: DeleteUserReceiptInvalidParameterError,
        UnauthorizedError: DeleteUserReceiptUnauthorizedError,
        ForbiddenError: DeleteUserReceiptForbiddenError,
        NotFoundError: DeleteUserReceiptNotFoundError,
        InternalServerError: DeleteUserReceiptInternalServerError,
        BadGatewayError: DeleteUserReceiptBadGatewayError,
        GatewayTimeoutError: DeleteUserReceiptGatewayTimeoutError,
        GenericError: DeleteUserReceiptGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteUserTransfer: {
        InvalidParameterError: DeleteUserTransferInvalidParameterError,
        UnauthorizedError: DeleteUserTransferUnauthorizedError,
        TransferNotUploadedError: DeleteUserTransferTransferNotUploadedError,
        ForbiddenError: DeleteUserTransferForbiddenError,
        NotFoundError: DeleteUserTransferNotFoundError,
        InternalServerError: DeleteUserTransferInternalServerError,
        BadGatewayError: DeleteUserTransferBadGatewayError,
        GatewayTimeoutError: DeleteUserTransferGatewayTimeoutError,
        GenericError: DeleteUserTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountMetricStatistic: {
        InvalidParameterError: GetAccountMetricStatisticInvalidParameterError,
        UnauthorizedError: GetAccountMetricStatisticUnauthorizedError,
        ForbiddenError: GetAccountMetricStatisticForbiddenError,
        NotFoundError: GetAccountMetricStatisticNotFoundError,
        InternalServerError: GetAccountMetricStatisticInternalServerError,
        BadGatewayError: GetAccountMetricStatisticBadGatewayError,
        GatewayTimeoutError: GetAccountMetricStatisticGatewayTimeoutError,
        GenericError: GetAccountMetricStatisticGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountTeamMetricStatistic: {
        InvalidParameterError: GetAccountTeamMetricStatisticInvalidParameterError,
        UnauthorizedError: GetAccountTeamMetricStatisticUnauthorizedError,
        ForbiddenError: GetAccountTeamMetricStatisticForbiddenError,
        NotFoundError: GetAccountTeamMetricStatisticNotFoundError,
        InternalServerError: GetAccountTeamMetricStatisticInternalServerError,
        BadGatewayError: GetAccountTeamMetricStatisticBadGatewayError,
        GatewayTimeoutError: GetAccountTeamMetricStatisticGatewayTimeoutError,
        GenericError: GetAccountTeamMetricStatisticGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountTeamUsage: {
        InvalidParameterError: GetAccountTeamUsageInvalidParameterError,
        UnauthorizedError: GetAccountTeamUsageUnauthorizedError,
        ForbiddenError: GetAccountTeamUsageForbiddenError,
        InternalServerError: GetAccountTeamUsageInternalServerError,
        BadGatewayError: GetAccountTeamUsageBadGatewayError,
        GatewayTimeoutError: GetAccountTeamUsageGatewayTimeoutError,
        GenericError: GetAccountTeamUsageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountTeamUserMetricStatistic: {
        InvalidParameterError: GetAccountTeamUserMetricStatisticInvalidParameterError,
        UnauthorizedError: GetAccountTeamUserMetricStatisticUnauthorizedError,
        ForbiddenError: GetAccountTeamUserMetricStatisticForbiddenError,
        NotFoundError: GetAccountTeamUserMetricStatisticNotFoundError,
        InternalServerError: GetAccountTeamUserMetricStatisticInternalServerError,
        BadGatewayError: GetAccountTeamUserMetricStatisticBadGatewayError,
        GatewayTimeoutError: GetAccountTeamUserMetricStatisticGatewayTimeoutError,
        GenericError: GetAccountTeamUserMetricStatisticGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountTeamUserUsage: {
        InvalidParameterError: GetAccountTeamUserUsageInvalidParameterError,
        UnauthorizedError: GetAccountTeamUserUsageUnauthorizedError,
        ForbiddenError: GetAccountTeamUserUsageForbiddenError,
        InternalServerError: GetAccountTeamUserUsageInternalServerError,
        BadGatewayError: GetAccountTeamUserUsageBadGatewayError,
        GatewayTimeoutError: GetAccountTeamUserUsageGatewayTimeoutError,
        GenericError: GetAccountTeamUserUsageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountTransfer: {
        InvalidParameterError: GetAccountTransferInvalidParameterError,
        UnauthorizedError: GetAccountTransferUnauthorizedError,
        ForbiddenError: GetAccountTransferForbiddenError,
        NotFoundError: GetAccountTransferNotFoundError,
        InternalServerError: GetAccountTransferInternalServerError,
        BadGatewayError: GetAccountTransferBadGatewayError,
        GatewayTimeoutError: GetAccountTransferGatewayTimeoutError,
        GenericError: GetAccountTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountUsage: {
        InvalidParameterError: GetAccountUsageInvalidParameterError,
        UnauthorizedError: GetAccountUsageUnauthorizedError,
        ForbiddenError: GetAccountUsageForbiddenError,
        InternalServerError: GetAccountUsageInternalServerError,
        BadGatewayError: GetAccountUsageBadGatewayError,
        GatewayTimeoutError: GetAccountUsageGatewayTimeoutError,
        GenericError: GetAccountUsageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountUserMetricStatistic: {
        InvalidParameterError: GetAccountUserMetricStatisticInvalidParameterError,
        UnauthorizedError: GetAccountUserMetricStatisticUnauthorizedError,
        ForbiddenError: GetAccountUserMetricStatisticForbiddenError,
        NotFoundError: GetAccountUserMetricStatisticNotFoundError,
        InternalServerError: GetAccountUserMetricStatisticInternalServerError,
        BadGatewayError: GetAccountUserMetricStatisticBadGatewayError,
        GatewayTimeoutError: GetAccountUserMetricStatisticGatewayTimeoutError,
        GenericError: GetAccountUserMetricStatisticGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountUserUsage: {
        InvalidParameterError: GetAccountUserUsageInvalidParameterError,
        UnauthorizedError: GetAccountUserUsageUnauthorizedError,
        ForbiddenError: GetAccountUserUsageForbiddenError,
        InternalServerError: GetAccountUserUsageInternalServerError,
        BadGatewayError: GetAccountUserUsageBadGatewayError,
        GatewayTimeoutError: GetAccountUserUsageGatewayTimeoutError,
        GenericError: GetAccountUserUsageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetDropbox: {
        InvalidParameterError: GetDropboxInvalidParameterError,
        UnauthorizedError: GetDropboxUnauthorizedError,
        ForbiddenError: GetDropboxForbiddenError,
        NotFoundError: GetDropboxNotFoundError,
        InternalServerError: GetDropboxInternalServerError,
        BadGatewayError: GetDropboxBadGatewayError,
        GatewayTimeoutError: GetDropboxGatewayTimeoutError,
        GenericError: GetDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetDropboxPreview: {
        InvalidParameterError: GetDropboxPreviewInvalidParameterError,
        UnauthorizedError: GetDropboxPreviewUnauthorizedError,
        PasswordDoesNotMatchError: GetDropboxPreviewPasswordDoesNotMatchError,
        InvalidSubscriptionError: GetDropboxPreviewInvalidSubscriptionError,
        OwnerUsageExceededError: GetDropboxPreviewOwnerUsageExceededError,
        DropboxDisabledError: GetDropboxPreviewDropboxDisabledError,
        DropboxDeletedError: GetDropboxPreviewDropboxDeletedError,
        DropboxMaxTransferCountError: GetDropboxPreviewDropboxMaxTransferCountError,
        DropboxMaxBytesUploadedError: GetDropboxPreviewDropboxMaxBytesUploadedError,
        ForbiddenError: GetDropboxPreviewForbiddenError,
        NotFoundError: GetDropboxPreviewNotFoundError,
        InternalServerError: GetDropboxPreviewInternalServerError,
        BadGatewayError: GetDropboxPreviewBadGatewayError,
        GatewayTimeoutError: GetDropboxPreviewGatewayTimeoutError,
        GenericError: GetDropboxPreviewGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetManualReview: {
        InvalidParameterError: GetManualReviewInvalidParameterError,
        UnauthorizedError: GetManualReviewUnauthorizedError,
        ForbiddenError: GetManualReviewForbiddenError,
        NotFoundError: GetManualReviewNotFoundError,
        InternalServerError: GetManualReviewInternalServerError,
        BadGatewayError: GetManualReviewBadGatewayError,
        GatewayTimeoutError: GetManualReviewGatewayTimeoutError,
        GenericError: GetManualReviewGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetMetricStatistic: {
        InvalidParameterError: GetMetricStatisticInvalidParameterError,
        UnauthorizedError: GetMetricStatisticUnauthorizedError,
        ForbiddenError: GetMetricStatisticForbiddenError,
        InternalServerError: GetMetricStatisticInternalServerError,
        BadGatewayError: GetMetricStatisticBadGatewayError,
        GatewayTimeoutError: GetMetricStatisticGatewayTimeoutError,
        GenericError: GetMetricStatisticGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetReceipt: {
        InvalidParameterError: GetReceiptInvalidParameterError,
        UnauthorizedError: GetReceiptUnauthorizedError,
        ForbiddenError: GetReceiptForbiddenError,
        NotFoundError: GetReceiptNotFoundError,
        InternalServerError: GetReceiptInternalServerError,
        BadGatewayError: GetReceiptBadGatewayError,
        GatewayTimeoutError: GetReceiptGatewayTimeoutError,
        GenericError: GetReceiptGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetReceiptFile: {
        InvalidParameterError: GetReceiptFileInvalidParameterError,
        UnauthorizedError: GetReceiptFileUnauthorizedError,
        ForbiddenError: GetReceiptFileForbiddenError,
        NotFoundError: GetReceiptFileNotFoundError,
        InternalServerError: GetReceiptFileInternalServerError,
        BadGatewayError: GetReceiptFileBadGatewayError,
        GatewayTimeoutError: GetReceiptFileGatewayTimeoutError,
        GenericError: GetReceiptFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetReceiver: {
        InvalidParameterError: GetReceiverInvalidParameterError,
        UnauthorizedError: GetReceiverUnauthorizedError,
        ForbiddenError: GetReceiverForbiddenError,
        InternalServerError: GetReceiverInternalServerError,
        BadGatewayError: GetReceiverBadGatewayError,
        GatewayTimeoutError: GetReceiverGatewayTimeoutError,
        GenericError: GetReceiverGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetReport: {
        InvalidParameterError: GetReportInvalidParameterError,
        UnauthorizedError: GetReportUnauthorizedError,
        ForbiddenError: GetReportForbiddenError,
        NotFoundError: GetReportNotFoundError,
        InternalServerError: GetReportInternalServerError,
        BadGatewayError: GetReportBadGatewayError,
        GatewayTimeoutError: GetReportGatewayTimeoutError,
        GenericError: GetReportGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetSender: {
        InvalidParameterError: GetSenderInvalidParameterError,
        UnauthorizedError: GetSenderUnauthorizedError,
        ForbiddenError: GetSenderForbiddenError,
        InternalServerError: GetSenderInternalServerError,
        BadGatewayError: GetSenderBadGatewayError,
        GatewayTimeoutError: GetSenderGatewayTimeoutError,
        GenericError: GetSenderGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamDropbox: {
        InvalidParameterError: GetTeamDropboxInvalidParameterError,
        UnauthorizedError: GetTeamDropboxUnauthorizedError,
        ForbiddenError: GetTeamDropboxForbiddenError,
        NotFoundError: GetTeamDropboxNotFoundError,
        InternalServerError: GetTeamDropboxInternalServerError,
        BadGatewayError: GetTeamDropboxBadGatewayError,
        GatewayTimeoutError: GetTeamDropboxGatewayTimeoutError,
        GenericError: GetTeamDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamMetricStatistic: {
        InvalidParameterError: GetTeamMetricStatisticInvalidParameterError,
        UnauthorizedError: GetTeamMetricStatisticUnauthorizedError,
        ForbiddenError: GetTeamMetricStatisticForbiddenError,
        InternalServerError: GetTeamMetricStatisticInternalServerError,
        BadGatewayError: GetTeamMetricStatisticBadGatewayError,
        GatewayTimeoutError: GetTeamMetricStatisticGatewayTimeoutError,
        GenericError: GetTeamMetricStatisticGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamReceipt: {
        InvalidParameterError: GetTeamReceiptInvalidParameterError,
        UnauthorizedError: GetTeamReceiptUnauthorizedError,
        ForbiddenError: GetTeamReceiptForbiddenError,
        NotFoundError: GetTeamReceiptNotFoundError,
        InternalServerError: GetTeamReceiptInternalServerError,
        BadGatewayError: GetTeamReceiptBadGatewayError,
        GatewayTimeoutError: GetTeamReceiptGatewayTimeoutError,
        GenericError: GetTeamReceiptGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamReceiptFile: {
        InvalidParameterError: GetTeamReceiptFileInvalidParameterError,
        UnauthorizedError: GetTeamReceiptFileUnauthorizedError,
        ForbiddenError: GetTeamReceiptFileForbiddenError,
        NotFoundError: GetTeamReceiptFileNotFoundError,
        InternalServerError: GetTeamReceiptFileInternalServerError,
        BadGatewayError: GetTeamReceiptFileBadGatewayError,
        GatewayTimeoutError: GetTeamReceiptFileGatewayTimeoutError,
        GenericError: GetTeamReceiptFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamTransfer: {
        InvalidParameterError: GetTeamTransferInvalidParameterError,
        UnauthorizedError: GetTeamTransferUnauthorizedError,
        ForbiddenError: GetTeamTransferForbiddenError,
        NotFoundError: GetTeamTransferNotFoundError,
        InternalServerError: GetTeamTransferInternalServerError,
        BadGatewayError: GetTeamTransferBadGatewayError,
        GatewayTimeoutError: GetTeamTransferGatewayTimeoutError,
        GenericError: GetTeamTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamTransferFile: {
        InvalidParameterError: GetTeamTransferFileInvalidParameterError,
        UnauthorizedError: GetTeamTransferFileUnauthorizedError,
        ForbiddenError: GetTeamTransferFileForbiddenError,
        NotFoundError: GetTeamTransferFileNotFoundError,
        InternalServerError: GetTeamTransferFileInternalServerError,
        BadGatewayError: GetTeamTransferFileBadGatewayError,
        GatewayTimeoutError: GetTeamTransferFileGatewayTimeoutError,
        GenericError: GetTeamTransferFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamTransferQueue: {
        InvalidParameterError: GetTeamTransferQueueInvalidParameterError,
        UnauthorizedError: GetTeamTransferQueueUnauthorizedError,
        ForbiddenError: GetTeamTransferQueueForbiddenError,
        NotFoundError: GetTeamTransferQueueNotFoundError,
        InternalServerError: GetTeamTransferQueueInternalServerError,
        BadGatewayError: GetTeamTransferQueueBadGatewayError,
        GatewayTimeoutError: GetTeamTransferQueueGatewayTimeoutError,
        GenericError: GetTeamTransferQueueGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamUsage: {
        InvalidParameterError: GetTeamUsageInvalidParameterError,
        UnauthorizedError: GetTeamUsageUnauthorizedError,
        ForbiddenError: GetTeamUsageForbiddenError,
        InternalServerError: GetTeamUsageInternalServerError,
        BadGatewayError: GetTeamUsageBadGatewayError,
        GatewayTimeoutError: GetTeamUsageGatewayTimeoutError,
        GenericError: GetTeamUsageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamUserDropbox: {
        InvalidParameterError: GetTeamUserDropboxInvalidParameterError,
        UnauthorizedError: GetTeamUserDropboxUnauthorizedError,
        ForbiddenError: GetTeamUserDropboxForbiddenError,
        NotFoundError: GetTeamUserDropboxNotFoundError,
        InternalServerError: GetTeamUserDropboxInternalServerError,
        BadGatewayError: GetTeamUserDropboxBadGatewayError,
        GatewayTimeoutError: GetTeamUserDropboxGatewayTimeoutError,
        GenericError: GetTeamUserDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamUserMetricStatistic: {
        InvalidParameterError: GetTeamUserMetricStatisticInvalidParameterError,
        UnauthorizedError: GetTeamUserMetricStatisticUnauthorizedError,
        ForbiddenError: GetTeamUserMetricStatisticForbiddenError,
        InternalServerError: GetTeamUserMetricStatisticInternalServerError,
        BadGatewayError: GetTeamUserMetricStatisticBadGatewayError,
        GatewayTimeoutError: GetTeamUserMetricStatisticGatewayTimeoutError,
        GenericError: GetTeamUserMetricStatisticGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamUserReceipt: {
        InvalidParameterError: GetTeamUserReceiptInvalidParameterError,
        UnauthorizedError: GetTeamUserReceiptUnauthorizedError,
        ForbiddenError: GetTeamUserReceiptForbiddenError,
        NotFoundError: GetTeamUserReceiptNotFoundError,
        InternalServerError: GetTeamUserReceiptInternalServerError,
        BadGatewayError: GetTeamUserReceiptBadGatewayError,
        GatewayTimeoutError: GetTeamUserReceiptGatewayTimeoutError,
        GenericError: GetTeamUserReceiptGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamUserReceiptFile: {
        InvalidParameterError: GetTeamUserReceiptFileInvalidParameterError,
        UnauthorizedError: GetTeamUserReceiptFileUnauthorizedError,
        ForbiddenError: GetTeamUserReceiptFileForbiddenError,
        NotFoundError: GetTeamUserReceiptFileNotFoundError,
        InternalServerError: GetTeamUserReceiptFileInternalServerError,
        BadGatewayError: GetTeamUserReceiptFileBadGatewayError,
        GatewayTimeoutError: GetTeamUserReceiptFileGatewayTimeoutError,
        GenericError: GetTeamUserReceiptFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamUserTransfer: {
        InvalidParameterError: GetTeamUserTransferInvalidParameterError,
        UnauthorizedError: GetTeamUserTransferUnauthorizedError,
        ForbiddenError: GetTeamUserTransferForbiddenError,
        NotFoundError: GetTeamUserTransferNotFoundError,
        InternalServerError: GetTeamUserTransferInternalServerError,
        BadGatewayError: GetTeamUserTransferBadGatewayError,
        GatewayTimeoutError: GetTeamUserTransferGatewayTimeoutError,
        GenericError: GetTeamUserTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamUserUsage: {
        InvalidParameterError: GetTeamUserUsageInvalidParameterError,
        UnauthorizedError: GetTeamUserUsageUnauthorizedError,
        ForbiddenError: GetTeamUserUsageForbiddenError,
        InternalServerError: GetTeamUserUsageInternalServerError,
        BadGatewayError: GetTeamUserUsageBadGatewayError,
        GatewayTimeoutError: GetTeamUserUsageGatewayTimeoutError,
        GenericError: GetTeamUserUsageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTransfer: {
        InvalidParameterError: GetTransferInvalidParameterError,
        UnauthorizedError: GetTransferUnauthorizedError,
        ForbiddenError: GetTransferForbiddenError,
        NotFoundError: GetTransferNotFoundError,
        InternalServerError: GetTransferInternalServerError,
        BadGatewayError: GetTransferBadGatewayError,
        GatewayTimeoutError: GetTransferGatewayTimeoutError,
        GenericError: GetTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTransferFile: {
        InvalidParameterError: GetTransferFileInvalidParameterError,
        UnauthorizedError: GetTransferFileUnauthorizedError,
        ForbiddenError: GetTransferFileForbiddenError,
        NotFoundError: GetTransferFileNotFoundError,
        InternalServerError: GetTransferFileInternalServerError,
        BadGatewayError: GetTransferFileBadGatewayError,
        GatewayTimeoutError: GetTransferFileGatewayTimeoutError,
        GenericError: GetTransferFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTransferFileInternal: {
        InvalidParameterError: GetTransferFileInternalInvalidParameterError,
        UnauthorizedError: GetTransferFileInternalUnauthorizedError,
        ForbiddenError: GetTransferFileInternalForbiddenError,
        NotFoundError: GetTransferFileInternalNotFoundError,
        InternalServerError: GetTransferFileInternalInternalServerError,
        BadGatewayError: GetTransferFileInternalBadGatewayError,
        GatewayTimeoutError: GetTransferFileInternalGatewayTimeoutError,
        GenericError: GetTransferFileInternalGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTransferFilePreview: {
        InvalidParameterError: GetTransferFilePreviewInvalidParameterError,
        UnauthorizedError: GetTransferFilePreviewUnauthorizedError,
        PasswordDoesNotMatchError: GetTransferFilePreviewPasswordDoesNotMatchError,
        ForbiddenError: GetTransferFilePreviewForbiddenError,
        NotFoundError: GetTransferFilePreviewNotFoundError,
        InternalServerError: GetTransferFilePreviewInternalServerError,
        BadGatewayError: GetTransferFilePreviewBadGatewayError,
        GatewayTimeoutError: GetTransferFilePreviewGatewayTimeoutError,
        GenericError: GetTransferFilePreviewGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTransferInternal: {
        InvalidParameterError: GetTransferInternalInvalidParameterError,
        UnauthorizedError: GetTransferInternalUnauthorizedError,
        ForbiddenError: GetTransferInternalForbiddenError,
        NotFoundError: GetTransferInternalNotFoundError,
        InternalServerError: GetTransferInternalInternalServerError,
        BadGatewayError: GetTransferInternalBadGatewayError,
        GatewayTimeoutError: GetTransferInternalGatewayTimeoutError,
        GenericError: GetTransferInternalGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTransferPreview: {
        InvalidParameterError: GetTransferPreviewInvalidParameterError,
        UnauthorizedError: GetTransferPreviewUnauthorizedError,
        PasswordDoesNotMatchError: GetTransferPreviewPasswordDoesNotMatchError,
        InvalidEmailError: GetTransferPreviewInvalidEmailError,
        OwnerUsageExceededError: GetTransferPreviewOwnerUsageExceededError,
        AccessorUsageExceededError: GetTransferPreviewAccessorUsageExceededError,
        ForbiddenError: GetTransferPreviewForbiddenError,
        NotFoundError: GetTransferPreviewNotFoundError,
        InternalServerError: GetTransferPreviewInternalServerError,
        BadGatewayError: GetTransferPreviewBadGatewayError,
        GatewayTimeoutError: GetTransferPreviewGatewayTimeoutError,
        GenericError: GetTransferPreviewGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTransferQueue: {
        InvalidParameterError: GetTransferQueueInvalidParameterError,
        UnauthorizedError: GetTransferQueueUnauthorizedError,
        ForbiddenError: GetTransferQueueForbiddenError,
        NotFoundError: GetTransferQueueNotFoundError,
        InternalServerError: GetTransferQueueInternalServerError,
        BadGatewayError: GetTransferQueueBadGatewayError,
        GatewayTimeoutError: GetTransferQueueGatewayTimeoutError,
        GenericError: GetTransferQueueGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTransferUser: {
        InvalidParameterError: GetTransferUserInvalidParameterError,
        UnauthorizedError: GetTransferUserUnauthorizedError,
        ForbiddenError: GetTransferUserForbiddenError,
        NotFoundError: GetTransferUserNotFoundError,
        InternalServerError: GetTransferUserInternalServerError,
        BadGatewayError: GetTransferUserBadGatewayError,
        GatewayTimeoutError: GetTransferUserGatewayTimeoutError,
        GenericError: GetTransferUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUsage: {
        UnauthorizedError: GetUsageUnauthorizedError,
        ForbiddenError: GetUsageForbiddenError,
        InternalServerError: GetUsageInternalServerError,
        BadGatewayError: GetUsageBadGatewayError,
        GatewayTimeoutError: GetUsageGatewayTimeoutError,
        GenericError: GetUsageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserDropbox: {
        InvalidParameterError: GetUserDropboxInvalidParameterError,
        UnauthorizedError: GetUserDropboxUnauthorizedError,
        ForbiddenError: GetUserDropboxForbiddenError,
        NotFoundError: GetUserDropboxNotFoundError,
        InternalServerError: GetUserDropboxInternalServerError,
        BadGatewayError: GetUserDropboxBadGatewayError,
        GatewayTimeoutError: GetUserDropboxGatewayTimeoutError,
        GenericError: GetUserDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserMetricStatistic: {
        InvalidParameterError: GetUserMetricStatisticInvalidParameterError,
        UnauthorizedError: GetUserMetricStatisticUnauthorizedError,
        ForbiddenError: GetUserMetricStatisticForbiddenError,
        InternalServerError: GetUserMetricStatisticInternalServerError,
        BadGatewayError: GetUserMetricStatisticBadGatewayError,
        GatewayTimeoutError: GetUserMetricStatisticGatewayTimeoutError,
        GenericError: GetUserMetricStatisticGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserReceipt: {
        InvalidParameterError: GetUserReceiptInvalidParameterError,
        UnauthorizedError: GetUserReceiptUnauthorizedError,
        ForbiddenError: GetUserReceiptForbiddenError,
        NotFoundError: GetUserReceiptNotFoundError,
        InternalServerError: GetUserReceiptInternalServerError,
        BadGatewayError: GetUserReceiptBadGatewayError,
        GatewayTimeoutError: GetUserReceiptGatewayTimeoutError,
        GenericError: GetUserReceiptGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserReceiptFile: {
        InvalidParameterError: GetUserReceiptFileInvalidParameterError,
        UnauthorizedError: GetUserReceiptFileUnauthorizedError,
        ForbiddenError: GetUserReceiptFileForbiddenError,
        NotFoundError: GetUserReceiptFileNotFoundError,
        InternalServerError: GetUserReceiptFileInternalServerError,
        BadGatewayError: GetUserReceiptFileBadGatewayError,
        GatewayTimeoutError: GetUserReceiptFileGatewayTimeoutError,
        GenericError: GetUserReceiptFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserTransfer: {
        InvalidParameterError: GetUserTransferInvalidParameterError,
        UnauthorizedError: GetUserTransferUnauthorizedError,
        ForbiddenError: GetUserTransferForbiddenError,
        NotFoundError: GetUserTransferNotFoundError,
        InternalServerError: GetUserTransferInternalServerError,
        BadGatewayError: GetUserTransferBadGatewayError,
        GatewayTimeoutError: GetUserTransferGatewayTimeoutError,
        GenericError: GetUserTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserTransferFile: {
        InvalidParameterError: GetUserTransferFileInvalidParameterError,
        UnauthorizedError: GetUserTransferFileUnauthorizedError,
        ForbiddenError: GetUserTransferFileForbiddenError,
        NotFoundError: GetUserTransferFileNotFoundError,
        InternalServerError: GetUserTransferFileInternalServerError,
        BadGatewayError: GetUserTransferFileBadGatewayError,
        GatewayTimeoutError: GetUserTransferFileGatewayTimeoutError,
        GenericError: GetUserTransferFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserUsage: {
        InvalidParameterError: GetUserUsageInvalidParameterError,
        UnauthorizedError: GetUserUsageUnauthorizedError,
        ForbiddenError: GetUserUsageForbiddenError,
        InternalServerError: GetUserUsageInternalServerError,
        BadGatewayError: GetUserUsageBadGatewayError,
        GatewayTimeoutError: GetUserUsageGatewayTimeoutError,
        GenericError: GetUserUsageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListAccountTransfers: {
        InvalidParameterError: ListAccountTransfersInvalidParameterError,
        UnauthorizedError: ListAccountTransfersUnauthorizedError,
        ForbiddenError: ListAccountTransfersForbiddenError,
        InternalServerError: ListAccountTransfersInternalServerError,
        BadGatewayError: ListAccountTransfersBadGatewayError,
        GatewayTimeoutError: ListAccountTransfersGatewayTimeoutError,
        GenericError: ListAccountTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListDayEvents: {
        InvalidParameterError: ListDayEventsInvalidParameterError,
        UnauthorizedError: ListDayEventsUnauthorizedError,
        ForbiddenError: ListDayEventsForbiddenError,
        InternalServerError: ListDayEventsInternalServerError,
        BadGatewayError: ListDayEventsBadGatewayError,
        GatewayTimeoutError: ListDayEventsGatewayTimeoutError,
        GenericError: ListDayEventsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListDayFiles: {
        InvalidParameterError: ListDayFilesInvalidParameterError,
        UnauthorizedError: ListDayFilesUnauthorizedError,
        ForbiddenError: ListDayFilesForbiddenError,
        InternalServerError: ListDayFilesInternalServerError,
        BadGatewayError: ListDayFilesBadGatewayError,
        GatewayTimeoutError: ListDayFilesGatewayTimeoutError,
        GenericError: ListDayFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListDayTransfers: {
        InvalidParameterError: ListDayTransfersInvalidParameterError,
        UnauthorizedError: ListDayTransfersUnauthorizedError,
        ForbiddenError: ListDayTransfersForbiddenError,
        InternalServerError: ListDayTransfersInternalServerError,
        BadGatewayError: ListDayTransfersBadGatewayError,
        GatewayTimeoutError: ListDayTransfersGatewayTimeoutError,
        GenericError: ListDayTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListDropboxes: {
        InvalidParameterError: ListDropboxesInvalidParameterError,
        UnauthorizedError: ListDropboxesUnauthorizedError,
        ForbiddenError: ListDropboxesForbiddenError,
        InternalServerError: ListDropboxesInternalServerError,
        BadGatewayError: ListDropboxesBadGatewayError,
        GatewayTimeoutError: ListDropboxesGatewayTimeoutError,
        GenericError: ListDropboxesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListHourEvents: {
        InvalidParameterError: ListHourEventsInvalidParameterError,
        UnauthorizedError: ListHourEventsUnauthorizedError,
        ForbiddenError: ListHourEventsForbiddenError,
        InternalServerError: ListHourEventsInternalServerError,
        BadGatewayError: ListHourEventsBadGatewayError,
        GatewayTimeoutError: ListHourEventsGatewayTimeoutError,
        GenericError: ListHourEventsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListHourFiles: {
        InvalidParameterError: ListHourFilesInvalidParameterError,
        UnauthorizedError: ListHourFilesUnauthorizedError,
        ForbiddenError: ListHourFilesForbiddenError,
        InternalServerError: ListHourFilesInternalServerError,
        BadGatewayError: ListHourFilesBadGatewayError,
        GatewayTimeoutError: ListHourFilesGatewayTimeoutError,
        GenericError: ListHourFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListHourTransfers: {
        InvalidParameterError: ListHourTransfersInvalidParameterError,
        UnauthorizedError: ListHourTransfersUnauthorizedError,
        ForbiddenError: ListHourTransfersForbiddenError,
        InternalServerError: ListHourTransfersInternalServerError,
        BadGatewayError: ListHourTransfersBadGatewayError,
        GatewayTimeoutError: ListHourTransfersGatewayTimeoutError,
        GenericError: ListHourTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListManualReviews: {
        UnauthorizedError: ListManualReviewsUnauthorizedError,
        ForbiddenError: ListManualReviewsForbiddenError,
        InternalServerError: ListManualReviewsInternalServerError,
        BadGatewayError: ListManualReviewsBadGatewayError,
        GatewayTimeoutError: ListManualReviewsGatewayTimeoutError,
        GenericError: ListManualReviewsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListMonthEvents: {
        InvalidParameterError: ListMonthEventsInvalidParameterError,
        UnauthorizedError: ListMonthEventsUnauthorizedError,
        ForbiddenError: ListMonthEventsForbiddenError,
        InternalServerError: ListMonthEventsInternalServerError,
        BadGatewayError: ListMonthEventsBadGatewayError,
        GatewayTimeoutError: ListMonthEventsGatewayTimeoutError,
        GenericError: ListMonthEventsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListMonthFiles: {
        InvalidParameterError: ListMonthFilesInvalidParameterError,
        UnauthorizedError: ListMonthFilesUnauthorizedError,
        ForbiddenError: ListMonthFilesForbiddenError,
        InternalServerError: ListMonthFilesInternalServerError,
        BadGatewayError: ListMonthFilesBadGatewayError,
        GatewayTimeoutError: ListMonthFilesGatewayTimeoutError,
        GenericError: ListMonthFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListMonthTransfers: {
        InvalidParameterError: ListMonthTransfersInvalidParameterError,
        UnauthorizedError: ListMonthTransfersUnauthorizedError,
        ForbiddenError: ListMonthTransfersForbiddenError,
        InternalServerError: ListMonthTransfersInternalServerError,
        BadGatewayError: ListMonthTransfersBadGatewayError,
        GatewayTimeoutError: ListMonthTransfersGatewayTimeoutError,
        GenericError: ListMonthTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListReceiptFiles: {
        InvalidParameterError: ListReceiptFilesInvalidParameterError,
        UnauthorizedError: ListReceiptFilesUnauthorizedError,
        ForbiddenError: ListReceiptFilesForbiddenError,
        NotFoundError: ListReceiptFilesNotFoundError,
        InternalServerError: ListReceiptFilesInternalServerError,
        BadGatewayError: ListReceiptFilesBadGatewayError,
        GatewayTimeoutError: ListReceiptFilesGatewayTimeoutError,
        GenericError: ListReceiptFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListReceipts: {
        InvalidParameterError: ListReceiptsInvalidParameterError,
        UnauthorizedError: ListReceiptsUnauthorizedError,
        ForbiddenError: ListReceiptsForbiddenError,
        InternalServerError: ListReceiptsInternalServerError,
        BadGatewayError: ListReceiptsBadGatewayError,
        GatewayTimeoutError: ListReceiptsGatewayTimeoutError,
        GenericError: ListReceiptsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListReceiverTransfers: {
        InvalidParameterError: ListReceiverTransfersInvalidParameterError,
        UnauthorizedError: ListReceiverTransfersUnauthorizedError,
        ForbiddenError: ListReceiverTransfersForbiddenError,
        NotFoundError: ListReceiverTransfersNotFoundError,
        InternalServerError: ListReceiverTransfersInternalServerError,
        BadGatewayError: ListReceiverTransfersBadGatewayError,
        GatewayTimeoutError: ListReceiverTransfersGatewayTimeoutError,
        GenericError: ListReceiverTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListSenderTransfers: {
        InvalidParameterError: ListSenderTransfersInvalidParameterError,
        UnauthorizedError: ListSenderTransfersUnauthorizedError,
        ForbiddenError: ListSenderTransfersForbiddenError,
        InternalServerError: ListSenderTransfersInternalServerError,
        BadGatewayError: ListSenderTransfersBadGatewayError,
        GatewayTimeoutError: ListSenderTransfersGatewayTimeoutError,
        GenericError: ListSenderTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamDropboxes: {
        InvalidParameterError: ListTeamDropboxesInvalidParameterError,
        UnauthorizedError: ListTeamDropboxesUnauthorizedError,
        ForbiddenError: ListTeamDropboxesForbiddenError,
        InternalServerError: ListTeamDropboxesInternalServerError,
        BadGatewayError: ListTeamDropboxesBadGatewayError,
        GatewayTimeoutError: ListTeamDropboxesGatewayTimeoutError,
        GenericError: ListTeamDropboxesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamReceiptFiles: {
        InvalidParameterError: ListTeamReceiptFilesInvalidParameterError,
        UnauthorizedError: ListTeamReceiptFilesUnauthorizedError,
        ForbiddenError: ListTeamReceiptFilesForbiddenError,
        NotFoundError: ListTeamReceiptFilesNotFoundError,
        InternalServerError: ListTeamReceiptFilesInternalServerError,
        BadGatewayError: ListTeamReceiptFilesBadGatewayError,
        GatewayTimeoutError: ListTeamReceiptFilesGatewayTimeoutError,
        GenericError: ListTeamReceiptFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamReceipts: {
        InvalidParameterError: ListTeamReceiptsInvalidParameterError,
        UnauthorizedError: ListTeamReceiptsUnauthorizedError,
        ForbiddenError: ListTeamReceiptsForbiddenError,
        InternalServerError: ListTeamReceiptsInternalServerError,
        BadGatewayError: ListTeamReceiptsBadGatewayError,
        GatewayTimeoutError: ListTeamReceiptsGatewayTimeoutError,
        GenericError: ListTeamReceiptsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamTransferEvents: {
        InvalidParameterError: ListTeamTransferEventsInvalidParameterError,
        UnauthorizedError: ListTeamTransferEventsUnauthorizedError,
        ForbiddenError: ListTeamTransferEventsForbiddenError,
        NotFoundError: ListTeamTransferEventsNotFoundError,
        InternalServerError: ListTeamTransferEventsInternalServerError,
        BadGatewayError: ListTeamTransferEventsBadGatewayError,
        GatewayTimeoutError: ListTeamTransferEventsGatewayTimeoutError,
        GenericError: ListTeamTransferEventsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamTransferFiles: {
        InvalidParameterError: ListTeamTransferFilesInvalidParameterError,
        UnauthorizedError: ListTeamTransferFilesUnauthorizedError,
        ForbiddenError: ListTeamTransferFilesForbiddenError,
        NotFoundError: ListTeamTransferFilesNotFoundError,
        InternalServerError: ListTeamTransferFilesInternalServerError,
        BadGatewayError: ListTeamTransferFilesBadGatewayError,
        GatewayTimeoutError: ListTeamTransferFilesGatewayTimeoutError,
        GenericError: ListTeamTransferFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamTransfers: {
        InvalidParameterError: ListTeamTransfersInvalidParameterError,
        UnauthorizedError: ListTeamTransfersUnauthorizedError,
        ForbiddenError: ListTeamTransfersForbiddenError,
        NotFoundError: ListTeamTransfersNotFoundError,
        InternalServerError: ListTeamTransfersInternalServerError,
        BadGatewayError: ListTeamTransfersBadGatewayError,
        GatewayTimeoutError: ListTeamTransfersGatewayTimeoutError,
        GenericError: ListTeamTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamUserDropboxes: {
        InvalidParameterError: ListTeamUserDropboxesInvalidParameterError,
        UnauthorizedError: ListTeamUserDropboxesUnauthorizedError,
        ForbiddenError: ListTeamUserDropboxesForbiddenError,
        InternalServerError: ListTeamUserDropboxesInternalServerError,
        BadGatewayError: ListTeamUserDropboxesBadGatewayError,
        GatewayTimeoutError: ListTeamUserDropboxesGatewayTimeoutError,
        GenericError: ListTeamUserDropboxesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamUserReceiptFiles: {
        InvalidParameterError: ListTeamUserReceiptFilesInvalidParameterError,
        UnauthorizedError: ListTeamUserReceiptFilesUnauthorizedError,
        ForbiddenError: ListTeamUserReceiptFilesForbiddenError,
        NotFoundError: ListTeamUserReceiptFilesNotFoundError,
        InternalServerError: ListTeamUserReceiptFilesInternalServerError,
        BadGatewayError: ListTeamUserReceiptFilesBadGatewayError,
        GatewayTimeoutError: ListTeamUserReceiptFilesGatewayTimeoutError,
        GenericError: ListTeamUserReceiptFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamUserReceipts: {
        InvalidParameterError: ListTeamUserReceiptsInvalidParameterError,
        UnauthorizedError: ListTeamUserReceiptsUnauthorizedError,
        ForbiddenError: ListTeamUserReceiptsForbiddenError,
        InternalServerError: ListTeamUserReceiptsInternalServerError,
        BadGatewayError: ListTeamUserReceiptsBadGatewayError,
        GatewayTimeoutError: ListTeamUserReceiptsGatewayTimeoutError,
        GenericError: ListTeamUserReceiptsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamUserTransfers: {
        InvalidParameterError: ListTeamUserTransfersInvalidParameterError,
        UnauthorizedError: ListTeamUserTransfersUnauthorizedError,
        ForbiddenError: ListTeamUserTransfersForbiddenError,
        InternalServerError: ListTeamUserTransfersInternalServerError,
        BadGatewayError: ListTeamUserTransfersBadGatewayError,
        GatewayTimeoutError: ListTeamUserTransfersGatewayTimeoutError,
        GenericError: ListTeamUserTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTransferEvents: {
        InvalidParameterError: ListTransferEventsInvalidParameterError,
        UnauthorizedError: ListTransferEventsUnauthorizedError,
        ForbiddenError: ListTransferEventsForbiddenError,
        NotFoundError: ListTransferEventsNotFoundError,
        InternalServerError: ListTransferEventsInternalServerError,
        BadGatewayError: ListTransferEventsBadGatewayError,
        GatewayTimeoutError: ListTransferEventsGatewayTimeoutError,
        GenericError: ListTransferEventsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTransferFiles: {
        InvalidParameterError: ListTransferFilesInvalidParameterError,
        UnauthorizedError: ListTransferFilesUnauthorizedError,
        ForbiddenError: ListTransferFilesForbiddenError,
        NotFoundError: ListTransferFilesNotFoundError,
        InternalServerError: ListTransferFilesInternalServerError,
        BadGatewayError: ListTransferFilesBadGatewayError,
        GatewayTimeoutError: ListTransferFilesGatewayTimeoutError,
        GenericError: ListTransferFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    Download: {
        BadRequestError: DownloadBadRequestError,
        UnauthorizedError: DownloadUnauthorizedError,
        FobiddenError: DownloadFobiddenError,
        NotFoundError: DownloadNotFoundError,
        InternalServerError: DownloadInternalServerError,
        BadGatewayError: DownloadBadGatewayError,
        GatewayTimeoutError: DownloadGatewayTimeoutError,
        GenericError: DownloadGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UploadTransferFilePart: {
        BadRequestError: UploadTransferFilePartBadRequestError,
        InternalServerError: UploadTransferFilePartInternalServerError,
        NotFoundError: UploadTransferFilePartNotFoundError,
        NoSuchUploadError: UploadTransferFilePartNoSuchUploadError,
        AccessControlListNotSupportedError: UploadTransferFilePartAccessControlListNotSupportedError,
        AccessDeniedError: UploadTransferFilePartAccessDeniedError,
        AccessPointAlreadyOwnedByYouError: UploadTransferFilePartAccessPointAlreadyOwnedByYouError,
        AccountProblemError: UploadTransferFilePartAccountProblemError,
        AllAccessDisabledError: UploadTransferFilePartAllAccessDisabledError,
        AmbiguousGrantByEmailAddressError: UploadTransferFilePartAmbiguousGrantByEmailAddressError,
        AuthorizationHeaderMalformedError: UploadTransferFilePartAuthorizationHeaderMalformedError,
        BadDigestError: UploadTransferFilePartBadDigestError,
        EntityTooSmallError: UploadTransferFilePartEntityTooSmallError,
        EntityTooLargeError: UploadTransferFilePartEntityTooLargeError,
        ExpiredTokenError: UploadTransferFilePartExpiredTokenError,
        IllegalLocationConstraintExceptionError: UploadTransferFilePartIllegalLocationConstraintExceptionError,
        IllegalVersioningConfigurationExceptionError: UploadTransferFilePartIllegalVersioningConfigurationExceptionError,
        IncompleteBodyError: UploadTransferFilePartIncompleteBodyError,
        InlineDataTooLargeError: UploadTransferFilePartInlineDataTooLargeError,
        InternalError: UploadTransferFilePartInternalError,
        InvalidAccessKeyIdError: UploadTransferFilePartInvalidAccessKeyIdError,
        InvalidArgumentError: UploadTransferFilePartInvalidArgumentError,
        InvalidBucketNameError: UploadTransferFilePartInvalidBucketNameError,
        InvalidBucketStateError: UploadTransferFilePartInvalidBucketStateError,
        InvalidDigestError: UploadTransferFilePartInvalidDigestError,
        InvalidLocationConstraintError: UploadTransferFilePartInvalidLocationConstraintError,
        InvalidObjectStateError: UploadTransferFilePartInvalidObjectStateError,
        InvalidPartError: UploadTransferFilePartInvalidPartError,
        InvalidPartOrderError: UploadTransferFilePartInvalidPartOrderError,
        InvalidPayerError: UploadTransferFilePartInvalidPayerError,
        InvalidPolicyDocumentError: UploadTransferFilePartInvalidPolicyDocumentError,
        InvalidRangeError: UploadTransferFilePartInvalidRangeError,
        InvalidRequestError: UploadTransferFilePartInvalidRequestError,
        InvalidSecurityError: UploadTransferFilePartInvalidSecurityError,
        InvalidTokenError: UploadTransferFilePartInvalidTokenError,
        InvalidURIError: UploadTransferFilePartInvalidURIError,
        KeyTooLongError: UploadTransferFilePartKeyTooLongError,
        MaxMessageLengthExceededError: UploadTransferFilePartMaxMessageLengthExceededError,
        MetadataTooLargeError: UploadTransferFilePartMetadataTooLargeError,
        MissingContentLengthError: UploadTransferFilePartMissingContentLengthError,
        MissingRequestBodyError: UploadTransferFilePartMissingRequestBodyError,
        MissingSecurityHeaderError: UploadTransferFilePartMissingSecurityHeaderError,
        NoSuchBucketError: UploadTransferFilePartNoSuchBucketError,
        NoSuchBucketPolicyError: UploadTransferFilePartNoSuchBucketPolicyError,
        NoSuchCORSConfigurationError: UploadTransferFilePartNoSuchCORSConfigurationError,
        NoSuchKeyError: UploadTransferFilePartNoSuchKeyError,
        NotImplementedError: UploadTransferFilePartNotImplementedError,
        RequestHeaderSectionTooLargeError: UploadTransferFilePartRequestHeaderSectionTooLargeError,
        RequestTimeoutError: UploadTransferFilePartRequestTimeoutError,
        RequestTimeTooSkewedError: UploadTransferFilePartRequestTimeTooSkewedError,
        ServerSideEncryptionConfigurationNotFoundError: UploadTransferFilePartServerSideEncryptionConfigurationNotFoundError,
        ServiceUnavailableError: UploadTransferFilePartServiceUnavailableError,
        SignatureDoesNotMatchError: UploadTransferFilePartSignatureDoesNotMatchError,
        SlowDownError: UploadTransferFilePartSlowDownError,
        TokenRefreshRequiredError: UploadTransferFilePartTokenRefreshRequiredError,
        UnexpectedContentError: UploadTransferFilePartUnexpectedContentError,
        UserKeyMustBeSpecifiedError: UploadTransferFilePartUserKeyMustBeSpecifiedError,
        EtagIsMissingError: UploadTransferFilePartEtagIsMissingError,
        AuthorizationQueryParametersError: UploadTransferFilePartAuthorizationQueryParametersError,
        ConditionalRequestConflictError: UploadTransferFilePartConditionalRequestConflictError,
        EndpointNotFoundError: UploadTransferFilePartEndpointNotFoundError,
        IncorrectEndpointError: UploadTransferFilePartIncorrectEndpointError,
        InvalidAccessPointError: UploadTransferFilePartInvalidAccessPointError,
        InvalidAccessPointAliasError: UploadTransferFilePartInvalidAccessPointAliasError,
        InvalidAddressingHeaderError: UploadTransferFilePartInvalidAddressingHeaderError,
        InvalidEncryptionAlgorithmError: UploadTransferFilePartInvalidEncryptionAlgorithmError,
        InvalidHostHeaderError: UploadTransferFilePartInvalidHostHeaderError,
        InvalidSessionExceptionError: UploadTransferFilePartInvalidSessionExceptionError,
        InvalidSignatureError: UploadTransferFilePartInvalidSignatureError,
        InvalidStorageClassError: UploadTransferFilePartInvalidStorageClassError,
        MissingAuthenticationTokenError: UploadTransferFilePartMissingAuthenticationTokenError,
        TokenCodeInvalidError: UploadTransferFilePartTokenCodeInvalidError,
        UnauthorizedAccessError: UploadTransferFilePartUnauthorizedAccessError,
        UnexpectedIPError: UploadTransferFilePartUnexpectedIPError,
        UnsupportedArgumentError: UploadTransferFilePartUnsupportedArgumentError,
        UnsupportedSignatureError: UploadTransferFilePartUnsupportedSignatureError,
        NoSuchAccessPointError: UploadTransferFilePartNoSuchAccessPointError,
        GenericError: UploadTransferFilePartGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTransferFilesInternalError: {
        InvalidParameterError: ListTransferFilesInternalInvalidParameterError,
        UnauthorizedError: ListTransferFilesInternalUnauthorizedError,
        ForbiddenError: ListTransferFilesInternalForbiddenError,
        NotFoundError: ListTransferFilesInternalNotFoundError,
        InternalServerError: ListTransferFilesInternalInternalServerError,
        BadGatewayError: ListTransferFilesInternalBadGatewayError,
        GatewayTimeoutError: ListTransferFilesInternalGatewayTimeoutError,
        GenericError: ListTransferFilesInternalGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTransferFilesPreviewError: {
        InvalidParameterError: ListTransferFilesPreviewInvalidParameterError,
        UnauthorizedError: ListTransferFilesPreviewUnauthorizedError,
        PasswordDoesNotMatchError: ListTransferFilesPreviewPasswordDoesNotMatchError,
        OwnerUsageExceededError: ListTransferFilesPreviewOwnerUsageExceededError,
        AccessorUsageExceededError: ListTransferFilesPreviewAccessorUsageExceededError,
        ForbiddenError: ListTransferFilesPreviewForbiddenError,
        NotFoundError: ListTransferFilesPreviewNotFoundError,
        InternalServerError: ListTransferFilesPreviewInternalServerError,
        BadGatewayError: ListTransferFilesPreviewBadGatewayError,
        GatewayTimeoutError: ListTransferFilesPreviewGatewayTimeoutError,
        GenericError: ListTransferFilesPreviewGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTransfersError: {
        InvalidParameterError: ListTransfersInvalidParameterError,
        UnauthorizedError: ListTransfersUnauthorizedError,
        ForbiddenError: ListTransfersForbiddenError,
        NotFoundError: ListTransfersNotFoundError,
        InternalServerError: ListTransfersInternalServerError,
        BadGatewayError: ListTransfersBadGatewayError,
        GatewayTimeoutError: ListTransfersGatewayTimeoutError,
        GenericError: ListTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserDropboxesError: {
        InvalidParameterError: ListUserDropboxesInvalidParameterError,
        UnauthorizedError: ListUserDropboxesUnauthorizedError,
        ForbiddenError: ListUserDropboxesForbiddenError,
        InternalServerError: ListUserDropboxesInternalServerError,
        BadGatewayError: ListUserDropboxesBadGatewayError,
        GatewayTimeoutError: ListUserDropboxesGatewayTimeoutError,
        GenericError: ListUserDropboxesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserReceiptFilesError: {
        InvalidParameterError: ListUserReceiptFilesInvalidParameterError,
        UnauthorizedError: ListUserReceiptFilesUnauthorizedError,
        ForbiddenError: ListUserReceiptFilesForbiddenError,
        NotFoundError: ListUserReceiptFilesNotFoundError,
        InternalServerError: ListUserReceiptFilesInternalServerError,
        BadGatewayError: ListUserReceiptFilesBadGatewayError,
        GatewayTimeoutError: ListUserReceiptFilesGatewayTimeoutError,
        GenericError: ListUserReceiptFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserReceiptsError: {
        InvalidParameterError: ListUserReceiptsInvalidParameterError,
        UnauthorizedError: ListUserReceiptsUnauthorizedError,
        ForbiddenError: ListUserReceiptsForbiddenError,
        InternalServerError: ListUserReceiptsInternalServerError,
        BadGatewayError: ListUserReceiptsBadGatewayError,
        GatewayTimeoutError: ListUserReceiptsGatewayTimeoutError,
        GenericError: ListUserReceiptsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserTransferEventsError: {
        InvalidParameterError: ListUserTransferEventsInvalidParameterError,
        UnauthorizedError: ListUserTransferEventsUnauthorizedError,
        ForbiddenError: ListUserTransferEventsForbiddenError,
        NotFoundError: ListUserTransferEventsNotFoundError,
        InternalServerError: ListUserTransferEventsInternalServerError,
        BadGatewayError: ListUserTransferEventsBadGatewayError,
        GatewayTimeoutError: ListUserTransferEventsGatewayTimeoutError,
        GenericError: ListUserTransferEventsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserTransferFilesError: {
        InvalidParameterError: ListUserTransferFilesInvalidParameterError,
        UnauthorizedError: ListUserTransferFilesUnauthorizedError,
        ForbiddenError: ListUserTransferFilesForbiddenError,
        NotFoundError: ListUserTransferFilesNotFoundError,
        InternalServerError: ListUserTransferFilesInternalServerError,
        BadGatewayError: ListUserTransferFilesBadGatewayError,
        GatewayTimeoutError: ListUserTransferFilesGatewayTimeoutError,
        GenericError: ListUserTransferFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListUserTransfersError: {
        InvalidParameterError: ListUserTransfersInvalidParameterError,
        UnauthorizedError: ListUserTransfersUnauthorizedError,
        ForbiddenError: ListUserTransfersForbiddenError,
        NotFoundError: ListUserTransfersNotFoundError,
        InternalServerError: ListUserTransfersInternalServerError,
        BadGatewayError: ListUserTransfersBadGatewayError,
        GatewayTimeoutError: ListUserTransfersGatewayTimeoutError,
        GenericError: ListUserTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListYearEventsError: {
        InvalidParameterError: ListYearEventsInvalidParameterError,
        UnauthorizedError: ListYearEventsUnauthorizedError,
        ForbiddenError: ListYearEventsForbiddenError,
        InternalServerError: ListYearEventsInternalServerError,
        BadGatewayError: ListYearEventsBadGatewayError,
        GatewayTimeoutError: ListYearEventsGatewayTimeoutError,
        GenericError: ListYearEventsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListYearFilesError: {
        InvalidParameterError: ListYearFilesInvalidParameterError,
        UnauthorizedError: ListYearFilesUnauthorizedError,
        ForbiddenError: ListYearFilesForbiddenError,
        InternalServerError: ListYearFilesInternalServerError,
        BadGatewayError: ListYearFilesBadGatewayError,
        GatewayTimeoutError: ListYearFilesGatewayTimeoutError,
        GenericError: ListYearFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListYearTransfersError: {
        InvalidParameterError: ListYearTransfersInvalidParameterError,
        UnauthorizedError: ListYearTransfersUnauthorizedError,
        ForbiddenError: ListYearTransfersForbiddenError,
        InternalServerError: ListYearTransfersInternalServerError,
        BadGatewayError: ListYearTransfersBadGatewayError,
        GatewayTimeoutError: ListYearTransfersGatewayTimeoutError,
        GenericError: ListYearTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    LockTransferError: {
        InvalidParameterError: LockTransferInvalidParameterError,
        UnauthorizedError: LockTransferUnauthorizedError,
        TransferAlreadyLockedError: LockTransferTransferAlreadyLockedError,
        TransferIsDirtyError: LockTransferTransferIsDirtyError,
        TransferIsInQueueError: LockTransferTransferIsInQueueError,
        ForbiddenError: LockTransferForbiddenError,
        NotFoundError: LockTransferNotFoundError,
        InternalServerError: LockTransferInternalServerError,
        BadGatewayError: LockTransferBadGatewayError,
        GatewayTimeoutError: LockTransferGatewayTimeoutError,
        GenericError: LockTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateDropboxError: {
        InvalidParameterError: UpdateDropboxInvalidParameterError,
        UnauthorizedError: UpdateDropboxUnauthorizedError,
        ForbiddenError: UpdateDropboxForbiddenError,
        NotFoundError: UpdateDropboxNotFoundError,
        InternalServerError: UpdateDropboxInternalServerError,
        BadGatewayError: UpdateDropboxBadGatewayError,
        GatewayTimeoutError: UpdateDropboxGatewayTimeoutError,
        GenericError: UpdateDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateManualReviewError: {
        InvalidParameterError: UpdateManualReviewInvalidParameterError,
        UnauthorizedError: UpdateManualReviewUnauthorizedError,
        ForbiddenError: UpdateManualReviewForbiddenError,
        NotFoundError: UpdateManualReviewNotFoundError,
        InternalServerError: UpdateManualReviewInternalServerError,
        BadGatewayError: UpdateManualReviewBadGatewayError,
        GatewayTimeoutError: UpdateManualReviewGatewayTimeoutError,
        GenericError: UpdateManualReviewGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTeamDropboxError: {
        InvalidParameterError: UpdateTeamDropboxInvalidParameterError,
        UnauthorizedError: UpdateTeamDropboxUnauthorizedError,
        ForbiddenError: UpdateTeamDropboxForbiddenError,
        NotFoundError: UpdateTeamDropboxNotFoundError,
        InternalServerError: UpdateTeamDropboxInternalServerError,
        BadGatewayError: UpdateTeamDropboxBadGatewayError,
        GatewayTimeoutError: UpdateTeamDropboxGatewayTimeoutError,
        GenericError: UpdateTeamDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTeamUserDropboxError: {
        InvalidParameterError: UpdateTeamUserDropboxInvalidParameterError,
        UnauthorizedError: UpdateTeamUserDropboxUnauthorizedError,
        ForbiddenError: UpdateTeamUserDropboxForbiddenError,
        NotFoundError: UpdateTeamUserDropboxNotFoundError,
        InternalServerError: UpdateTeamUserDropboxInternalServerError,
        BadGatewayError: UpdateTeamUserDropboxBadGatewayError,
        GatewayTimeoutError: UpdateTeamUserDropboxGatewayTimeoutError,
        GenericError: UpdateTeamUserDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTransferError: {
        InvalidParameterError: UpdateTransferInvalidParameterError,
        UnauthorizedError: UpdateTransferUnauthorizedError,
        TransferAlreadyLockedError: UpdateTransferTransferAlreadyLockedError,
        ForbiddenError: UpdateTransferForbiddenError,
        NotFoundError: UpdateTransferNotFoundError,
        InternalServerError: UpdateTransferInternalServerError,
        BadGatewayError: UpdateTransferBadGatewayError,
        GatewayTimeoutError: UpdateTransferGatewayTimeoutError,
        GenericError: UpdateTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTransferCustomizationError: {
        InvalidParameterError: UpdateTransferCustomizationInvalidParameterError,
        UnauthorizedError: UpdateTransferCustomizationUnauthorizedError,
        ForbiddenError: UpdateTransferCustomizationForbiddenError,
        NotFoundError: UpdateTransferCustomizationNotFoundError,
        InternalServerError: UpdateTransferCustomizationInternalServerError,
        BadGatewayError: UpdateTransferCustomizationBadGatewayError,
        GatewayTimeoutError: UpdateTransferCustomizationGatewayTimeoutError,
        GenericError: UpdateTransferCustomizationGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTransferFileError: {
        InvalidParameterError: UpdateTransferFileInvalidParameterError,
        UnauthorizedError: UpdateTransferFileUnauthorizedError,
        TransferAlreadyLockedError: UpdateTransferFileTransferAlreadyLockedError,
        FileAlreadyLockedError: UpdateTransferFileFileAlreadyLockedError,
        ForbiddenError: UpdateTransferFileForbiddenError,
        NotFoundError: UpdateTransferFileNotFoundError,
        InternalServerError: UpdateTransferFileInternalServerError,
        BadGatewayError: UpdateTransferFileBadGatewayError,
        GatewayTimeoutError: UpdateTransferFileGatewayTimeoutError,
        GenericError: UpdateTransferFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTransferFilePartError: {
        InvalidParameterError: UpdateTransferFilePartInvalidParameterError,
        UnauthorizedError: UpdateTransferFilePartUnauthorizedError,
        TransferAlreadyLockedError: UpdateTransferFilePartTransferAlreadyLockedError,
        FileAlreadyLockedError: UpdateTransferFilePartFileAlreadyLockedError,
        ForbiddenError: UpdateTransferFilePartForbiddenError,
        NotFoundError: UpdateTransferFilePartNotFoundError,
        InternalServerError: UpdateTransferFilePartInternalServerError,
        BadGatewayError: UpdateTransferFilePartBadGatewayError,
        GatewayTimeoutError: UpdateTransferFilePartGatewayTimeoutError,
        GenericError: UpdateTransferFilePartGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateTransferFilePartsError: {
        InvalidParameterError: UpdateTransferFilePartsInvalidParameterError,
        UnauthorizedError: UpdateTransferFilePartsUnauthorizedError,
        TransferAlreadyLockedError: UpdateTransferFilePartsTransferAlreadyLockedError,
        FileAlreadyLockedError: UpdateTransferFilePartsFileAlreadyLockedError,
        ForbiddenError: UpdateTransferFilePartsForbiddenError,
        NotFoundError: UpdateTransferFilePartsNotFoundError,
        InternalServerError: UpdateTransferFilePartsInternalServerError,
        BadGatewayError: UpdateTransferFilePartsBadGatewayError,
        GatewayTimeoutError: UpdateTransferFilePartsGatewayTimeoutError,
        GenericError: UpdateTransferFilePartsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UpdateUserDropboxError: {
        InvalidParameterError: UpdateUserDropboxInvalidParameterError,
        UnauthorizedError: UpdateUserDropboxUnauthorizedError,
        ForbiddenError: UpdateUserDropboxForbiddenError,
        NotFoundError: UpdateUserDropboxNotFoundError,
        InternalServerError: UpdateUserDropboxInternalServerError,
        BadGatewayError: UpdateUserDropboxBadGatewayError,
        GatewayTimeoutError: UpdateUserDropboxGatewayTimeoutError,
        GenericError: UpdateUserDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateDropboxError: {
        InvalidParameterError: CreateDropboxInvalidParameterError,
        UnauthorizedError: CreateDropboxUnauthorizedError,
        InvalidSubscriptionError: CreateDropboxInvalidSubscriptionError,
        ForbiddenError: CreateDropboxForbiddenError,
        InternalServerError: CreateDropboxInternalServerError,
        BadGatewayError: CreateDropboxBadGatewayError,
        GatewayTimeoutError: CreateDropboxGatewayTimeoutError,
        GenericError: CreateDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateDropboxTransferError: {
        MissingSenderError: CreateDropboxTransferMissingSenderError,
        MissingReceiversError: CreateDropboxTransferMissingReceiversError,
        InvalidDeliveryError: CreateDropboxTransferInvalidDeliveryError,
        InvalidAvailabilityDurationError: CreateDropboxTransferInvalidAvailabilityDurationError,
        InvalidParameterError: CreateDropboxTransferInvalidParameterError,
        UnauthorizedError: CreateDropboxTransferUnauthorizedError,
        PasswordDoesNotMatchError: CreateDropboxTransferPasswordDoesNotMatchError,
        InvalidSubscriptionError: CreateDropboxTransferInvalidSubscriptionError,
        EmailNotAllowedError: CreateDropboxTransferEmailNotAllowedError,
        OwnerUsageExceededError: CreateDropboxTransferOwnerUsageExceededError,
        PasswordRequiredError: CreateDropboxTransferPasswordRequiredError,
        TeamConfigurationError: CreateDropboxTransferTeamConfigurationError,
        DropboxDisabledError: CreateDropboxTransferDropboxDisabledError,
        DropboxDeletedError: CreateDropboxTransferDropboxDeletedError,
        DropboxMaxTransferCountError: CreateDropboxTransferDropboxMaxTransferCountError,
        DropboxMaxBytesUploadedError: CreateDropboxTransferDropboxMaxBytesUploadedError,
        ForbiddenError: CreateDropboxTransferForbiddenError,
        NotFoundError: CreateDropboxTransferNotFoundError,
        CustomUrlAlreadyInUseError: CreateDropboxTransferCustomUrlAlreadyInUseError,
        InternalServerError: CreateDropboxTransferInternalServerError,
        BadGatewayError: CreateDropboxTransferBadGatewayError,
        GatewayTimeoutError: CreateDropboxTransferGatewayTimeoutError,
        GenericError: CreateDropboxTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTeamDropboxError: {
        InvalidParameterError: CreateTeamDropboxInvalidParameterError,
        UnauthorizedError: CreateTeamDropboxUnauthorizedError,
        InvalidSubscriptionError: CreateTeamDropboxInvalidSubscriptionError,
        ForbiddenError: CreateTeamDropboxForbiddenError,
        NotFoundError: CreateTeamDropboxNotFoundError,
        InternalServerError: CreateTeamDropboxInternalServerError,
        BadGatewayError: CreateTeamDropboxBadGatewayError,
        GatewayTimeoutError: CreateTeamDropboxGatewayTimeoutError,
        GenericError: CreateTeamDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTeamTransferError: {
        InvalidAvailabilityDurationError: CreateTeamTransferInvalidAvailabilityDurationError,
        InvalidParameterError: CreateTeamTransferInvalidParameterError,
        UnauthorizedError: CreateTeamTransferUnauthorizedError,
        InvalidSubscriptionError: CreateTeamTransferInvalidSubscriptionError,
        EmailNotAllowedError: CreateTeamTransferEmailNotAllowedError,
        UsageExceededError: CreateTeamTransferUsageExceededError,
        PasswordRequiredError: CreateTeamTransferPasswordRequiredError,
        ForbiddenError: CreateTeamTransferForbiddenError,
        NotFoundError: CreateTeamTransferNotFoundError,
        CustomUrlAlreadyInUseError: CreateTeamTransferCustomUrlAlreadyInUseError,
        InternalServerError: CreateTeamTransferInternalServerError,
        BadGatewayError: CreateTeamTransferBadGatewayError,
        GatewayTimeoutError: CreateTeamTransferGatewayTimeoutError,
        GenericError: CreateTeamTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTeamUserDropboxError: {
        InvalidParameterError: CreateTeamUserDropboxInvalidParameterError,
        UnauthorizedError: CreateTeamUserDropboxUnauthorizedError,
        InvalidSubscriptionError: CreateTeamUserDropboxInvalidSubscriptionError,
        ForbiddenError: CreateTeamUserDropboxForbiddenError,
        NotFoundError: CreateTeamUserDropboxNotFoundError,
        InternalServerError: CreateTeamUserDropboxInternalServerError,
        BadGatewayError: CreateTeamUserDropboxBadGatewayError,
        GatewayTimeoutError: CreateTeamUserDropboxGatewayTimeoutError,
        GenericError: CreateTeamUserDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTransferError: {
        InvalidAvailabilityDurationError: CreateTransferInvalidAvailabilityDurationError,
        InvalidParameterError: CreateTransferInvalidParameterError,
        UnauthorizedError: CreateTransferUnauthorizedError,
        InvalidSubscriptionError: CreateTransferInvalidSubscriptionError,
        EmailNotAllowedError: CreateTransferEmailNotAllowedError,
        UsageExceededError: CreateTransferUsageExceededError,
        PasswordRequiredError: CreateTransferPasswordRequiredError,
        EmailNotVerifiedError: CreateTransferEmailNotVerifiedError,
        ForbiddenError: CreateTransferForbiddenError,
        CustomUrlAlreadyInUseError: CreateTransferCustomUrlAlreadyInUseError,
        InternalServerError: CreateTransferInternalServerError,
        BadGatewayError: CreateTransferBadGatewayError,
        GatewayTimeoutError: CreateTransferGatewayTimeoutError,
        GenericError: CreateTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTransferFileError: {
        InvalidParameterError: CreateTransferFileInvalidParameterError,
        UnauthorizedError: CreateTransferFileUnauthorizedError,
        TransferAlreadyLockedError: CreateTransferFileTransferAlreadyLockedError,
        TransferIsInQueueError: CreateTransferFileTransferIsInQueueError,
        ForbiddenError: CreateTransferFileForbiddenError,
        NotFoundError: CreateTransferFileNotFoundError,
        ConflictError: CreateTransferFileConflictError,
        InternalServerError: CreateTransferFileInternalServerError,
        BadGatewayError: CreateTransferFileBadGatewayError,
        GatewayTimeoutError: CreateTransferFileGatewayTimeoutError,
        GenericError: CreateTransferFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTransferFilePartError: {
        InvalidParameterError: CreateTransferFilePartInvalidParameterError,
        UnauthorizedError: CreateTransferFilePartUnauthorizedError,
        TransferAlreadyLockedError: CreateTransferFilePartTransferAlreadyLockedError,
        FileAlreadyLockedError: CreateTransferFilePartFileAlreadyLockedError,
        ForbiddenError: CreateTransferFilePartForbiddenError,
        NotFoundError: CreateTransferFilePartNotFoundError,
        InternalServerError: CreateTransferFilePartInternalServerError,
        BadGatewayError: CreateTransferFilePartBadGatewayError,
        GatewayTimeoutError: CreateTransferFilePartGatewayTimeoutError,
        GenericError: CreateTransferFilePartGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTransferFilePartsError: {
        InvalidParameterError: CreateTransferFilePartsInvalidParameterError,
        UnauthorizedError: CreateTransferFilePartsUnauthorizedError,
        TransferAlreadyLockedError: CreateTransferFilePartsTransferAlreadyLockedError,
        FileAlreadyLockedError: CreateTransferFilePartsFileAlreadyLockedError,
        ForbiddenError: CreateTransferFilePartsForbiddenError,
        NotFoundError: CreateTransferFilePartsNotFoundError,
        InternalServerError: CreateTransferFilePartsInternalServerError,
        BadGatewayError: CreateTransferFilePartsBadGatewayError,
        GatewayTimeoutError: CreateTransferFilePartsGatewayTimeoutError,
        GenericError: CreateTransferFilePartsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateTransferSignedUrlsError: {
        InvalidParameterError: CreateTransferSignedUrlsInvalidParameterError,
        UnauthorizedError: CreateTransferSignedUrlsUnauthorizedError,
        PasswordDoesNotMatchError: CreateTransferSignedUrlsPasswordDoesNotMatchError,
        ForbiddenError: CreateTransferSignedUrlsForbiddenError,
        NotFoundError: CreateTransferSignedUrlsNotFoundError,
        InternalServerError: CreateTransferSignedUrlsInternalServerError,
        BadGatewayError: CreateTransferSignedUrlsBadGatewayError,
        GatewayTimeoutError: CreateTransferSignedUrlsGatewayTimeoutError,
        GenericError: CreateTransferSignedUrlsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    CreateUserDropboxError: {
        InvalidParameterError: CreateUserDropboxInvalidParameterError,
        UnauthorizedError: CreateUserDropboxUnauthorizedError,
        InvalidSubscriptionError: CreateUserDropboxInvalidSubscriptionError,
        ForbiddenError: CreateUserDropboxForbiddenError,
        NotFoundError: CreateUserDropboxNotFoundError,
        InternalServerError: CreateUserDropboxInternalServerError,
        BadGatewayError: CreateUserDropboxBadGatewayError,
        GatewayTimeoutError: CreateUserDropboxGatewayTimeoutError,
        GenericError: CreateUserDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteDropboxError: {
        InvalidParameterError: DeleteDropboxInvalidParameterError,
        UnauthorizedError: DeleteDropboxUnauthorizedError,
        ForbiddenError: DeleteDropboxForbiddenError,
        NotFoundError: DeleteDropboxNotFoundError,
        InternalServerError: DeleteDropboxInternalServerError,
        BadGatewayError: DeleteDropboxBadGatewayError,
        GatewayTimeoutError: DeleteDropboxGatewayTimeoutError,
        GenericError: DeleteDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteReceiptError: {
        InvalidParameterError: DeleteReceiptInvalidParameterError,
        UnauthorizedError: DeleteReceiptUnauthorizedError,
        ForbiddenError: DeleteReceiptForbiddenError,
        NotFoundError: DeleteReceiptNotFoundError,
        InternalServerError: DeleteReceiptInternalServerError,
        BadGatewayError: DeleteReceiptBadGatewayError,
        GatewayTimeoutError: DeleteReceiptGatewayTimeoutError,
        GenericError: DeleteReceiptGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteReportError: {
        InvalidParameterError: DeleteReportInvalidParameterError,
        UnauthorizedError: DeleteReportUnauthorizedError,
        TransferNotUploadedError: DeleteReportTransferNotUploadedError,
        ForbiddenError: DeleteReportForbiddenError,
        NotFoundError: DeleteReportNotFoundError,
        InternalServerError: DeleteReportInternalServerError,
        BadGatewayError: DeleteReportBadGatewayError,
        GatewayTimeoutError: DeleteReportGatewayTimeoutError,
        GenericError: DeleteReportGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteTeamDropboxError: {
        InvalidParameterError: DeleteTeamDropboxInvalidParameterError,
        UnauthorizedError: DeleteTeamDropboxUnauthorizedError,
        ForbiddenError: DeleteTeamDropboxForbiddenError,
        NotFoundError: DeleteTeamDropboxNotFoundError,
        InternalServerError: DeleteTeamDropboxInternalServerError,
        BadGatewayError: DeleteTeamDropboxBadGatewayError,
        GatewayTimeoutError: DeleteTeamDropboxGatewayTimeoutError,
        GenericError: DeleteTeamDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteTeamReceiptError: {
        InvalidParameterError: DeleteTeamReceiptInvalidParameterError,
        UnauthorizedError: DeleteTeamReceiptUnauthorizedError,
        ForbiddenError: DeleteTeamReceiptForbiddenError,
        NotFoundError: DeleteTeamReceiptNotFoundError,
        InternalServerError: DeleteTeamReceiptInternalServerError,
        BadGatewayError: DeleteTeamReceiptBadGatewayError,
        GatewayTimeoutError: DeleteTeamReceiptGatewayTimeoutError,
        GenericError: DeleteTeamReceiptGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteTeamTransferError: {
        InvalidParameterError: DeleteTeamTransferInvalidParameterError,
        UnauthorizedError: DeleteTeamTransferUnauthorizedError,
        TransferNotUploadedError: DeleteTeamTransferTransferNotUploadedError,
        ForbiddenError: DeleteTeamTransferForbiddenError,
        NotFoundError: DeleteTeamTransferNotFoundError,
        InternalServerError: DeleteTeamTransferInternalServerError,
        BadGatewayError: DeleteTeamTransferBadGatewayError,
        GatewayTimeoutError: DeleteTeamTransferGatewayTimeoutError,
        GenericError: DeleteTeamTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteTeamUserDropboxError: {
        InvalidParameterError: DeleteTeamUserDropboxInvalidParameterError,
        UnauthorizedError: DeleteTeamUserDropboxUnauthorizedError,
        ForbiddenError: DeleteTeamUserDropboxForbiddenError,
        NotFoundError: DeleteTeamUserDropboxNotFoundError,
        InternalServerError: DeleteTeamUserDropboxInternalServerError,
        BadGatewayError: DeleteTeamUserDropboxBadGatewayError,
        GatewayTimeoutError: DeleteTeamUserDropboxGatewayTimeoutError,
        GenericError: DeleteTeamUserDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteTeamUserReceiptError: {
        InvalidParameterError: DeleteTeamUserReceiptInvalidParameterError,
        UnauthorizedError: DeleteTeamUserReceiptUnauthorizedError,
        ForbiddenError: DeleteTeamUserReceiptForbiddenError,
        NotFoundError: DeleteTeamUserReceiptNotFoundError,
        InternalServerError: DeleteTeamUserReceiptInternalServerError,
        BadGatewayError: DeleteTeamUserReceiptBadGatewayError,
        GatewayTimeoutError: DeleteTeamUserReceiptGatewayTimeoutError,
        GenericError: DeleteTeamUserReceiptGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteTransferError: {
        InvalidParameterError: DeleteTransferInvalidParameterError,
        UnauthorizedError: DeleteTransferUnauthorizedError,
        TransferNotUploadedError: DeleteTransferTransferNotUploadedError,
        ForbiddenError: DeleteTransferForbiddenError,
        NotFoundError: DeleteTransferNotFoundError,
        InternalServerError: DeleteTransferInternalServerError,
        BadGatewayError: DeleteTransferBadGatewayError,
        GatewayTimeoutError: DeleteTransferGatewayTimeoutError,
        GenericError: DeleteTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteTransferFileError: {
        InvalidParameterError: DeleteTransferFileInvalidParameterError,
        UnauthorizedError: DeleteTransferFileUnauthorizedError,
        ForbiddenError: DeleteTransferFileForbiddenError,
        NotFoundError: DeleteTransferFileNotFoundError,
        InternalServerError: DeleteTransferFileInternalServerError,
        BadGatewayError: DeleteTransferFileBadGatewayError,
        GatewayTimeoutError: DeleteTransferFileGatewayTimeoutError,
        GenericError: DeleteTransferFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteUserDropboxError: {
        InvalidParameterError: DeleteUserDropboxInvalidParameterError,
        UnauthorizedError: DeleteUserDropboxUnauthorizedError,
        ForbiddenError: DeleteUserDropboxForbiddenError,
        NotFoundError: DeleteUserDropboxNotFoundError,
        InternalServerError: DeleteUserDropboxInternalServerError,
        BadGatewayError: DeleteUserDropboxBadGatewayError,
        GatewayTimeoutError: DeleteUserDropboxGatewayTimeoutError,
        GenericError: DeleteUserDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteUserReceiptError: {
        InvalidParameterError: DeleteUserReceiptInvalidParameterError,
        UnauthorizedError: DeleteUserReceiptUnauthorizedError,
        ForbiddenError: DeleteUserReceiptForbiddenError,
        NotFoundError: DeleteUserReceiptNotFoundError,
        InternalServerError: DeleteUserReceiptInternalServerError,
        BadGatewayError: DeleteUserReceiptBadGatewayError,
        GatewayTimeoutError: DeleteUserReceiptGatewayTimeoutError,
        GenericError: DeleteUserReceiptGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DeleteUserTransferError: {
        InvalidParameterError: DeleteUserTransferInvalidParameterError,
        UnauthorizedError: DeleteUserTransferUnauthorizedError,
        TransferNotUploadedError: DeleteUserTransferTransferNotUploadedError,
        ForbiddenError: DeleteUserTransferForbiddenError,
        NotFoundError: DeleteUserTransferNotFoundError,
        InternalServerError: DeleteUserTransferInternalServerError,
        BadGatewayError: DeleteUserTransferBadGatewayError,
        GatewayTimeoutError: DeleteUserTransferGatewayTimeoutError,
        GenericError: DeleteUserTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountMetricStatisticError: {
        InvalidParameterError: GetAccountMetricStatisticInvalidParameterError,
        UnauthorizedError: GetAccountMetricStatisticUnauthorizedError,
        ForbiddenError: GetAccountMetricStatisticForbiddenError,
        NotFoundError: GetAccountMetricStatisticNotFoundError,
        InternalServerError: GetAccountMetricStatisticInternalServerError,
        BadGatewayError: GetAccountMetricStatisticBadGatewayError,
        GatewayTimeoutError: GetAccountMetricStatisticGatewayTimeoutError,
        GenericError: GetAccountMetricStatisticGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountTeamMetricStatisticError: {
        InvalidParameterError: GetAccountTeamMetricStatisticInvalidParameterError,
        UnauthorizedError: GetAccountTeamMetricStatisticUnauthorizedError,
        ForbiddenError: GetAccountTeamMetricStatisticForbiddenError,
        NotFoundError: GetAccountTeamMetricStatisticNotFoundError,
        InternalServerError: GetAccountTeamMetricStatisticInternalServerError,
        BadGatewayError: GetAccountTeamMetricStatisticBadGatewayError,
        GatewayTimeoutError: GetAccountTeamMetricStatisticGatewayTimeoutError,
        GenericError: GetAccountTeamMetricStatisticGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountTeamUsageError: {
        InvalidParameterError: GetAccountTeamUsageInvalidParameterError,
        UnauthorizedError: GetAccountTeamUsageUnauthorizedError,
        ForbiddenError: GetAccountTeamUsageForbiddenError,
        InternalServerError: GetAccountTeamUsageInternalServerError,
        BadGatewayError: GetAccountTeamUsageBadGatewayError,
        GatewayTimeoutError: GetAccountTeamUsageGatewayTimeoutError,
        GenericError: GetAccountTeamUsageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountTeamUserMetricStatisticError: {
        InvalidParameterError: GetAccountTeamUserMetricStatisticInvalidParameterError,
        UnauthorizedError: GetAccountTeamUserMetricStatisticUnauthorizedError,
        ForbiddenError: GetAccountTeamUserMetricStatisticForbiddenError,
        NotFoundError: GetAccountTeamUserMetricStatisticNotFoundError,
        InternalServerError: GetAccountTeamUserMetricStatisticInternalServerError,
        BadGatewayError: GetAccountTeamUserMetricStatisticBadGatewayError,
        GatewayTimeoutError: GetAccountTeamUserMetricStatisticGatewayTimeoutError,
        GenericError: GetAccountTeamUserMetricStatisticGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountTeamUserUsageError: {
        InvalidParameterError: GetAccountTeamUserUsageInvalidParameterError,
        UnauthorizedError: GetAccountTeamUserUsageUnauthorizedError,
        ForbiddenError: GetAccountTeamUserUsageForbiddenError,
        InternalServerError: GetAccountTeamUserUsageInternalServerError,
        BadGatewayError: GetAccountTeamUserUsageBadGatewayError,
        GatewayTimeoutError: GetAccountTeamUserUsageGatewayTimeoutError,
        GenericError: GetAccountTeamUserUsageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountTransferError: {
        InvalidParameterError: GetAccountTransferInvalidParameterError,
        UnauthorizedError: GetAccountTransferUnauthorizedError,
        ForbiddenError: GetAccountTransferForbiddenError,
        NotFoundError: GetAccountTransferNotFoundError,
        InternalServerError: GetAccountTransferInternalServerError,
        BadGatewayError: GetAccountTransferBadGatewayError,
        GatewayTimeoutError: GetAccountTransferGatewayTimeoutError,
        GenericError: GetAccountTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountUsageError: {
        InvalidParameterError: GetAccountUsageInvalidParameterError,
        UnauthorizedError: GetAccountUsageUnauthorizedError,
        ForbiddenError: GetAccountUsageForbiddenError,
        InternalServerError: GetAccountUsageInternalServerError,
        BadGatewayError: GetAccountUsageBadGatewayError,
        GatewayTimeoutError: GetAccountUsageGatewayTimeoutError,
        GenericError: GetAccountUsageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountUserMetricStatisticError: {
        InvalidParameterError: GetAccountUserMetricStatisticInvalidParameterError,
        UnauthorizedError: GetAccountUserMetricStatisticUnauthorizedError,
        ForbiddenError: GetAccountUserMetricStatisticForbiddenError,
        NotFoundError: GetAccountUserMetricStatisticNotFoundError,
        InternalServerError: GetAccountUserMetricStatisticInternalServerError,
        BadGatewayError: GetAccountUserMetricStatisticBadGatewayError,
        GatewayTimeoutError: GetAccountUserMetricStatisticGatewayTimeoutError,
        GenericError: GetAccountUserMetricStatisticGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetAccountUserUsageError: {
        InvalidParameterError: GetAccountUserUsageInvalidParameterError,
        UnauthorizedError: GetAccountUserUsageUnauthorizedError,
        ForbiddenError: GetAccountUserUsageForbiddenError,
        InternalServerError: GetAccountUserUsageInternalServerError,
        BadGatewayError: GetAccountUserUsageBadGatewayError,
        GatewayTimeoutError: GetAccountUserUsageGatewayTimeoutError,
        GenericError: GetAccountUserUsageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetDropboxError: {
        InvalidParameterError: GetDropboxInvalidParameterError,
        UnauthorizedError: GetDropboxUnauthorizedError,
        ForbiddenError: GetDropboxForbiddenError,
        NotFoundError: GetDropboxNotFoundError,
        InternalServerError: GetDropboxInternalServerError,
        BadGatewayError: GetDropboxBadGatewayError,
        GatewayTimeoutError: GetDropboxGatewayTimeoutError,
        GenericError: GetDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetDropboxPreviewError: {
        InvalidParameterError: GetDropboxPreviewInvalidParameterError,
        UnauthorizedError: GetDropboxPreviewUnauthorizedError,
        PasswordDoesNotMatchError: GetDropboxPreviewPasswordDoesNotMatchError,
        InvalidSubscriptionError: GetDropboxPreviewInvalidSubscriptionError,
        OwnerUsageExceededError: GetDropboxPreviewOwnerUsageExceededError,
        DropboxDisabledError: GetDropboxPreviewDropboxDisabledError,
        DropboxDeletedError: GetDropboxPreviewDropboxDeletedError,
        DropboxMaxTransferCountError: GetDropboxPreviewDropboxMaxTransferCountError,
        DropboxMaxBytesUploadedError: GetDropboxPreviewDropboxMaxBytesUploadedError,
        ForbiddenError: GetDropboxPreviewForbiddenError,
        NotFoundError: GetDropboxPreviewNotFoundError,
        InternalServerError: GetDropboxPreviewInternalServerError,
        BadGatewayError: GetDropboxPreviewBadGatewayError,
        GatewayTimeoutError: GetDropboxPreviewGatewayTimeoutError,
        GenericError: GetDropboxPreviewGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetManualReviewError: {
        InvalidParameterError: GetManualReviewInvalidParameterError,
        UnauthorizedError: GetManualReviewUnauthorizedError,
        ForbiddenError: GetManualReviewForbiddenError,
        NotFoundError: GetManualReviewNotFoundError,
        InternalServerError: GetManualReviewInternalServerError,
        BadGatewayError: GetManualReviewBadGatewayError,
        GatewayTimeoutError: GetManualReviewGatewayTimeoutError,
        GenericError: GetManualReviewGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetMetricStatisticError: {
        InvalidParameterError: GetMetricStatisticInvalidParameterError,
        UnauthorizedError: GetMetricStatisticUnauthorizedError,
        ForbiddenError: GetMetricStatisticForbiddenError,
        InternalServerError: GetMetricStatisticInternalServerError,
        BadGatewayError: GetMetricStatisticBadGatewayError,
        GatewayTimeoutError: GetMetricStatisticGatewayTimeoutError,
        GenericError: GetMetricStatisticGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetReceiptError: {
        InvalidParameterError: GetReceiptInvalidParameterError,
        UnauthorizedError: GetReceiptUnauthorizedError,
        ForbiddenError: GetReceiptForbiddenError,
        NotFoundError: GetReceiptNotFoundError,
        InternalServerError: GetReceiptInternalServerError,
        BadGatewayError: GetReceiptBadGatewayError,
        GatewayTimeoutError: GetReceiptGatewayTimeoutError,
        GenericError: GetReceiptGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetReceiptFileError: {
        InvalidParameterError: GetReceiptFileInvalidParameterError,
        UnauthorizedError: GetReceiptFileUnauthorizedError,
        ForbiddenError: GetReceiptFileForbiddenError,
        NotFoundError: GetReceiptFileNotFoundError,
        InternalServerError: GetReceiptFileInternalServerError,
        BadGatewayError: GetReceiptFileBadGatewayError,
        GatewayTimeoutError: GetReceiptFileGatewayTimeoutError,
        GenericError: GetReceiptFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetReceiverError: {
        InvalidParameterError: GetReceiverInvalidParameterError,
        UnauthorizedError: GetReceiverUnauthorizedError,
        ForbiddenError: GetReceiverForbiddenError,
        InternalServerError: GetReceiverInternalServerError,
        BadGatewayError: GetReceiverBadGatewayError,
        GatewayTimeoutError: GetReceiverGatewayTimeoutError,
        GenericError: GetReceiverGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetReportError: {
        InvalidParameterError: GetReportInvalidParameterError,
        UnauthorizedError: GetReportUnauthorizedError,
        ForbiddenError: GetReportForbiddenError,
        NotFoundError: GetReportNotFoundError,
        InternalServerError: GetReportInternalServerError,
        BadGatewayError: GetReportBadGatewayError,
        GatewayTimeoutError: GetReportGatewayTimeoutError,
        GenericError: GetReportGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetSenderError: {
        InvalidParameterError: GetSenderInvalidParameterError,
        UnauthorizedError: GetSenderUnauthorizedError,
        ForbiddenError: GetSenderForbiddenError,
        InternalServerError: GetSenderInternalServerError,
        BadGatewayError: GetSenderBadGatewayError,
        GatewayTimeoutError: GetSenderGatewayTimeoutError,
        GenericError: GetSenderGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamDropboxError: {
        InvalidParameterError: GetTeamDropboxInvalidParameterError,
        UnauthorizedError: GetTeamDropboxUnauthorizedError,
        ForbiddenError: GetTeamDropboxForbiddenError,
        NotFoundError: GetTeamDropboxNotFoundError,
        InternalServerError: GetTeamDropboxInternalServerError,
        BadGatewayError: GetTeamDropboxBadGatewayError,
        GatewayTimeoutError: GetTeamDropboxGatewayTimeoutError,
        GenericError: GetTeamDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamMetricStatisticError: {
        InvalidParameterError: GetTeamMetricStatisticInvalidParameterError,
        UnauthorizedError: GetTeamMetricStatisticUnauthorizedError,
        ForbiddenError: GetTeamMetricStatisticForbiddenError,
        InternalServerError: GetTeamMetricStatisticInternalServerError,
        BadGatewayError: GetTeamMetricStatisticBadGatewayError,
        GatewayTimeoutError: GetTeamMetricStatisticGatewayTimeoutError,
        GenericError: GetTeamMetricStatisticGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamReceiptError: {
        InvalidParameterError: GetTeamReceiptInvalidParameterError,
        UnauthorizedError: GetTeamReceiptUnauthorizedError,
        ForbiddenError: GetTeamReceiptForbiddenError,
        NotFoundError: GetTeamReceiptNotFoundError,
        InternalServerError: GetTeamReceiptInternalServerError,
        BadGatewayError: GetTeamReceiptBadGatewayError,
        GatewayTimeoutError: GetTeamReceiptGatewayTimeoutError,
        GenericError: GetTeamReceiptGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamReceiptFileError: {
        InvalidParameterError: GetTeamReceiptFileInvalidParameterError,
        UnauthorizedError: GetTeamReceiptFileUnauthorizedError,
        ForbiddenError: GetTeamReceiptFileForbiddenError,
        NotFoundError: GetTeamReceiptFileNotFoundError,
        InternalServerError: GetTeamReceiptFileInternalServerError,
        BadGatewayError: GetTeamReceiptFileBadGatewayError,
        GatewayTimeoutError: GetTeamReceiptFileGatewayTimeoutError,
        GenericError: GetTeamReceiptFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamTransferError: {
        InvalidParameterError: GetTeamTransferInvalidParameterError,
        UnauthorizedError: GetTeamTransferUnauthorizedError,
        ForbiddenError: GetTeamTransferForbiddenError,
        NotFoundError: GetTeamTransferNotFoundError,
        InternalServerError: GetTeamTransferInternalServerError,
        BadGatewayError: GetTeamTransferBadGatewayError,
        GatewayTimeoutError: GetTeamTransferGatewayTimeoutError,
        GenericError: GetTeamTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamTransferFileError: {
        InvalidParameterError: GetTeamTransferFileInvalidParameterError,
        UnauthorizedError: GetTeamTransferFileUnauthorizedError,
        ForbiddenError: GetTeamTransferFileForbiddenError,
        NotFoundError: GetTeamTransferFileNotFoundError,
        InternalServerError: GetTeamTransferFileInternalServerError,
        BadGatewayError: GetTeamTransferFileBadGatewayError,
        GatewayTimeoutError: GetTeamTransferFileGatewayTimeoutError,
        GenericError: GetTeamTransferFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamTransferQueueError: {
        InvalidParameterError: GetTeamTransferQueueInvalidParameterError,
        UnauthorizedError: GetTeamTransferQueueUnauthorizedError,
        ForbiddenError: GetTeamTransferQueueForbiddenError,
        NotFoundError: GetTeamTransferQueueNotFoundError,
        InternalServerError: GetTeamTransferQueueInternalServerError,
        BadGatewayError: GetTeamTransferQueueBadGatewayError,
        GatewayTimeoutError: GetTeamTransferQueueGatewayTimeoutError,
        GenericError: GetTeamTransferQueueGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamUsageError: {
        InvalidParameterError: GetTeamUsageInvalidParameterError,
        UnauthorizedError: GetTeamUsageUnauthorizedError,
        ForbiddenError: GetTeamUsageForbiddenError,
        InternalServerError: GetTeamUsageInternalServerError,
        BadGatewayError: GetTeamUsageBadGatewayError,
        GatewayTimeoutError: GetTeamUsageGatewayTimeoutError,
        GenericError: GetTeamUsageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamUserDropboxError: {
        InvalidParameterError: GetTeamUserDropboxInvalidParameterError,
        UnauthorizedError: GetTeamUserDropboxUnauthorizedError,
        ForbiddenError: GetTeamUserDropboxForbiddenError,
        NotFoundError: GetTeamUserDropboxNotFoundError,
        InternalServerError: GetTeamUserDropboxInternalServerError,
        BadGatewayError: GetTeamUserDropboxBadGatewayError,
        GatewayTimeoutError: GetTeamUserDropboxGatewayTimeoutError,
        GenericError: GetTeamUserDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamUserMetricStatisticError: {
        InvalidParameterError: GetTeamUserMetricStatisticInvalidParameterError,
        UnauthorizedError: GetTeamUserMetricStatisticUnauthorizedError,
        ForbiddenError: GetTeamUserMetricStatisticForbiddenError,
        InternalServerError: GetTeamUserMetricStatisticInternalServerError,
        BadGatewayError: GetTeamUserMetricStatisticBadGatewayError,
        GatewayTimeoutError: GetTeamUserMetricStatisticGatewayTimeoutError,
        GenericError: GetTeamUserMetricStatisticGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamUserReceiptError: {
        InvalidParameterError: GetTeamUserReceiptInvalidParameterError,
        UnauthorizedError: GetTeamUserReceiptUnauthorizedError,
        ForbiddenError: GetTeamUserReceiptForbiddenError,
        NotFoundError: GetTeamUserReceiptNotFoundError,
        InternalServerError: GetTeamUserReceiptInternalServerError,
        BadGatewayError: GetTeamUserReceiptBadGatewayError,
        GatewayTimeoutError: GetTeamUserReceiptGatewayTimeoutError,
        GenericError: GetTeamUserReceiptGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamUserReceiptFileError: {
        InvalidParameterError: GetTeamUserReceiptFileInvalidParameterError,
        UnauthorizedError: GetTeamUserReceiptFileUnauthorizedError,
        ForbiddenError: GetTeamUserReceiptFileForbiddenError,
        NotFoundError: GetTeamUserReceiptFileNotFoundError,
        InternalServerError: GetTeamUserReceiptFileInternalServerError,
        BadGatewayError: GetTeamUserReceiptFileBadGatewayError,
        GatewayTimeoutError: GetTeamUserReceiptFileGatewayTimeoutError,
        GenericError: GetTeamUserReceiptFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamUserTransferError: {
        InvalidParameterError: GetTeamUserTransferInvalidParameterError,
        UnauthorizedError: GetTeamUserTransferUnauthorizedError,
        ForbiddenError: GetTeamUserTransferForbiddenError,
        NotFoundError: GetTeamUserTransferNotFoundError,
        InternalServerError: GetTeamUserTransferInternalServerError,
        BadGatewayError: GetTeamUserTransferBadGatewayError,
        GatewayTimeoutError: GetTeamUserTransferGatewayTimeoutError,
        GenericError: GetTeamUserTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTeamUserUsageError: {
        InvalidParameterError: GetTeamUserUsageInvalidParameterError,
        UnauthorizedError: GetTeamUserUsageUnauthorizedError,
        ForbiddenError: GetTeamUserUsageForbiddenError,
        InternalServerError: GetTeamUserUsageInternalServerError,
        BadGatewayError: GetTeamUserUsageBadGatewayError,
        GatewayTimeoutError: GetTeamUserUsageGatewayTimeoutError,
        GenericError: GetTeamUserUsageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTransferError: {
        InvalidParameterError: GetTransferInvalidParameterError,
        UnauthorizedError: GetTransferUnauthorizedError,
        ForbiddenError: GetTransferForbiddenError,
        NotFoundError: GetTransferNotFoundError,
        InternalServerError: GetTransferInternalServerError,
        BadGatewayError: GetTransferBadGatewayError,
        GatewayTimeoutError: GetTransferGatewayTimeoutError,
        GenericError: GetTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTransferFileError: {
        InvalidParameterError: GetTransferFileInvalidParameterError,
        UnauthorizedError: GetTransferFileUnauthorizedError,
        ForbiddenError: GetTransferFileForbiddenError,
        NotFoundError: GetTransferFileNotFoundError,
        InternalServerError: GetTransferFileInternalServerError,
        BadGatewayError: GetTransferFileBadGatewayError,
        GatewayTimeoutError: GetTransferFileGatewayTimeoutError,
        GenericError: GetTransferFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTransferFileInternalError: {
        InvalidParameterError: GetTransferFileInternalInvalidParameterError,
        UnauthorizedError: GetTransferFileInternalUnauthorizedError,
        ForbiddenError: GetTransferFileInternalForbiddenError,
        NotFoundError: GetTransferFileInternalNotFoundError,
        InternalServerError: GetTransferFileInternalInternalServerError,
        BadGatewayError: GetTransferFileInternalBadGatewayError,
        GatewayTimeoutError: GetTransferFileInternalGatewayTimeoutError,
        GenericError: GetTransferFileInternalGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTransferFilePreviewError: {
        InvalidParameterError: GetTransferFilePreviewInvalidParameterError,
        UnauthorizedError: GetTransferFilePreviewUnauthorizedError,
        PasswordDoesNotMatchError: GetTransferFilePreviewPasswordDoesNotMatchError,
        ForbiddenError: GetTransferFilePreviewForbiddenError,
        NotFoundError: GetTransferFilePreviewNotFoundError,
        InternalServerError: GetTransferFilePreviewInternalServerError,
        BadGatewayError: GetTransferFilePreviewBadGatewayError,
        GatewayTimeoutError: GetTransferFilePreviewGatewayTimeoutError,
        GenericError: GetTransferFilePreviewGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTransferInternalError: {
        InvalidParameterError: GetTransferInternalInvalidParameterError,
        UnauthorizedError: GetTransferInternalUnauthorizedError,
        ForbiddenError: GetTransferInternalForbiddenError,
        NotFoundError: GetTransferInternalNotFoundError,
        InternalServerError: GetTransferInternalInternalServerError,
        BadGatewayError: GetTransferInternalBadGatewayError,
        GatewayTimeoutError: GetTransferInternalGatewayTimeoutError,
        GenericError: GetTransferInternalGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTransferPreviewError: {
        InvalidParameterError: GetTransferPreviewInvalidParameterError,
        UnauthorizedError: GetTransferPreviewUnauthorizedError,
        PasswordDoesNotMatchError: GetTransferPreviewPasswordDoesNotMatchError,
        InvalidEmailError: GetTransferPreviewInvalidEmailError,
        OwnerUsageExceededError: GetTransferPreviewOwnerUsageExceededError,
        AccessorUsageExceededError: GetTransferPreviewAccessorUsageExceededError,
        ForbiddenError: GetTransferPreviewForbiddenError,
        NotFoundError: GetTransferPreviewNotFoundError,
        InternalServerError: GetTransferPreviewInternalServerError,
        BadGatewayError: GetTransferPreviewBadGatewayError,
        GatewayTimeoutError: GetTransferPreviewGatewayTimeoutError,
        GenericError: GetTransferPreviewGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTransferQueueError: {
        InvalidParameterError: GetTransferQueueInvalidParameterError,
        UnauthorizedError: GetTransferQueueUnauthorizedError,
        ForbiddenError: GetTransferQueueForbiddenError,
        NotFoundError: GetTransferQueueNotFoundError,
        InternalServerError: GetTransferQueueInternalServerError,
        BadGatewayError: GetTransferQueueBadGatewayError,
        GatewayTimeoutError: GetTransferQueueGatewayTimeoutError,
        GenericError: GetTransferQueueGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetTransferUserError: {
        InvalidParameterError: GetTransferUserInvalidParameterError,
        UnauthorizedError: GetTransferUserUnauthorizedError,
        ForbiddenError: GetTransferUserForbiddenError,
        NotFoundError: GetTransferUserNotFoundError,
        InternalServerError: GetTransferUserInternalServerError,
        BadGatewayError: GetTransferUserBadGatewayError,
        GatewayTimeoutError: GetTransferUserGatewayTimeoutError,
        GenericError: GetTransferUserGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUsageError: {
        UnauthorizedError: GetUsageUnauthorizedError,
        ForbiddenError: GetUsageForbiddenError,
        InternalServerError: GetUsageInternalServerError,
        BadGatewayError: GetUsageBadGatewayError,
        GatewayTimeoutError: GetUsageGatewayTimeoutError,
        GenericError: GetUsageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserDropboxError: {
        InvalidParameterError: GetUserDropboxInvalidParameterError,
        UnauthorizedError: GetUserDropboxUnauthorizedError,
        ForbiddenError: GetUserDropboxForbiddenError,
        NotFoundError: GetUserDropboxNotFoundError,
        InternalServerError: GetUserDropboxInternalServerError,
        BadGatewayError: GetUserDropboxBadGatewayError,
        GatewayTimeoutError: GetUserDropboxGatewayTimeoutError,
        GenericError: GetUserDropboxGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserMetricStatisticError: {
        InvalidParameterError: GetUserMetricStatisticInvalidParameterError,
        UnauthorizedError: GetUserMetricStatisticUnauthorizedError,
        ForbiddenError: GetUserMetricStatisticForbiddenError,
        InternalServerError: GetUserMetricStatisticInternalServerError,
        BadGatewayError: GetUserMetricStatisticBadGatewayError,
        GatewayTimeoutError: GetUserMetricStatisticGatewayTimeoutError,
        GenericError: GetUserMetricStatisticGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserReceiptError: {
        InvalidParameterError: GetUserReceiptInvalidParameterError,
        UnauthorizedError: GetUserReceiptUnauthorizedError,
        ForbiddenError: GetUserReceiptForbiddenError,
        NotFoundError: GetUserReceiptNotFoundError,
        InternalServerError: GetUserReceiptInternalServerError,
        BadGatewayError: GetUserReceiptBadGatewayError,
        GatewayTimeoutError: GetUserReceiptGatewayTimeoutError,
        GenericError: GetUserReceiptGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserReceiptFileError: {
        InvalidParameterError: GetUserReceiptFileInvalidParameterError,
        UnauthorizedError: GetUserReceiptFileUnauthorizedError,
        ForbiddenError: GetUserReceiptFileForbiddenError,
        NotFoundError: GetUserReceiptFileNotFoundError,
        InternalServerError: GetUserReceiptFileInternalServerError,
        BadGatewayError: GetUserReceiptFileBadGatewayError,
        GatewayTimeoutError: GetUserReceiptFileGatewayTimeoutError,
        GenericError: GetUserReceiptFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserTransferError: {
        InvalidParameterError: GetUserTransferInvalidParameterError,
        UnauthorizedError: GetUserTransferUnauthorizedError,
        ForbiddenError: GetUserTransferForbiddenError,
        NotFoundError: GetUserTransferNotFoundError,
        InternalServerError: GetUserTransferInternalServerError,
        BadGatewayError: GetUserTransferBadGatewayError,
        GatewayTimeoutError: GetUserTransferGatewayTimeoutError,
        GenericError: GetUserTransferGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserTransferFileError: {
        InvalidParameterError: GetUserTransferFileInvalidParameterError,
        UnauthorizedError: GetUserTransferFileUnauthorizedError,
        ForbiddenError: GetUserTransferFileForbiddenError,
        NotFoundError: GetUserTransferFileNotFoundError,
        InternalServerError: GetUserTransferFileInternalServerError,
        BadGatewayError: GetUserTransferFileBadGatewayError,
        GatewayTimeoutError: GetUserTransferFileGatewayTimeoutError,
        GenericError: GetUserTransferFileGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    GetUserUsageError: {
        InvalidParameterError: GetUserUsageInvalidParameterError,
        UnauthorizedError: GetUserUsageUnauthorizedError,
        ForbiddenError: GetUserUsageForbiddenError,
        InternalServerError: GetUserUsageInternalServerError,
        BadGatewayError: GetUserUsageBadGatewayError,
        GatewayTimeoutError: GetUserUsageGatewayTimeoutError,
        GenericError: GetUserUsageGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListAccountTransfersError: {
        InvalidParameterError: ListAccountTransfersInvalidParameterError,
        UnauthorizedError: ListAccountTransfersUnauthorizedError,
        ForbiddenError: ListAccountTransfersForbiddenError,
        InternalServerError: ListAccountTransfersInternalServerError,
        BadGatewayError: ListAccountTransfersBadGatewayError,
        GatewayTimeoutError: ListAccountTransfersGatewayTimeoutError,
        GenericError: ListAccountTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListDayEventsError: {
        InvalidParameterError: ListDayEventsInvalidParameterError,
        UnauthorizedError: ListDayEventsUnauthorizedError,
        ForbiddenError: ListDayEventsForbiddenError,
        InternalServerError: ListDayEventsInternalServerError,
        BadGatewayError: ListDayEventsBadGatewayError,
        GatewayTimeoutError: ListDayEventsGatewayTimeoutError,
        GenericError: ListDayEventsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListDayFilesError: {
        InvalidParameterError: ListDayFilesInvalidParameterError,
        UnauthorizedError: ListDayFilesUnauthorizedError,
        ForbiddenError: ListDayFilesForbiddenError,
        InternalServerError: ListDayFilesInternalServerError,
        BadGatewayError: ListDayFilesBadGatewayError,
        GatewayTimeoutError: ListDayFilesGatewayTimeoutError,
        GenericError: ListDayFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListDayTransfersError: {
        InvalidParameterError: ListDayTransfersInvalidParameterError,
        UnauthorizedError: ListDayTransfersUnauthorizedError,
        ForbiddenError: ListDayTransfersForbiddenError,
        InternalServerError: ListDayTransfersInternalServerError,
        BadGatewayError: ListDayTransfersBadGatewayError,
        GatewayTimeoutError: ListDayTransfersGatewayTimeoutError,
        GenericError: ListDayTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListDropboxesError: {
        InvalidParameterError: ListDropboxesInvalidParameterError,
        UnauthorizedError: ListDropboxesUnauthorizedError,
        ForbiddenError: ListDropboxesForbiddenError,
        InternalServerError: ListDropboxesInternalServerError,
        BadGatewayError: ListDropboxesBadGatewayError,
        GatewayTimeoutError: ListDropboxesGatewayTimeoutError,
        GenericError: ListDropboxesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListHourEventsError: {
        InvalidParameterError: ListHourEventsInvalidParameterError,
        UnauthorizedError: ListHourEventsUnauthorizedError,
        ForbiddenError: ListHourEventsForbiddenError,
        InternalServerError: ListHourEventsInternalServerError,
        BadGatewayError: ListHourEventsBadGatewayError,
        GatewayTimeoutError: ListHourEventsGatewayTimeoutError,
        GenericError: ListHourEventsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListHourFilesError: {
        InvalidParameterError: ListHourFilesInvalidParameterError,
        UnauthorizedError: ListHourFilesUnauthorizedError,
        ForbiddenError: ListHourFilesForbiddenError,
        InternalServerError: ListHourFilesInternalServerError,
        BadGatewayError: ListHourFilesBadGatewayError,
        GatewayTimeoutError: ListHourFilesGatewayTimeoutError,
        GenericError: ListHourFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListHourTransfersError: {
        InvalidParameterError: ListHourTransfersInvalidParameterError,
        UnauthorizedError: ListHourTransfersUnauthorizedError,
        ForbiddenError: ListHourTransfersForbiddenError,
        InternalServerError: ListHourTransfersInternalServerError,
        BadGatewayError: ListHourTransfersBadGatewayError,
        GatewayTimeoutError: ListHourTransfersGatewayTimeoutError,
        GenericError: ListHourTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListManualReviewsError: {
        UnauthorizedError: ListManualReviewsUnauthorizedError,
        ForbiddenError: ListManualReviewsForbiddenError,
        InternalServerError: ListManualReviewsInternalServerError,
        BadGatewayError: ListManualReviewsBadGatewayError,
        GatewayTimeoutError: ListManualReviewsGatewayTimeoutError,
        GenericError: ListManualReviewsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListMonthEventsError: {
        InvalidParameterError: ListMonthEventsInvalidParameterError,
        UnauthorizedError: ListMonthEventsUnauthorizedError,
        ForbiddenError: ListMonthEventsForbiddenError,
        InternalServerError: ListMonthEventsInternalServerError,
        BadGatewayError: ListMonthEventsBadGatewayError,
        GatewayTimeoutError: ListMonthEventsGatewayTimeoutError,
        GenericError: ListMonthEventsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListMonthFilesError: {
        InvalidParameterError: ListMonthFilesInvalidParameterError,
        UnauthorizedError: ListMonthFilesUnauthorizedError,
        ForbiddenError: ListMonthFilesForbiddenError,
        InternalServerError: ListMonthFilesInternalServerError,
        BadGatewayError: ListMonthFilesBadGatewayError,
        GatewayTimeoutError: ListMonthFilesGatewayTimeoutError,
        GenericError: ListMonthFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListMonthTransfersError: {
        InvalidParameterError: ListMonthTransfersInvalidParameterError,
        UnauthorizedError: ListMonthTransfersUnauthorizedError,
        ForbiddenError: ListMonthTransfersForbiddenError,
        InternalServerError: ListMonthTransfersInternalServerError,
        BadGatewayError: ListMonthTransfersBadGatewayError,
        GatewayTimeoutError: ListMonthTransfersGatewayTimeoutError,
        GenericError: ListMonthTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListReceiptFilesError: {
        InvalidParameterError: ListReceiptFilesInvalidParameterError,
        UnauthorizedError: ListReceiptFilesUnauthorizedError,
        ForbiddenError: ListReceiptFilesForbiddenError,
        NotFoundError: ListReceiptFilesNotFoundError,
        InternalServerError: ListReceiptFilesInternalServerError,
        BadGatewayError: ListReceiptFilesBadGatewayError,
        GatewayTimeoutError: ListReceiptFilesGatewayTimeoutError,
        GenericError: ListReceiptFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListReceiptsError: {
        InvalidParameterError: ListReceiptsInvalidParameterError,
        UnauthorizedError: ListReceiptsUnauthorizedError,
        ForbiddenError: ListReceiptsForbiddenError,
        InternalServerError: ListReceiptsInternalServerError,
        BadGatewayError: ListReceiptsBadGatewayError,
        GatewayTimeoutError: ListReceiptsGatewayTimeoutError,
        GenericError: ListReceiptsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListReceiverTransfersError: {
        InvalidParameterError: ListReceiverTransfersInvalidParameterError,
        UnauthorizedError: ListReceiverTransfersUnauthorizedError,
        ForbiddenError: ListReceiverTransfersForbiddenError,
        NotFoundError: ListReceiverTransfersNotFoundError,
        InternalServerError: ListReceiverTransfersInternalServerError,
        BadGatewayError: ListReceiverTransfersBadGatewayError,
        GatewayTimeoutError: ListReceiverTransfersGatewayTimeoutError,
        GenericError: ListReceiverTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListSenderTransfersError: {
        InvalidParameterError: ListSenderTransfersInvalidParameterError,
        UnauthorizedError: ListSenderTransfersUnauthorizedError,
        ForbiddenError: ListSenderTransfersForbiddenError,
        InternalServerError: ListSenderTransfersInternalServerError,
        BadGatewayError: ListSenderTransfersBadGatewayError,
        GatewayTimeoutError: ListSenderTransfersGatewayTimeoutError,
        GenericError: ListSenderTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamDropboxesError: {
        InvalidParameterError: ListTeamDropboxesInvalidParameterError,
        UnauthorizedError: ListTeamDropboxesUnauthorizedError,
        ForbiddenError: ListTeamDropboxesForbiddenError,
        InternalServerError: ListTeamDropboxesInternalServerError,
        BadGatewayError: ListTeamDropboxesBadGatewayError,
        GatewayTimeoutError: ListTeamDropboxesGatewayTimeoutError,
        GenericError: ListTeamDropboxesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamReceiptFilesError: {
        InvalidParameterError: ListTeamReceiptFilesInvalidParameterError,
        UnauthorizedError: ListTeamReceiptFilesUnauthorizedError,
        ForbiddenError: ListTeamReceiptFilesForbiddenError,
        NotFoundError: ListTeamReceiptFilesNotFoundError,
        InternalServerError: ListTeamReceiptFilesInternalServerError,
        BadGatewayError: ListTeamReceiptFilesBadGatewayError,
        GatewayTimeoutError: ListTeamReceiptFilesGatewayTimeoutError,
        GenericError: ListTeamReceiptFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamReceiptsError: {
        InvalidParameterError: ListTeamReceiptsInvalidParameterError,
        UnauthorizedError: ListTeamReceiptsUnauthorizedError,
        ForbiddenError: ListTeamReceiptsForbiddenError,
        InternalServerError: ListTeamReceiptsInternalServerError,
        BadGatewayError: ListTeamReceiptsBadGatewayError,
        GatewayTimeoutError: ListTeamReceiptsGatewayTimeoutError,
        GenericError: ListTeamReceiptsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamTransferEventsError: {
        InvalidParameterError: ListTeamTransferEventsInvalidParameterError,
        UnauthorizedError: ListTeamTransferEventsUnauthorizedError,
        ForbiddenError: ListTeamTransferEventsForbiddenError,
        NotFoundError: ListTeamTransferEventsNotFoundError,
        InternalServerError: ListTeamTransferEventsInternalServerError,
        BadGatewayError: ListTeamTransferEventsBadGatewayError,
        GatewayTimeoutError: ListTeamTransferEventsGatewayTimeoutError,
        GenericError: ListTeamTransferEventsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamTransferFilesError: {
        InvalidParameterError: ListTeamTransferFilesInvalidParameterError,
        UnauthorizedError: ListTeamTransferFilesUnauthorizedError,
        ForbiddenError: ListTeamTransferFilesForbiddenError,
        NotFoundError: ListTeamTransferFilesNotFoundError,
        InternalServerError: ListTeamTransferFilesInternalServerError,
        BadGatewayError: ListTeamTransferFilesBadGatewayError,
        GatewayTimeoutError: ListTeamTransferFilesGatewayTimeoutError,
        GenericError: ListTeamTransferFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamTransfersError: {
        InvalidParameterError: ListTeamTransfersInvalidParameterError,
        UnauthorizedError: ListTeamTransfersUnauthorizedError,
        ForbiddenError: ListTeamTransfersForbiddenError,
        NotFoundError: ListTeamTransfersNotFoundError,
        InternalServerError: ListTeamTransfersInternalServerError,
        BadGatewayError: ListTeamTransfersBadGatewayError,
        GatewayTimeoutError: ListTeamTransfersGatewayTimeoutError,
        GenericError: ListTeamTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamUserDropboxesError: {
        InvalidParameterError: ListTeamUserDropboxesInvalidParameterError,
        UnauthorizedError: ListTeamUserDropboxesUnauthorizedError,
        ForbiddenError: ListTeamUserDropboxesForbiddenError,
        InternalServerError: ListTeamUserDropboxesInternalServerError,
        BadGatewayError: ListTeamUserDropboxesBadGatewayError,
        GatewayTimeoutError: ListTeamUserDropboxesGatewayTimeoutError,
        GenericError: ListTeamUserDropboxesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamUserReceiptFilesError: {
        InvalidParameterError: ListTeamUserReceiptFilesInvalidParameterError,
        UnauthorizedError: ListTeamUserReceiptFilesUnauthorizedError,
        ForbiddenError: ListTeamUserReceiptFilesForbiddenError,
        NotFoundError: ListTeamUserReceiptFilesNotFoundError,
        InternalServerError: ListTeamUserReceiptFilesInternalServerError,
        BadGatewayError: ListTeamUserReceiptFilesBadGatewayError,
        GatewayTimeoutError: ListTeamUserReceiptFilesGatewayTimeoutError,
        GenericError: ListTeamUserReceiptFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamUserReceiptsError: {
        InvalidParameterError: ListTeamUserReceiptsInvalidParameterError,
        UnauthorizedError: ListTeamUserReceiptsUnauthorizedError,
        ForbiddenError: ListTeamUserReceiptsForbiddenError,
        InternalServerError: ListTeamUserReceiptsInternalServerError,
        BadGatewayError: ListTeamUserReceiptsBadGatewayError,
        GatewayTimeoutError: ListTeamUserReceiptsGatewayTimeoutError,
        GenericError: ListTeamUserReceiptsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTeamUserTransfersError: {
        InvalidParameterError: ListTeamUserTransfersInvalidParameterError,
        UnauthorizedError: ListTeamUserTransfersUnauthorizedError,
        ForbiddenError: ListTeamUserTransfersForbiddenError,
        InternalServerError: ListTeamUserTransfersInternalServerError,
        BadGatewayError: ListTeamUserTransfersBadGatewayError,
        GatewayTimeoutError: ListTeamUserTransfersGatewayTimeoutError,
        GenericError: ListTeamUserTransfersGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTransferEventsError: {
        InvalidParameterError: ListTransferEventsInvalidParameterError,
        UnauthorizedError: ListTransferEventsUnauthorizedError,
        ForbiddenError: ListTransferEventsForbiddenError,
        NotFoundError: ListTransferEventsNotFoundError,
        InternalServerError: ListTransferEventsInternalServerError,
        BadGatewayError: ListTransferEventsBadGatewayError,
        GatewayTimeoutError: ListTransferEventsGatewayTimeoutError,
        GenericError: ListTransferEventsGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    ListTransferFilesError: {
        InvalidParameterError: ListTransferFilesInvalidParameterError,
        UnauthorizedError: ListTransferFilesUnauthorizedError,
        ForbiddenError: ListTransferFilesForbiddenError,
        NotFoundError: ListTransferFilesNotFoundError,
        InternalServerError: ListTransferFilesInternalServerError,
        BadGatewayError: ListTransferFilesBadGatewayError,
        GatewayTimeoutError: ListTransferFilesGatewayTimeoutError,
        GenericError: ListTransferFilesGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    DownloadError: {
        BadRequestError: DownloadBadRequestError,
        UnauthorizedError: DownloadUnauthorizedError,
        FobiddenError: DownloadFobiddenError,
        NotFoundError: DownloadNotFoundError,
        InternalServerError: DownloadInternalServerError,
        BadGatewayError: DownloadBadGatewayError,
        GatewayTimeoutError: DownloadGatewayTimeoutError,
        GenericError: DownloadGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    UploadTransferFilePartError: {
        BadRequestError: UploadTransferFilePartBadRequestError,
        InternalServerError: UploadTransferFilePartInternalServerError,
        NotFoundError: UploadTransferFilePartNotFoundError,
        NoSuchUploadError: UploadTransferFilePartNoSuchUploadError,
        AccessControlListNotSupportedError: UploadTransferFilePartAccessControlListNotSupportedError,
        AccessDeniedError: UploadTransferFilePartAccessDeniedError,
        AccessPointAlreadyOwnedByYouError: UploadTransferFilePartAccessPointAlreadyOwnedByYouError,
        AccountProblemError: UploadTransferFilePartAccountProblemError,
        AllAccessDisabledError: UploadTransferFilePartAllAccessDisabledError,
        AmbiguousGrantByEmailAddressError: UploadTransferFilePartAmbiguousGrantByEmailAddressError,
        AuthorizationHeaderMalformedError: UploadTransferFilePartAuthorizationHeaderMalformedError,
        BadDigestError: UploadTransferFilePartBadDigestError,
        EntityTooSmallError: UploadTransferFilePartEntityTooSmallError,
        EntityTooLargeError: UploadTransferFilePartEntityTooLargeError,
        ExpiredTokenError: UploadTransferFilePartExpiredTokenError,
        IllegalLocationConstraintExceptionError: UploadTransferFilePartIllegalLocationConstraintExceptionError,
        IllegalVersioningConfigurationExceptionError: UploadTransferFilePartIllegalVersioningConfigurationExceptionError,
        IncompleteBodyError: UploadTransferFilePartIncompleteBodyError,
        InlineDataTooLargeError: UploadTransferFilePartInlineDataTooLargeError,
        InternalError: UploadTransferFilePartInternalError,
        InvalidAccessKeyIdError: UploadTransferFilePartInvalidAccessKeyIdError,
        InvalidArgumentError: UploadTransferFilePartInvalidArgumentError,
        InvalidBucketNameError: UploadTransferFilePartInvalidBucketNameError,
        InvalidBucketStateError: UploadTransferFilePartInvalidBucketStateError,
        InvalidDigestError: UploadTransferFilePartInvalidDigestError,
        InvalidLocationConstraintError: UploadTransferFilePartInvalidLocationConstraintError,
        InvalidObjectStateError: UploadTransferFilePartInvalidObjectStateError,
        InvalidPartError: UploadTransferFilePartInvalidPartError,
        InvalidPartOrderError: UploadTransferFilePartInvalidPartOrderError,
        InvalidPayerError: UploadTransferFilePartInvalidPayerError,
        InvalidPolicyDocumentError: UploadTransferFilePartInvalidPolicyDocumentError,
        InvalidRangeError: UploadTransferFilePartInvalidRangeError,
        InvalidRequestError: UploadTransferFilePartInvalidRequestError,
        InvalidSecurityError: UploadTransferFilePartInvalidSecurityError,
        InvalidTokenError: UploadTransferFilePartInvalidTokenError,
        InvalidURIError: UploadTransferFilePartInvalidURIError,
        KeyTooLongError: UploadTransferFilePartKeyTooLongError,
        MaxMessageLengthExceededError: UploadTransferFilePartMaxMessageLengthExceededError,
        MetadataTooLargeError: UploadTransferFilePartMetadataTooLargeError,
        MissingContentLengthError: UploadTransferFilePartMissingContentLengthError,
        MissingRequestBodyError: UploadTransferFilePartMissingRequestBodyError,
        MissingSecurityHeaderError: UploadTransferFilePartMissingSecurityHeaderError,
        NoSuchBucketError: UploadTransferFilePartNoSuchBucketError,
        NoSuchBucketPolicyError: UploadTransferFilePartNoSuchBucketPolicyError,
        NoSuchCORSConfigurationError: UploadTransferFilePartNoSuchCORSConfigurationError,
        NoSuchKeyError: UploadTransferFilePartNoSuchKeyError,
        NotImplementedError: UploadTransferFilePartNotImplementedError,
        RequestHeaderSectionTooLargeError: UploadTransferFilePartRequestHeaderSectionTooLargeError,
        RequestTimeoutError: UploadTransferFilePartRequestTimeoutError,
        RequestTimeTooSkewedError: UploadTransferFilePartRequestTimeTooSkewedError,
        ServerSideEncryptionConfigurationNotFoundError: UploadTransferFilePartServerSideEncryptionConfigurationNotFoundError,
        ServiceUnavailableError: UploadTransferFilePartServiceUnavailableError,
        SignatureDoesNotMatchError: UploadTransferFilePartSignatureDoesNotMatchError,
        SlowDownError: UploadTransferFilePartSlowDownError,
        TokenRefreshRequiredError: UploadTransferFilePartTokenRefreshRequiredError,
        UnexpectedContentError: UploadTransferFilePartUnexpectedContentError,
        UserKeyMustBeSpecifiedError: UploadTransferFilePartUserKeyMustBeSpecifiedError,
        EtagIsMissingError: UploadTransferFilePartEtagIsMissingError,
        AuthorizationQueryParametersError: UploadTransferFilePartAuthorizationQueryParametersError,
        ConditionalRequestConflictError: UploadTransferFilePartConditionalRequestConflictError,
        EndpointNotFoundError: UploadTransferFilePartEndpointNotFoundError,
        IncorrectEndpointError: UploadTransferFilePartIncorrectEndpointError,
        InvalidAccessPointError: UploadTransferFilePartInvalidAccessPointError,
        InvalidAccessPointAliasError: UploadTransferFilePartInvalidAccessPointAliasError,
        InvalidAddressingHeaderError: UploadTransferFilePartInvalidAddressingHeaderError,
        InvalidEncryptionAlgorithmError: UploadTransferFilePartInvalidEncryptionAlgorithmError,
        InvalidHostHeaderError: UploadTransferFilePartInvalidHostHeaderError,
        InvalidSessionExceptionError: UploadTransferFilePartInvalidSessionExceptionError,
        InvalidSignatureError: UploadTransferFilePartInvalidSignatureError,
        InvalidStorageClassError: UploadTransferFilePartInvalidStorageClassError,
        MissingAuthenticationTokenError: UploadTransferFilePartMissingAuthenticationTokenError,
        TokenCodeInvalidError: UploadTransferFilePartTokenCodeInvalidError,
        UnauthorizedAccessError: UploadTransferFilePartUnauthorizedAccessError,
        UnexpectedIPError: UploadTransferFilePartUnexpectedIPError,
        UnsupportedArgumentError: UploadTransferFilePartUnsupportedArgumentError,
        UnsupportedSignatureError: UploadTransferFilePartUnsupportedSignatureError,
        NoSuchAccessPointError: UploadTransferFilePartNoSuchAccessPointError,
        GenericError: UploadTransferFilePartGenericError,
        UnknownError,
        NetworkError,
        ConnectionAbortedError,
        TimeoutError,
    },
    InvalidSdkConfigurationError,
    InvalidRegionOrHostError,
    InvalidRegionError,
    InvalidHostError,
};
